/* eslint-disable operator-linebreak */
/* eslint-disable @typescript-eslint/quotes */
/* eslint-disable @typescript-eslint/indent */

import { isNull, isUndefined } from 'lodash';

const partnerGlobalConfigLocal = JSON.parse(
  window.localStorage.getItem('partner_settings')
);
let primaryColor =
  process.env.REACT_APP_PLATFORM_DEFAULT_PRIMARY_COLOR || '#006699';

if (
  !isNull(partnerGlobalConfigLocal) &&
  !isUndefined(partnerGlobalConfigLocal)
) {
  primaryColor = partnerGlobalConfigLocal?.color_schema?.primary;
}

export const en = {
         login_sign_in: 'Sign In',
         login_email_address: 'Email address',
         login_form_password_label: 'Password',
         login_forget_password: 'Forgot password',
         login_credentials_error: 'Please check your email and password',
         login_api_error: 'Internal login API Alarm',
         internal_server_error: 'Internal Server Alarm',
         /* Forget Password */
         forget_password_title: 'Forgot password',
         forget_password_email_address: 'Email address',
         forget_password_button: 'Send Reset Password Link',
         forget_password_login: 'Return',
         forgot_password_form_success:
           'Password reset email is forwarded. Please check your inbox. The email might be in your spam.',
         forgot_password_subject: 'Fortes Data Management  - Forgot Password',
         temporary_password_subject:
           'Fortes Data Management - New Account Created',
         forgot_password_required_form_error: 'Email is required',
         forgot_password_valid_form_error: 'Must be a valid email',
         /* END Forget Password */
         /** Reset Password */
         reset_password_title: 'Reset password',
         reset_password_new_password: 'New password',
         reset_password_confirm_password: 'Confirm password',
         reset_password_new_password_required_form_error:
           'New password is required',
         reset_password_confirm_password_required_form_error:
           'Confirm password is required',
         reset_password_passwords_not_matching: "Passwords don't match",
         reset_password_new_password_form_error:
           'Password must contain at least 8 characters with at least one uppercase letter, at least one number and at least one special character.',
         reset_password_button: 'Reset password',
         reset_password_form_success:
           'Your password is is updated successfully.',
         /** End Reset Password */
         /* DASHBOARD */
         dashboard_title: 'Dashboard',
         dashboard_amount_of_devices: 'AMOUNT OF DEVICES',
         dashboard_amount_of_devices_week: 'AMOUNT OF DEVICES LAST WEEK',
         dashboard_amount_of_devices_error: 'AMOUNT OF DEVICES WITH ALARMS',
         dashboard_temperature: 'RETURN  TEMPERATURE IN CELCIUS',
         dashboard_device_status: 'Device overview',
         dashboard_routing_temperature: 'Temperatures all devices',
         dashboard_routing_temperature_hr: 'Hr',
         dashboard_error_devices: 'Devices with Active Alarms:',
         dashboard_error: 'ALARM',
         dashboard_online: 'ONLINE',
         dashboard_offline: 'OFFLINE',
         'dashboard organic': 'Organic',
         'dashboard referal': 'Referral',
         dashboard_see_all: 'SEE ALL',
         /* END DASHBOARD */
         /* Sidebar */
         date_range: 'Date Range',
         sidebar_dashboard: 'Dashboard',
         sidebar_clients_overview: 'Client management',
         sidebar_clients: 'Clients',
         sidebar_service_clients: 'Service clients',
         sidebar_devices_overview: 'Device management',
         sidebar_devices: 'Device overview',
         sidebar_projects: 'Project overview',
         sidebar_presets: 'Presets',
         sidebar_fortes_users: 'Admins',
         sidebar_fortes_settings: 'Settings',
         sidebar_audit: 'Audit',
         sidebar_reports: 'Reports',
         sidebar_total_devices: 'Devices - Total',
         sidebar_online_devices: 'Devices - Online',
         sidebar_offline_devices: 'Devices - Offline',
         sidebar_error_devices: 'Devices - Alarm',
         sidebar_change_logs: 'Change Logs',
         sidebar_version_title: 'Version',
         image_upload_success: 'Image is updated successfully!',
         image_upload_file_type_error: 'Only JPEG and PNG files are allowed.',
         image_upload_file_size_error: 'File size should be less than 5 MB.',
         image_uploading_text: 'Uploading...',
         /* END Sidebar */
         /* Navbar */
         navbar_search: 'Search',
         navbar_notification: 'Notification',
         navbar_no_notification: 'There are no notifications',
         navbar_profile: 'Profile',
         navbar_setting: 'Account settings',
         navbar_logout: 'Logout',
         /* END Navbar */
         active_label: 'ACTIVE',
         deactive_label: 'INACTIVE',
         please_fix_form_errors: 'Please fix form errors',
         /* Clients */
         clients: 'Clients',
         clients_all: 'ALL',
         clients_active: 'ACTIVE',
         clients_inactive: 'INACTIVE',
         clients_add_new: 'Add new client',
         clients_filter_search: 'Search client',
         clients_sort_by_filter_label: 'Sort by',
         clients_sort_by_value_1: 'Date(newest)',
         clients_sort_by_value_2: 'Date(oldest)',
         clients_sort_by_value_3: 'Alphabetical',
         clients_country_filter_label: 'Country',
         clients_filter_reset_button: 'Reset',
         clients_filter_delete_button: 'Deactivate',
         clients_table_name: 'Name',
         clients_table_country: 'Country',
         clients_table_devices: 'Devices',
         clients_table_added: 'Creation date',
         clients_table_status: 'Status',
         clients_table_row_per_page: 'Rows per page',
         clients_bread_crumb_main_title: 'Clients',
         add_clients_bread_crumb_first_link: 'Add Client',
         add_clients_form_header: 'Add Client',
         edit_clients_bread_crumb_first_link: 'Edit Client',
         edit_clients_form_header: 'Edit Client',
         clients_form_client_name_field: 'Name',
         clients_form_email_field: 'Email address',
         clients_form_user_field: 'Client Contact',
         clients_form_city_field: 'City',
         clients_form_country_field: 'Country',
         clients_form_client_kong_role_field: 'kong Role',
         clients_form_client_kong_role_member_label: 'Member',
         clients_form_client_kong_role_admin_label: 'Admin',
         clients_form_allow_customization_field: 'Allow white-labeling',
         clients_form_add_client_button: 'Add client',
         clients_form_edit_client_button: 'Save changes',
         clients_form_cancel_button: 'Cancel',
         clients_form_submitting_client_button: 'Submitting...',
         clients_name_required_form_error: 'Name is required',
         clients_email_required_form_error: 'Email address is required',
         clients_api_kong_role_required_form_error: 'kong role is required',
         clients_email_valid_form_error: 'Must be a valid email address',
         clients_city_required_form_error: 'City is required',
         clients_country_required_form_error: 'Country is required',
         clients_add_form_success: 'Client created successfully!',
         clients_edit_form_success: 'Client is updated successfully!',
         clients_form_api_error: 'Internal Client - API Server Alarm',
         clients_form_email_error: 'Email already exists',
         clients_no_record_found: 'No clients found',
         client_deactivated_message: 'Client is deactivated successfully',
         client_activated_message: 'Client is activated successfully',
         clients_bulk_no_user_is_selected_error_message:
           'Please select multiple records to deactivate',
         clients_bulk_deactivated_message:
           '{{ USERS_COUNT }} Clients are deactivated successfully',
         client_single_stats_table_title: 'Status',
         /* END Clients */
         client_single_first_bread_crumb: 'Clients',
         client_single_second_bread_crumb: 'View Client',
         client_single_country_label: 'Country',
         client_single_devices_label: 'Devices',
         client_single_edit_button: 'Edit',
         client_single_users_tab: 'Users',
         client_single_apis_tab: 'API Keys',
         client_single_customization_tab: 'White label',
         client_single_customization_tab_logo: 'Logo',
         client_single_customization_tab_primary_color: 'Primary color',
         client_single_customization_tab_secondary_color: 'Secondary color',
         client_single_customization_tab_submit_button: 'Save changes',
         client_single_customization_color_schema_success:
           'White-label is updated successfully.',
         client_single_filter_search: 'Search',
         client_single_add_new_user_button: 'Add user',
         client_single_add_new_api_key_button: 'Add API key',
         client_single_role_id_filter: 'Role',
         client_single_users_search: 'Search',
         client_single_filter_reset_button: 'Reset',
         client_single_users_all: 'ALL',
         client_single_users_active: 'ACTIVE',
         client_single_users_inactive: 'INACTIVE',
         client_single_filter_delete_button: 'Deactivate',
         client_single_users_table_name: 'Name',
         client_single_users_table_address: 'Address',
         client_single_users_table_role_id: 'Role',
         client_single_users_table_status: 'Status',
         client_single_users_table_added: 'Creation date',
         client_single_users_table_no_record_found: 'No record found',
         client_single_table_row_per_page: 'Rows per page',
         client_single_stats_online_devices_label: 'Online devices',
         client_single_stats_error_devices_label: 'Alarm devices',
         client_single_no_user_selected_for_de_activation_message:
           'Please select a record to deactivate',
         /* END Clients Single */
         /* Service Clients */
         service_clients: 'Service Clients',
         service_clients_all: 'ALL',
         service_clients_active: 'ACTIVE',
         service_clients_inactive: 'INACTIVE',
         service_clients_add_new: 'Add new',
         service_clients_filter_search: 'Search',
         service_clients_sort_by_filter_label: 'Sort by',
         service_clients_sort_by_value_1: 'Date(newest)',
         service_clients_sort_by_value_2: 'Date(oldest)',
         service_clients_sort_by_value_3: 'Alphabetical',
         service_clients_country_filter_label: 'Country',
         service_clients_filter_reset_button: 'Reset',
         service_clients_filter_delete_button: 'Deactivate',
         service_clients_table_name: 'Name',
         service_clients_table_country: 'Country',
         service_clients_table_devices: 'Devices',
         service_clients_table_added: 'Creation date',
         service_clients_table_status: 'Status',
         service_clients_table_row_per_page: 'Rows per page',
         service_clients_bread_crumb_main_title: 'Service Clients',
         add_service_clients_bread_crumb_first_link: 'Add Service Client',
         add_service_clients_form_header: 'Add Service Client',
         edit_service_clients_bread_crumb_first_link: 'Edit Service Client',
         edit_service_clients_form_header: 'Edit Service Client',
         service_clients_form_service_client_name_field: 'Name',
         service_clients_form_email_field: 'Email address',
         service_clients_form_client_field: 'Client',
         service_clients_form_user_field: 'Client Contact',
         service_clients_form_city_field: 'City',
         service_clients_form_country_field: 'Country',
         service_clients_form_add_service_client_button: 'Add Service Client',
         service_clients_form_edit_service_client_button: 'Save changes',
         service_clients_form_cancel_button: 'Cancel',
         service_clients_form_submitting_service_client_button: 'Submitting...',
         service_clients_name_required_form_error: 'Name is required',
         service_clients_email_required_form_error: 'Email is required',
         service_clients_focal_user_id_required_form_error:
           'Main User is required',
         service_clients_email_valid_form_error:
           'Must be a valid email address',
         service_clients_city_required_form_error: 'City is required',
         service_clients_client_required_form_error: 'Client is required',
         service_clients_country_required_form_error: 'Country is required',
         service_clients_add_form_success:
           'Service Client created successfully!',
         service_clients_edit_form_success:
           'Service Client is updated successfully!',
         service_clients_form_api_error:
           'Internal Service Client - API Server Alarm',
         service_clients_form_email_error: 'Email already exists',
         service_clients_no_record_found: 'No Service Clients found',
         service_client_deactivated_message:
           'Service Client is deactivated successfully',
         service_client_activated_message:
           'Service Client is activated successfully',
         service_clients_bulk_no_user_is_selected_error_message:
           'Please select records to deactivate',
         service_clients_bulk_deactivated_message:
           '{{ USERS_COUNT }} Service Client(s) are deactivated successfully',
         service_client_single_stats_table_title: 'Status',
         /* END Service Clients */
         service_client_single_first_bread_crumb: 'Service Clients',
         service_client_single_second_bread_crumb: 'View Service Client',
         service_client_single_country_label: 'Country',
         service_client_single_devices_label: 'Devices',
         service_client_single_edit_button: 'Edit',
         service_client_single_users_tab: 'Users',
         service_client_single_apis_tab: 'API Keys',
         service_client_single_filter_search: 'Search',
         service_client_single_add_new_user_button: 'Add user',
         service_client_single_add_new_api_key_button: 'Add API key',
         service_client_single_role_id_filter: 'Role',
         service_client_single_users_search: 'Search',
         service_client_single_filter_reset_button: 'Reset',
         service_client_single_users_all: 'ALL',
         service_client_single_users_active: 'ACTIVE',
         service_client_single_users_inactive: 'INACTIVE',
         service_client_single_filter_delete_button: 'Deactivate',
         service_client_single_users_table_name: 'Name',
         service_client_single_users_table_address: 'Address',
         service_client_single_users_table_role_id: 'Role',
         service_client_single_users_table_status: 'Status',
         service_client_single_users_table_added: 'Creation date',
         service_client_single_users_table_no_record_found: 'No record found',
         service_client_single_table_row_per_page: 'Rows per page',
         service_client_single_stats_active_devices_label: 'Online devices',
         service_client_single_stats_error_devices_label: 'Alarm devices',
         service_client_single_no_user_selected_for_de_activation_message:
           'Please select records to deactivate',
         /* END Service Clients Single */
         /* Users */
         users_bread_crumb_main_title: 'Client',
         add_users_bread_crumb_first_link: 'Add user',
         add_users_form_header: 'Add user',
         edit_users_bread_crumb_first_link: 'Edit user',
         edit_users_form_header: 'Edit user',
         users_form_first_name_field: 'First name',
         users_form_last_name_field: 'Last name',
         users_form_email_field: 'Email address',
         users_form_official_email_field: 'Offical email address',
         users_form_phone_field: 'Phone number',
         users_form_official_phone_number_field: 'Offical phone number',
         users_form_password_field: 'Password',
         users_form_role_id_field: 'Role',
         users_form_select_role_id_field: 'Select role',
         users_form_street_number_field: 'Street',
         users_form_house_number_field: 'House number',
         users_form_neighbourhood_field: 'Neighbourhood',
         users_form_postal_code_field: 'Postal code',
         users_form_city_field: 'City',
         users_form_country_field: 'Country',
         users_form_email_verification_field: 'Email verification',
         users_form_email_verification_sub_title_field:
           'Disabling this button will automatically send the user a verification email',
         users_form_add_user_button: 'Add user',
         users_form_edit_user_button: 'Save changes',
         users_form_cancel_button: 'Cancel',
         users_form_submitting_user_button: 'Submitting...',
         users_first_name_required_form_error: 'First name is required',
         users_last_name_required_form_error: 'Last name is required',
         users_email_required_form_error: 'Email is required',
         users_email_valid_form_error: 'Must be a valid email address',
         users_password_required_form_error: 'Password is required',
         users_country_required_form_error: 'Country is required',
         users_role_id_required_form_error: 'Role is required',
         users_password_form_error:
           'Password must contain at least 8 characters with at least one uppercase letter, at least one number and at least one special character.',
         users_add_form_success: 'User created successfully!',
         users_edit_form_success: 'User is updated successfully!',
         users_form_api_error: 'Internal Users - API Server Alarm',
         users_form_email_error: 'Email address already exists',
         users_no_record_found: 'No users found',
         user_deactivated_message: 'User is deactivated successfully',
         user_activated_message: 'User is activated successfully',
         user_email_verified_title: 'Email address is verified',
         user_email_verified_sub_title:
           'Disabling this button will automatically send the user a verification email',
         users_bulk_no_user_is_selected_error_message:
           'Please select records to deactivate',
         users_bulk_deactivated_message:
           '{{ USERS_COUNT }} Users are deactivated successfully',
         /** Projects */
         projects: 'Projects',
         projects_all: 'ALL',
         projects_active: 'ACTIVE',
         projects_inactive: 'INACTIVE',
         projects_unassigned: 'UNASSIGNED',
         projects_add_new: 'Add new',
         projects_filter_search: 'Search project',
         projects_sort_by_filter_label: 'Sort by',
         projects_sort_by_value_1: 'Date(newest)',
         projects_sort_by_value_2: 'Date(oldest)',
         projects_sort_by_value_3: 'Alphabetical',
         projects_country_filter_label: 'Country',
         projects_filter_reset_button: 'Reset',
         projects_filter_delete_button: 'Delete',
         projects_table_name: 'Name',
         projects_table_batch_number: 'Batch Number',
         projects_table_client: 'Clients',
         projects_table_devices: 'Devices',
         projects_table_added: 'Creation date',
         projects_table_status: 'Status',
         projects_table_row_per_page: 'Rows per page',
         projects_bread_crumb_main_title: 'Projects',
         add_projects_bread_crumb_first_link: 'Add project',
         add_projects_form_header: 'Add project',
         edit_projects_bread_crumb_first_link: 'Edit project',
         edit_projects_form_header: 'Edit project',
         projects_form_project_name_field: 'Project name',
         projects_form_email_field: 'Email address',
         projects_form_client_field: 'Client',
         projects_form_service_client_field: 'Service client',
         projects_form_user_field: 'User',
         projects_form_description_field: 'Description (optional)',
         projects_form_add_project_button: 'Save changes',
         projects_form_edit_project_button: 'Save changes',
         projects_form_cancel_button: 'Cancel',
         projects_form_submitting_service_client_button: 'Submitting...',
         projects_name_required_form_error: 'Name is required',
         projects_form_unqiue_project_order_number_error:
           'Project Order Number must be unique',
         projects_batch_number_required_form_error: 'Batch number is required',
         projects_client_required_form_error: 'Client is required',
         projects_description_required_form_error: 'Description is required',
         projects_add_form_success: 'Project created successfully!',
         projects_edit_form_success: 'Project is updated successfully!',
         projects_form_api_error: 'Internal projects - API Server Alarm',
         projects_no_record_found: 'No projects found',
         projects_deactivated_message: 'Project is deactivated successfully',
         projects_activated_message: 'Project is activated successfully',
         projects_bulk_no_user_is_selected_error_message:
           'Please select records to deactivate',
         projects_bulk_deactivated_message:
           '{{ USERS_COUNT }} Projects are deactivated successfully',
         projects_single_stats_table_title: 'Status',
         /** Devices */
         devices_form_header: 'Devices',
         devices_all: 'All',
         devices_active: 'Online',
         devices_inactive: 'Offline',
         devices_error: 'ALARM',
         devices_register_enabled: 'Enabled',
         devices_register_disabled: 'Disabled',
         devices_add_new: 'Add new',
         devices_testing: 'Device Testing',
         devices_name: 'Name',
         devices_address: 'Installation address',
         devices_client: 'Client',
         devices_project: 'Project',
         devices_status: 'Status',
         devices_description: 'Heat Interface Unit',
         device_is_online: 'Device is "online"',
         device_is_offline: 'Device is "offline"',
         devices_last_viewed: 'Last seen',
         devices_action: 'Action',
         devices_search: 'Search',
         devices_row_per_page: 'Rows per page',
         device_rssi_title: 'RSSI',
         device_status_reg_105_no_error_255: 'No alarm',
         device_status_menu_keys_list: JSON.stringify([
           'operating_state',
           'settings_hot_water',
           'settings_heating_and_cooling',
           'manual_control',
           'firmware_registers',
           'lin_pump_delta_parameters',
           'm_bus_meters',
           'live_hot_water',
           'live_heating',
           'live_cooling',
         ]),
         devices_filter_search: 'Search device',
         devices_sort_by_filter_label: 'Sort by',
         devices_sort_by_value_1: 'Date(newest)',
         devices_sort_by_value_2: 'Date(oldest)',
         devices_sort_by_value_3: 'Alphabetical',
         devices_country_filter_label: 'Country',
         devices_filter_reset_button: 'Reset',
         devices_filter_delete_button: 'Delete',
         devices_table_name: 'Name',
         devices_table_firmware: 'Firmware',
         devices_table_device_type: 'Device type',
         devices_table_batch_number: 'Batch number',
         devices_table_client: 'Clients',
         devices_table_devices: 'Devices',
         devices_table_added: 'Creation date',
         devices_table_status: 'Status',
         devices_table_row_per_page: 'Rows per page',
         devices_bread_crumb_main_title: 'Devices',
         add_devices_bread_crumb_first_link: 'Add device',
         add_devices_form_header: 'Add device',
         edit_devices_bread_crumb_first_link: 'Edit device',
         edit_devices_form_header: 'Edit device',
         devices_form_device_information_tab: 'Device information',
         devices_form_name_field: 'Device name',
         devices_form_type_field: 'Device type',
         devices_form_ip_address_field: 'IP Address',
         devices_form_preset_field: 'Preset',
         devices_form_project_field: 'Project',
         devices_form_client_field: 'Client',
         devices_form_batch_number_field: 'Batch number',
         devices_form_serial_number_field: 'Serial number Mercurius',
         devices_form_box_serial_number_field:
           'Serial number Heat Interface Unit',
         devices_form_firmware_field: 'Firmware version',
         devices_form_description_field: 'Heat Interface Unit Type',
         devices_form_device_address_tab: 'Installation address',
         devices_form_street_number_field: 'Street',
         devices_form_house_number_field: 'House number',
         devices_form_postal_code_field: 'Postal code',
         devices_form_neighbourhood_field: 'Additional information',
         devices_form_city_field: 'City',
         devices_form_country_field: 'Country',
         devices_form_floor_number_field: 'Floor',
         devices_form_building_number_field: 'Construction number',
         devices_form_additional_information_tab: 'Additional information',
         devices_form_sn_heat_unit_field: 'Serial number heat interface unit',
         devices_form_article_number_field:
           'Article number heat interface unit',
         devices_form_prod_order_nr_week_field: 'Production order number',
         devices_form_serial_number_mercurius_field: 'Serial number Mercurius',
         devices_form_sim_card_number_field: 'Sim card number',
         devices_form_customer_ref_field: 'Customer reference',
         devices_form_production_date_field: 'Production date',
         devices_form_order_number_field: 'Order number',
         devices_form_product_number_field: 'Article number',
         devices_form_model_number_field: 'Model number',
         devices_form_note_field: 'Note (optional)',
         devices_form_settings_tab: 'Settings',
         devices_form_device_interval_field: 'Interval',
         devices_form_is_device_enabled_sensor_field: 'Enable sensor data',
         devices_form_is_device_activated_field: 'Deactivate device',
         devices_form_mbus_tab: 'M-Bus',
         devices_form_is_device_enabled_heat_meter_field: 'Enable heat meter',
         devices_form_is_device_enabled_cool_meter_field: 'Enable cool meter',
         devices_form_is_device_enabled_electric_meter_field:
           'Enable electricity meter',
         devices_form_is_device_enabled_bi_directional_meter_field:
           'Enable heat/cool meter',
         devices_form_is_device_enabled_water_meter_field: 'Enable water meter',
         devices_form_is_device_enabled_mbus_search_meter_button:
           'Search energy meters',
         devices_form_add_device_button: 'Add device',
         devices_form_edit_device_button: 'Save changes',
         devices_form_cancel_button: 'Cancel',
         devices_form_submitting_service_client_button: 'Submitting...',
         devices_name_required_form_error: 'Name is required',
         devices_batch_number_required_form_error: 'Batch number is required',
         devices_serial_number_required_form_error: 'Serial number is required',
         devices_sn_heat_number_numeric_form_error:
           'Serial number Heat Interface Unit must be a number',
         devices_article_number_form_error: 'Article number is required',
         devices_prod_order_nr_week_form_error:
           'Production order number is required',
         devices_serial_number_mercurius_form_error:
           'Serial number Mercurius is required',
         devices_sim_card_number_form_error: 'Sim card number is required',
         devices_device_interval_numeric_form_error:
           'Device interval must be a number',
         devices_client_required_form_error: 'Client is required',
         devices_project_required_form_error: 'Project is required',
         devices_preset_required_form_error: 'Preset is required',
         devices_description_required_form_error: 'Description is required',
         devices_add_form_success: 'Device created successfully!',
         devices_edit_form_success: 'Device is updated successfully!',
         devices_form_unique_error:
           'Serial number heat interface unit and serial number Mercurius must be unique',
         devices_form_api_error: 'Internal devices - API Server Alarm',
         devices_no_record_found: 'No devices found',
         devices_deactivated_message: 'Device is deactivated successfully',
         devices_activated_message: 'Device is activated successfully',
         devices_search_mbus_registers_success:
           'The message has been successfully sent to the device.',
         devices_search_mbus_registers_missing_serial_number_error:
           'Please fill in serial number to proceed.',
         devices_bulk_no_user_is_selected_error_message:
           'Please select records to deactivate',
         devices_bulk_deactivated_message:
           '{{ USERS_COUNT }} Devices are deactivated successfully',
         // Devices Single
         device_single_page_title: 'Device details',
         devices_single_bread_crumb_main_title: 'Device overview',
         devices_single_bread_crumb_first_link: 'Device page',
         devices_single_basic_details_client: 'CLIENT',
         devices_single_basic_details_serial_number: 'SERIAL NUMBER MERCURIUS',
         devices_single_basic_details_firmware: 'FIRMWARE',
         devices_single_basic_details_type: 'DEVICE TYPE',
         devices_single_edit_device_button: 'Edit device',
         device_single_error_status: 'Error',
         device_single_online_status: 'Online',
         device_single_offline_status: 'Offline',
         device_single_rss_device_status: 'Device status',
         device_single_rss_signal_strength: 'Signal strength',
         device_single_temperature_tab: 'Temperature graph',
         device_single_temperature_title:
           'The history of the heat interface unit',
         device_single_temperature_hr: 'Hour',
         device_single_registers_tab: 'Registers',
         device_single_event_tab: 'Events',
         device_single_device_details_tab: 'Info',
         device_single_device_api_timer_seconds_label: 'Seconds',
         device_single_device_api_timer_minute_label: 'Minute',
         device_single_device_api_timer_minutes_label: 'Minutes',
         device_single_recall_device_status_api_timer_field: 'API Interval',
         devices_single_last_seen: 'Last seen',
         devices_single_fetch_registers: 'DATA COLLECT',
         fetch_registers_success:
           'The request has been successfully sent to device.',
         write_registers_success:
           'Write message has been successfully sent to device.',
         write_registers_error: 'Please change the value to proceed.',
         fetch_registers_m_bus_meters_not_supported:
           'M-Bus Meters are not supported at the moment.',
         // Operating Status - TR03
         business_situation_operating_status_TR03_title:
           'Operating state Heat Interface Unit',
         device_status_nr: 'NR',
         device_status_name: 'Name',
         device_status_value: 'Value',
         business_situation_operating_status_TR03_100: 'Heating state',
         business_situation_operating_status_TR03_100_list: JSON.stringify({
           list: {
             0: 'Idle',
             1: 'Request',
             2: 'Demand',
             3: 'Post Circulation',
             4: 'Off',
             5: 'Pre Circulation',
           },
         }),
         business_situation_operating_status_TR03_101: 'Hot Water state',
         business_situation_operating_status_TR03_101_list: JSON.stringify({
           list: {
             0: 'Idle',
             1: 'Request',
             2: 'Demand',
             3: 'Post Circulation',
             4: 'Off',
           },
         }),
         business_situation_operating_status_TR03_102: 'Preheat state',
         business_situation_operating_status_TR03_102_list: JSON.stringify({
           list: {
             0: 'Idle',
             1: 'Demand',
           },
         }),
         business_situation_operating_status_TR03_103:
           'Thermal disinfection state',
         business_situation_operating_status_TR03_103_list: JSON.stringify({
           list: {
             0: 'Idle',
             1: 'Request',
             2: 'Demand',
             3: 'Post Circulation',
             4: 'Off',
           },
         }),
         business_situation_operating_status_TR03_104: 'Cooling state',
         business_situation_operating_status_TR03_104_list: JSON.stringify({
           list: {
             0: 'Idle',
             1: 'Request',
             2: 'Init',
             3: 'Demand',
             4: 'Post Circulation',
             5: 'Pre Circulation',
           },
         }),
         business_situation_operating_status_TR03_1802:
           'TE Heating Element State',
         business_situation_operating_status_TR03_1802_list: JSON.stringify({
           list: {
             0: 'Off',
             1: 'On',
           },
         }),
         business_situation_operating_status_TR03_105: 'Alarm code',
         business_situation_operating_status_TR03_106: 'Software version',
         business_situation_operating_status_TR03_107: 'Hot water valve (M1)',
         business_situation_operating_status_TR03_108:
           'Heating/cooling valve (M2)',
         business_situation_operating_status_TR03_109: 'Pump',
         business_situation_operating_status_TR03_109_list: JSON.stringify({
           list: {
             0: 'Off',
             1: 'On',
           },
         }),
         business_situation_operating_status_TR03_110: '6-way-valve',
         business_situation_operating_status_TR03_110_list: JSON.stringify({
           list: {
             0: 'Position: Heating',
             1: 'Position: Cooling',
           },
         }),
         business_situation_operating_status_TR03_112_list: JSON.stringify({
           list: {
             0: 'Heating or demand',
             1: 'Cooling',
           },
         }),
         business_situation_operating_status_TR03_113: 'Room thermostat input',
         business_situation_operating_status_TR03_113_list: JSON.stringify({
           list: {
             1: 'No heating demand',
             2: 'Heating demand',
           },
         }),
         business_situation_operating_status_TR03_114: 'OpenTherm Indicator',
         business_situation_operating_status_TR03_114_list: JSON.stringify({
           list: {
             0: 'Inactive connection',
             1: 'Active connection',
           },
         }),
         business_situation_operating_status_TR03_115: 'Appliance Type',
         // Business situation - TR03
         business_situation_measured_values_TR03_title: 'Measurements',
         business_situation_measured_values_TR03_200: 'Hot water flow rate',
         business_situation_measured_values_TR03_201: 'Hot water temperature',
         business_situation_measured_values_TR03_202: 'Primary supply',
         business_situation_measured_values_TR03_203: 'Primary return/Outdoor',
         business_situation_measured_values_TR03_205: 'Secondary supply',
         business_situation_measured_values_TR03_206: 'Secondary return',
         business_situation_measured_values_TR03_204:
           'Calculated heating setpoint',
         business_situation_measured_values_TR03_207:
           'Room Temperature (OpenTherm)',
         business_situation_measured_values_TR03_208:
           'Room Setpoint (OpenTherm)',
         business_situation_measured_values_TR03_210:
           'Secondary water pressure',
         // Operating time - TR03
         business_situation_operating_time_TR03_title: 'Operating Time',
         business_situation_operating_time_TR03_800: 'Total system run time',
         business_situation_operating_time_TR03_801: 'Heating burn time',
         business_situation_operating_time_TR03_802: 'Cooling burn time',
         business_situation_operating_time_TR03_803: 'Hot water burn Time',
         business_situation_operating_time_TR03_804: 'Number of tappings',
         business_situation_operating_time_TR03_805: 'Hot water Volume',
         business_situation_operating_time_TR03_806: 'Power cuts',
         // Warmtapwater - TR03
         settings_dhw_warm_tap_water_TR03_title: 'Settings hot water',
         settings_dhw_warm_tap_water_TR03_300: 'Hot water setpoint',
         settings_dhw_warm_tap_water_TR03_301: 'Preheat mode',
         settings_dhw_warm_tap_water_TR03_301_list: JSON.stringify({
           list: {
             0: 'Off',
             1: 'Anti freeze',
             2: 'Eco',
             3: 'Comfort',
             4: 'Dynamic (recommended)',
           },
         }),
         settings_dhw_warm_tap_water_TR03_302: 'Comfort setpoint',
         settings_dhw_warm_tap_water_TR03_303: 'Minimum flow rate threshold',
         settings_dhw_warm_tap_water_TR03_304: 'Hot water enable',
         settings_dhw_warm_tap_water_TR03_304_list: JSON.stringify({
           list: {
             0: 'Off',
             1: 'On',
           },
         }),
         // Thermal disinfection - TR03
         settings_thermal_disinfection_TR03_title:
           'Settings Thermal disinfection',
         settings_thermal_disinfection_TR03_400: 'Thermal disinfection enabled',
         settings_thermal_disinfection_TR03_400_list: JSON.stringify({
           list: {
             0: 'Off',
             1: 'On',
           },
         }),
         settings_thermal_disinfection_TR03_401:
           'Thermal disinfection setpoint',
         settings_thermal_disinfection_TR03_402:
           'Thermal disinfection burn time',
         settings_thermal_disinfection_TR03_403:
           'Thermal disinfection wait time',
         // TE-Booster - TR03
         settings_dhw_te_booster_TR03_title: 'Settings TE-Booster',
         settings_dhw_te_booster_TR03_1800: 'TE-Booster',
         settings_dhw_te_booster_TR03_1800_list: JSON.stringify({
           list: {
             0: 'Disabled',
             1: 'Enabled',
           },
         }),
         settings_dhw_te_booster_TR03_1804: 'TE-Booster setpoint',
         settings_dhw_te_booster_TR03_1805: 'TE-Booster setpoint hysteresis',
         settings_dhw_te_booster_TR03_1812: 'TE-Booster setpoint timeout',
         settings_dhw_te_booster_TR03_1813: 'TE-Booster setpoint timer',
         settings_dhw_te_booster_TR03_1815: 'TE-Booster threshold',
         settings_dhw_te_booster_TR03_1816: 'TE-Booster taped volume',
         // Heating - TR03
         heating_and_cooling_settings_heating_TR03_title: 'Settings heating',
         heating_and_cooling_settings_heating_TR03_500:
           'Heating maximum setpoint',
         heating_and_cooling_settings_heating_TR03_501:
           'Heating minimum setpoint',
         heating_and_cooling_settings_heating_TR03_506:
           'Maximum primary return',
         heating_and_cooling_settings_heating_TR03_507:
           'Primary return compensation factor',
         heating_and_cooling_settings_heating_TR03_508:
           'Delta primary-secondary setpoint',
         heating_and_cooling_settings_heating_TR03_510:
           'Maximum heating temperature',
         heating_and_cooling_settings_heating_TR03_509:
           'Minimum primary-secondary delta',
         heating_and_cooling_settings_heating_TR03_514: 'Heating setpoint',
         heating_and_cooling_settings_heating_TR03_515: 'Heating enable',
         heating_and_cooling_settings_heating_TR03_515_list: JSON.stringify({
           list: {
             0: 'Off',
             1: 'On',
           },
         }),
         // Cooling - TR03
         heating_and_cooling_settings_cooling_TR03_title: 'Settings cooling',
         heating_and_cooling_settings_cooling_TR03_600: 'Cooling setpoint',
         heating_and_cooling_settings_cooling_TR03_601:
           'Minimum primary return',
         heating_and_cooling_settings_cooling_TR03_602:
           'Primary return compensation factor',
         heating_and_cooling_settings_cooling_TR03_605:
           'Maximum cooling temperature',
         heating_and_cooling_settings_cooling_TR03_606:
           'Cooling setpoint minimum',
         heating_and_cooling_settings_cooling_TR03_607:
           'Cooling setpoint maximum',
         heating_and_cooling_settings_cooling_TR03_611: 'Cooling enable',
         heating_and_cooling_settings_cooling_TR03_611_list: JSON.stringify({
           list: {
             0: 'Off',
             1: 'On',
           },
         }),
         // Secondary General - TR03
         heating_and_cooling_settings_secondary_general_TR03_title:
           'Settings general',
         heating_and_cooling_settings_secondary_general_TR03_512:
           'Minimum Pressure',
         heating_and_cooling_settings_secondary_general_TR03_513:
           'Maximum Pressure',
         heating_and_cooling_settings_secondary_general_TR03_603:
           'Wait time to switch heating and cooling',
         heating_and_cooling_settings_secondary_general_TR03_604:
           '6-way valve waiting time',
         // Changeover WKW - TR03
         heating_and_cooling_settings_changeover_wkw_TR03_title:
           'Settings 3.5 pipe systems',
         heating_and_cooling_settings_changeover_wkw_TR03_1850:
           '3.5 pipe configuration',
         heating_and_cooling_settings_changeover_wkw_TR03_1850_list: JSON.stringify(
           {
             list: {
               0: 'Heating',
               1: 'Cooling',
             },
           }
         ),
         heating_and_cooling_settings_changeover_wkw_TR03_1851:
           'Cooling detection threshold',
         heating_and_cooling_settings_changeover_wkw_TR03_1852:
           'Heating detection threshold',
         heating_and_cooling_settings_changeover_wkw_TR03_1853:
           'Heating lowered setpoint',
         heating_and_cooling_settings_changeover_wkw_TR03_1854:
           'Lowered setpoint used',
         heating_and_cooling_settings_changeover_wkw_TR03_1854_list: JSON.stringify(
           {
             list: {
               0: 'Off',
               1: 'On',
             },
           }
         ),
         heating_and_cooling_settings_changeover_wkw_TR03_1855:
           'Predetection M2 position',
         heating_and_cooling_settings_changeover_wkw_TR03_1856:
           'Detection interval',
         heating_and_cooling_settings_changeover_wkw_TR03_1857:
           'Detection interval timer',
         heating_and_cooling_settings_changeover_wkw_TR03_1858:
           'Predetection timeout',
         heating_and_cooling_settings_changeover_wkw_TR03_1859:
           'Predetection timer',
         heating_and_cooling_settings_changeover_wkw_TR03_1860:
           'Configuration switch timer',
         heating_and_cooling_settings_changeover_wkw_TR03_1861:
           'Switch timeout',
         heating_and_cooling_settings_changeover_wkw_TR03_1862:
           'Configuration switch threshold',
         heating_and_cooling_settings_changeover_wkw_TR03_1863:
           'Boost function mode',
         heating_and_cooling_settings_changeover_wkw_TR03_1863_list: JSON.stringify(
           {
             list: {
               0: 'Disabled',
               1: 'Enabled',
             },
           }
         ),
         heating_and_cooling_settings_changeover_wkw_TR03_1864:
           'Boost detection timer',
         heating_and_cooling_settings_changeover_wkw_TR03_1865:
           'Boost detection timeout',
         heating_and_cooling_settings_changeover_wkw_TR03_1866:
           'Maximum boost position',
         // Manual Operation - TR03
         settings_manual_operation_TR03_title: 'Manual control',
         settings_manual_operation_TR03_700: 'Manual control enable',
         settings_manual_operation_TR03_700_list: JSON.stringify({
           list: {
             0: 'Off',
             1: 'On',
           },
         }),
         settings_manual_operation_TR03_701: 'Hot water valve (M1)',
         settings_manual_operation_TR03_702: 'Heating/cooling valve (M2)',
         settings_manual_operation_TR03_703: 'Pump',
         settings_manual_operation_TR03_703_list: JSON.stringify({
           list: {
             0: 'Off',
             1: 'On',
           },
         }),
         settings_manual_operation_TR03_704: '6-way valve',
         settings_manual_operation_TR03_704_list: JSON.stringify({
           list: {
             0: 'Heating',
             1: 'Cooling',
           },
         }),
         settings_manual_operation_TR03_706: 'Heat demand status output',
         settings_manual_operation_TR03_706_list: JSON.stringify({
           list: {
             0: 'Heating or demand',
             1: 'Cooling',
           },
         }),
         settings_manual_operation_TR03_707: 'Hot water valve (M1)[%]',
         settings_manual_operation_TR03_708: 'Heating/cooling valve (M2)[%]',
         settings_manual_operation_TR03_1801: 'Elektisch element TE-Booster',
         settings_manual_operation_TR03_1801_list: JSON.stringify({
           list: {
             0: 'Disabled',
             1: 'Enabled',
           },
         }),
         settings_manual_operation_TR03_709: 'Manual control timeout timer',
         // Live Tap Water
         live_tap_water_title: 'Live Hot Water',
         live_tap_water_101: 'Hot water state',
         live_tap_water_107: 'Hot water valve (M1)',
         live_tap_water_200: 'Flow rate',
         live_tap_water_201: 'Hot water temperature',
         live_tap_water_202: 'Primary supply',
         live_tap_water_203: 'Primary return',
         live_tap_water_1007: 'Primary flow M-Bus meter',
         live_tap_water_1008: 'Power',
         // Live CV
         live_cv_title: 'Live Heating',
         live_cv_100: 'Heating state',
         live_cv_108: 'Heating valve (M2)',
         live_cv_202: 'Primary supply',
         live_cv_203: 'Primary return',
         live_cv_204: 'Calculated heating setpoint',
         live_cv_205: 'Secondary supply',
         live_cv_206: 'Secondary return',
         live_cv_113: 'Room thermostat input',
         live_cv_210: 'Secondary water pressure',
         live_cv_1007: 'Primary flow M-Bus meter',
         live_cv_1008: 'Power',
         // Live Cooling
         live_cooling_title: 'Live Cooling',
         live_cooling_104: 'Cooling state',
         live_cooling_109: 'Pump',
         live_cooling_110: '6-way valve',
         live_cooling_113: 'Room thermostat input',
         live_cooling_108: 'Cooling valve (M2)',
         live_cooling_202: 'Primary supply',
         live_cooling_204: 'Calculated heating setpoint',
         live_cooling_205: 'Secondary supply',
         live_cooling_206: 'Secondary return',
         // M Bus Limit DELETE ALL
         m_bus_limit_title: 'M Bus Limit',
         m_bus_limit_1500: 'Begrenzing inschakelen',
         m_bus_limit_1501: 'Serienummer begrenzing meter',
         m_bus_limit_1503: 'Begrens status',
         m_bus_limit_1504: 'Begrenzing configuratie DHW (h) en CH (l)',
         m_bus_limit_1505: 'Begrens vermogen',
         m_bus_limit_1506: 'Begrens flow',
         m_bus_limit_1507: 'Begrens retour temperatuur (Alleen voor CH)',
         // Meter 1
         m_bus_meter_1_title: 'Meter 1 (Heating)',
         m_bus_meter_1_0000: 'Serial number',
         m_bus_meter_1_0002: 'Manufacturer',
         m_bus_meter_1_0003: 'Meter type',
         m_bus_meter_1_0004: 'Status',
         m_bus_meter_1_0005: 'Flow',
         m_bus_meter_1_0006: 'Power',
         m_bus_meter_1_0007: 'Supply temperature',
         m_bus_meter_1_0008: 'Return temperature',
         m_bus_meter_1_0010: 'Accumulated heating energy',
         m_bus_meter_1_0012: 'Accumulated Volume',
         // Meter 2
         m_bus_meter_2_title: 'Meter 2 (Cooling)',
         m_bus_meter_2_0100: 'Serial umber',
         m_bus_meter_2_0102: 'Manufacturer',
         m_bus_meter_2_0103: 'Meter type',
         m_bus_meter_2_0104: 'Status',
         m_bus_meter_2_0105: 'Flow',
         m_bus_meter_2_0106: 'Power',
         m_bus_meter_2_0107: 'Supply temperature',
         m_bus_meter_2_0108: 'Return temperature',
         m_bus_meter_2_0110: 'Accumulated cooling energy',
         m_bus_meter_2_0112: 'Accumulated volume',
         // Meter 3
         m_bus_meter_3_title: 'Meter 3 (Electricity)',
         m_bus_meter_3_0200: 'Serial number',
         m_bus_meter_3_0202: 'Manufacturer',
         m_bus_meter_3_0203: 'Meter type',
         m_bus_meter_3_0204: 'Status',
         m_bus_meter_3_0206: 'Power',
         m_bus_meter_3_0210: 'Accumulated energy',
         m_bus_meter_3_0214: 'Current',
         // Meter 4
         m_bus_meter_4_title: 'Meter 4 (Water)',
         m_bus_meter_4_0300: 'Serial number',
         m_bus_meter_4_0302: 'Manufacturer',
         m_bus_meter_4_0303: 'Meter type',
         m_bus_meter_4_0304: 'Status',
         m_bus_meter_4_0305: 'Flow',
         m_bus_meter_4_0307: 'Supply temperature (if available)',
         m_bus_meter_4_0312: 'Accumulated volume',
         // Meter 5
         m_bus_meter_5_title: 'Meter 5 (Bi Directional)',
         m_bus_meter_5_0400: 'Serial number',
         m_bus_meter_5_0402: 'Manufacturer',
         m_bus_meter_5_0403: 'Meter type',
         m_bus_meter_5_0404: 'Status',
         m_bus_meter_5_0405: 'Flow',
         m_bus_meter_5_0406: 'Power',
         m_bus_meter_5_0407: 'Supply temperature',
         m_bus_meter_5_0408: 'Return temperature',
         m_bus_meter_5_0410: 'Accumulated heating energy',
         m_bus_meter_5_0412: 'Accumulated volume',
         m_bus_meter_5_0414: 'Accumulated cooling energy',
         // History Block Errors
         history_block_errors_title: 'History Block Errors - sorted by newest',
         history_block_errors_860: 'Block Alarm 1',
         history_block_errors_861: 'Block Alarm 2',
         history_block_errors_862: 'Block Alarm 3',
         history_block_errors_863: 'Block Alarm 4',
         history_block_errors_864: 'Block Alarm 5',
         history_block_errors_865: 'Block Alarm 6',
         history_block_errors_866: 'Block Alarm 7',
         history_block_errors_867: 'Block Alarm 8',
         history_block_errors_868: 'Block Alarm 9',
         history_block_errors_869: 'Block Alarm 10',
         history_block_errors_870: 'Block Alarm 11',
         history_block_errors_871: 'Block Alarm 12',
         history_block_errors_872: 'Block Alarm 13',
         history_block_errors_873: 'Block Alarm 14',
         history_block_errors_874: 'Block Alarm 15',
         // Events
         device_events_type_filter_label: 'Event type',
         device_events_type_filter_value_1: 'Audit',
         device_events_type_filter_value_2: 'Alarm',
         // Presets
         presets: 'Presets',
         presets_all: 'All',
         presets_active: 'ACTIVE',
         presets_inactive: 'INACTIVE',
         presets_add_new: 'Add new',
         presets_filter_search: 'Search',
         presets_filter_reset_button: 'Reset',
         presets_filter_delete_button: 'Delete',
         presets_table_name: 'Name',
         presets_table_status: 'Status',
         presets_updated_date: 'Updated At',
         presets_action: 'Actions',
         presets_table_row_per_page: 'Rows per page',
         presets_status_menu_list: JSON.stringify([
           {
             key: 'settings_hot_water',
             value: 'Settings hot water',
             permission: 'settings-hot-water-tab-read',
           },
           {
             key: 'settings_heating_and_cooling',
             value: 'Settings heating and cooling',
             permission: 'settings-heating-and-cooling-tab-read',
           },
           {
             key: 'manual_control',
             value: 'Manual control',
             permission: 'manual-control-tab-read',
           },
         ]),
         add_presets_title: 'Add preset',
         edit_presets_title: 'Edit preset',
         presets_form_name_required: 'Preset name is required',
         presets_form_register_required: 'Register value is required',
         presets_form_add_preset_button: 'Save changes',
         presets_form_edit_preset_button: 'Save changes',
         presets_form_cancel_button: 'Cancel',
         presets_add_form_success: 'Preset created successfully!',
         presets_edit_form_success: 'Preset is updated successfully!',
         presets_form_api_error: 'Internal API - Presets Server Alarm',
         presets_no_record_found: 'No presets found',
         presets_deactivated_message: 'Preset is deactivated successfully',
         presets_activated_message: 'Preset is activated successfully',
         presets_bulk_no_user_is_selected_error_message:
           'Please select records to deactivate',
         presets_bulk_deactivated_message:
           '{{ USERS_COUNT }} Presets are deactivated successfully',
         // Audits
         audits: 'Audits',
         audits_all: 'All',
         audits_active: 'Audit',
         audits_inactive: 'Alarm',
         audits_filter_search: 'Search',
         audits_client_filter_label: 'Client',
         audits_error_code_filter_label: 'Alarm code',
         audits_project_filter_label: 'Project',
         audits_order_number_filter_label: 'Order number',
         audits_events_type_filter_label: 'Event type',
         audits_date_range_filter_label: 'Date range',
         audits_events_type_filter_value_1: 'Audit',
         audits_events_type_filter_value_2: 'Alarm',
         audits_reset_filters_button: 'Reset',
         audits_date: 'Date',
         audits_device: 'Device',
         audits_client: 'Client',
         audits_message: 'Message',
         audits_table_row_per_page: 'Rows per page',
         audits_table_no_record_found: 'No records found',
         // Settings
         settings_update_profile_title: 'Update profile',
         settings_notification_title: 'Notifications',
         settings_notification_window_exceptions_title:
           'Notify when operating window exceptions occur',
         settings_notification_device_error_title: 'Active Alarm email',
         settings_notification_channels_title: 'Notifications channels',
         settings_notification_use_email_title: 'Use email',
         /* Admins */
         admins: 'Admins',
         admins_first_bread_crumb: 'Admins',
         admins_filter_search: 'Search',
         admins_add_new: 'Add user',
         admins_filter_reset_button: 'Reset',
         admins_filter_delete_button: 'Deactivate',
         admins_search: 'Search',
         admins_all: 'ALL',
         admins_active: 'ACTIVE',
         admins_inactive: 'INACTIVE',
         admins_table_name: 'Name',
         admins_table_address: 'Address',
         admins_table_role_id: 'Role',
         admins_table_status: 'Status',
         admins_table_added: 'Creation date',
         admins_table_no_record_found: 'No record found',
         admins_table_row_per_page: 'Rows per page',
         admins_no_user_selected_for_de_activation_message:
           'Please select records to deactivate',
         admins_bread_crumb_main_title: 'Admins',
         add_admins_bread_crumb_first_link: 'Add admin',
         add_admins_form_header: 'Add admin',
         edit_admins_bread_crumb_first_link: 'Edit admin',
         edit_admins_form_header: 'Edit admin',
         admins_form_first_name_field: 'First name',
         admins_form_last_name_field: 'Last name',
         admins_form_email_field: 'Email address',
         admins_form_official_email_field: 'Offical email address',
         admins_form_phone_field: 'Phone number',
         admins_form_official_phone_number_field: 'Offical phone number',
         admins_form_password_field: 'Password',
         admins_form_role_id_field: 'Role',
         admins_form_select_role_id_field: 'Select role',
         admins_form_street_number_field: 'Street',
         admins_form_house_number_field: 'House number',
         admins_form_neighbourhood_field: 'Neighbourhood',
         admins_form_postal_code_field: 'Postal code',
         admins_form_city_field: 'City',
         admins_form_country_field: 'Country',
         admins_form_email_verification_field: 'Email verification',
         admins_form_email_verification_sub_title_field:
           'Disabling this will automatically send the admin a verification email',
         admins_form_add_admin_button: 'Add Admin',
         admins_form_edit_admin_button: 'Save changes',
         admins_form_cancel_button: 'Cancel',
         admins_form_submitting_admin_button: 'Submitting...',
         admins_first_name_required_form_error: 'First name is required',
         admins_last_name_required_form_error: 'Last name is required',
         admins_email_required_form_error: 'Email is required',
         admins_email_valid_form_error: 'Must be a valid email',
         admins_password_required_form_error: 'Password is required',
         admins_country_required_form_error: 'Country is required',
         admins_role_id_required_form_error: 'Role is required',
         admins_password_form_error:
           'Password must contain atleast one alphabet of uppercase, number and special character',
         admins_add_form_success: 'Admin is created successfully!',
         admins_edit_form_success: 'Admin is updated successfully!',
         admins_form_api_error: 'Internal Admins - API server error',
         admins_form_email_error: 'Email already exists',
         admins_no_record_found: 'No admin users found',
         admins_deactivated_message: 'Admin is deactivated successfully',
         admins_activated_message: 'Admin is activated successfully',
         admins_email_verified_title: 'Email is verified',
         admins_email_verified_sub_title:
           'Disabling this will automatically send the admin a verification email',
         admins_bulk_no_admin_is_selected_error_message:
           'Please select records to deactivate',
         admins_bulk_deactivated_message:
           '{{ USERS_COUNT }} Admins are deactivated successfully',
         // Search Results
         search_result_title: 'Search results: ',
         search_users: 'Users',
         search_clients: 'Clients',
         search_service_clients: 'Service Clients',
         search_devices: 'Devices',
         search_presets: 'Presets',
         search_projects: 'Projects',
         // New Locales
         no_error_devices_found: 'No error devices found',
         project_single_first_bread_crumb: 'Projects',
         project_single_second_bread_crumb: 'View project',
         project_single_client_label: 'Client',
         project_single_service_client_label: 'Service Client',
         project_single_devices_label: 'Devices',
         project_single_edit_button: 'Edit',
         project_single_devices_tab: 'Devices',
         client_single_view_more_errors_button: 'View more',
         client_error_single_devices_tab: 'Alarm devices',
         client_error_single_device_name: 'Device',
         client_error_single_device_error_code: 'Alarm code',
         client_error_single_device_error_date_time: 'Date',
         devices_bulk_edit_registers_button: 'Change setting(s)',
         devices_bulk_edit_ota_button: 'Update device(s)',
         client_error_single_device_errors_table_row_per_page: 'Rows per page',
         client_error_single_device_error_no_record_found: 'No records found',
         devices_bulk_edit_registers_title: 'Device registers project update',
         devices_bulk_edit_registers_form_submit_button: 'Bulk update',
         devices_bulk_edit_registers_form_cancel_button: 'Cancel',
         devices_bulk_edit_registers_form_success:
           'Message is forwarded to selected device(s)',
         devices_bulk_edit_registers_form_error:
           'Please fill in atleast one register value',
         devices_bulk_edit_registers_form_api_error: 'Internal server error',
         devices_bulk_edit_ota_title: 'Device OTA bulk update',
         devices_bulk_edit_ota_form_firmware_field: 'Firmware',
         devices_bulk_edit_ota_form_submit_button: 'Update devices',
         devices_bulk_edit_ota_form_cancel_button: 'Cancel',
         devices_bulk_edit_ota_form_success:
           'Message is forwarded to selected devices',
         devices_bulk_edit_ota_form_firmware_required_error:
           'Firmware required',
         devices_bulk_edit_ota_form_api_error:
           'Internal Bulk - API Server Alarm',
         devices_bulk_edit_registers_selected_devices:
           'Devices Selected for Bulk Edit',
         // Device Status Table Pop Over
         custom_popover_min_value: 'Min. Value',
         custom_popover_max_value: 'Max. Value',
         custom_popover_list_options: 'Possible values',
         custom_popover_short_description: 'Description',
         custom_popover_close_modal_button: 'Close window',
         // Warmtapwater PopOver Short Description
         custom_popover_300_short_description: 'Hot water setpoint',
         custom_popover_301_short_description: 'Preheat mode',
         custom_popover_302_short_description: 'Comfort setpoint',
         custom_popover_303_short_description: 'Minimum flow rate threshold',
         custom_popover_304_short_description: 'Hot water enable',
         // Thermal disinfection PopOver Short Description
         custom_popover_400_short_description: 'Thermal disinfection enabled',
         custom_popover_401_short_description: 'Thermal disinfection setpoint',
         custom_popover_402_short_description: 'Thermal disinfection burn time',
         custom_popover_403_short_description: 'Thermal disinfection wait time',
         // TE-Booster PopOver Short Description
         custom_popover_1800_short_description: 'TE-Booster Enabled',
         custom_popover_1804_short_description: 'TE-Booster setpoint',
         custom_popover_1805_short_description:
           'TE-Booster setpoint Hysteresis',
         custom_popover_1812_short_description: 'TE-Booster setpoint timeout',
         custom_popover_1813_short_description: 'TE-Booster setpoint timer',
         custom_popover_1815_short_description: 'TE-Booster threshold',
         custom_popover_1816_short_description: 'TE-Booster taped volume',
         // Heating PopOver Short Description
         custom_popover_500_short_description: 'Heating maximum setpoint',
         custom_popover_501_short_description: 'Heating minimum setpoint',
         custom_popover_506_short_description: 'Maximum primary return',
         custom_popover_507_short_description:
           'Primary return compensation factor',
         custom_popover_508_short_description:
           'Delta primary-secondary setpoint',
         custom_popover_510_short_description: 'Maximum heating temperature',
         custom_popover_509_short_description:
           'Minimum primary-secondary delta',
         custom_popover_514_short_description: 'Heating setpoint',
         custom_popover_515_short_description: 'Heating enable',
         // Cooling PopOver Short Description
         custom_popover_600_short_description: 'Cooling setpoint',
         custom_popover_601_short_description: 'Minimum primary return',
         custom_popover_602_short_description:
           'Primary return compensation factor',
         custom_popover_605_short_description: 'Maximum cooling temperature',
         custom_popover_606_short_description: 'Cooling setpoint minimum',
         custom_popover_607_short_description: 'Cooling setpoint maximum',
         custom_popover_611_short_description: 'Cooling enable',
         // Secondary General PopOver Short Description
         custom_popover_512_short_description: 'Minimum Pressure',
         custom_popover_513_short_description: 'Maximum Pressure',
         custom_popover_603_short_description:
           'Wait time to switch heating and cooling',
         custom_popover_604_short_description: '6-way valve waiting time',
         // Changeover WKW PopOver Short Description
         custom_popover_1850_short_description: '3.5Pipe Configuration',
         custom_popover_1851_short_description: 'Cooling detection threshold',
         custom_popover_1852_short_description: 'Heating detection threshold',
         custom_popover_1853_short_description: 'Heating lowered setpoint',
         custom_popover_1854_short_description: 'Lowered setpoint used',
         custom_popover_1855_short_description: 'Predetection M2 position',
         custom_popover_1856_short_description: 'Detection interval',
         custom_popover_1857_short_description: 'Detection interval timer',
         custom_popover_1858_short_description: 'Predetection timeout',
         custom_popover_1859_short_description: 'Predetection timer',
         custom_popover_1860_short_description: 'Configuration switch timer',
         custom_popover_1861_short_description: 'Switch timeout',
         custom_popover_1862_short_description:
           'Configuration switch threshold',
         custom_popover_1863_short_description: 'Boost function mode',
         custom_popover_1864_short_description: 'Boost detection timer',
         custom_popover_1865_short_description: 'Boost detection timeout',
         custom_popover_1866_short_description: 'Maximum boost position',
         // Manual Operation PopOver Short Description
         custom_popover_700_short_description: 'Manual control enable',
         custom_popover_701_short_description: 'Hot water valve (M1)',
         custom_popover_702_short_description: 'Heating/cooling valve (M2)',
         custom_popover_703_short_description: 'Pump',
         custom_popover_704_short_description: '6-way valve',
         custom_popover_706_short_description: 'Heat demand status output',
         custom_popover_707_short_description: 'Hot water valve (M1)[%]',
         custom_popover_708_short_description: 'Heating/cooling valve (M2)[%]',
         custom_popover_1801_short_description: 'Elektisch element TE-Booster',
         custom_popover_709_short_description: 'Manual control timeout timer',
         // Warmtapwater PopOver Long Description
         custom_popover_300_long_description: 'DHW Setpoint',
         custom_popover_301_long_description: 'Preheat mode',
         custom_popover_302_long_description: 'Comfort Setpoint',
         custom_popover_303_long_description: 'Flow rate start threshold',
         custom_popover_304_long_description: 'DHW Enable',
         // Thermal disinfection PopOver Long Description
         custom_popover_400_long_description: 'Aleg Enabled',
         custom_popover_401_long_description: 'Aleg Setpoint',
         custom_popover_402_long_description: 'Aleg Burn Time',
         custom_popover_403_long_description: 'Aleg Wait Time',
         // TE-Booster PopOver Long Description
         custom_popover_1800_long_description: 'TE-Booster Enabled',
         custom_popover_1804_long_description: 'TE-Booster Setpoint',
         custom_popover_1805_long_description: 'TE-Booster Setpoint Hysteresis',
         custom_popover_1812_long_description: 'TE-Booster Setpoint Timeout',
         custom_popover_1813_long_description: 'TE-Booster Setpoint Timer',
         custom_popover_1815_long_description: 'TE-Booster Threshold',
         custom_popover_1816_long_description: 'TE-Booster Taped Volume',
         // Heating PopOver Long Description
         custom_popover_500_long_description: 'CH Max Setpoint',
         custom_popover_501_long_description: 'CH Min Setpoint',
         custom_popover_506_long_description: 'Max Primary Return',
         custom_popover_507_long_description: 'Max Primary Return Percentage',
         custom_popover_508_long_description: 'Delta Prim CH Setpoint',
         custom_popover_510_long_description: 'Max Heating Temperature',
         custom_popover_509_long_description: 'Delta Prim Min',
         custom_popover_514_long_description: 'CH Setpoint',
         custom_popover_515_long_description: 'CH Enable',
         // Cooling PopOver Long Description
         custom_popover_600_long_description: 'CoolTempSetpoint',
         custom_popover_601_long_description: 'Cool MaxPrimary Return',
         custom_popover_602_long_description:
           'Cool % of Max Setpoint compensation',
         custom_popover_605_long_description: 'Max Cooling Temp',
         custom_popover_606_long_description: 'Cool setpoint min',
         custom_popover_607_long_description: 'Cool setpoint max',
         custom_popover_611_long_description: 'Cooling Enable',
         // Secondary General PopOver Long Description
         custom_popover_512_long_description: 'CH Min Pressure',
         custom_popover_513_long_description: 'CH Max Pressure',
         custom_popover_603_long_description: 'CoolHeatWaitingTime',
         custom_popover_604_long_description: '6way valve waiting time',
         // Changeover WKW PopOver Long Description
         custom_popover_1850_long_description: '3.5Pipe Configuration',
         custom_popover_1851_long_description: 'Cooling detection threshold',
         custom_popover_1852_long_description: 'Heating detection threshold',
         custom_popover_1853_long_description: 'Heating lowered setpoint',
         custom_popover_1854_long_description: 'Lowered setpoint used',
         custom_popover_1855_long_description: 'Predetection MCV2 position',
         custom_popover_1856_long_description: 'Detection interval',
         custom_popover_1857_long_description: 'Detection interval timer',
         custom_popover_1858_long_description: 'Predetection timeout',
         custom_popover_1859_long_description: 'Predetection timer',
         custom_popover_1860_long_description: 'Configuration switch timer',
         custom_popover_1861_long_description: 'Switch timeout',
         custom_popover_1862_long_description: 'Configuration switch threshold',
         custom_popover_1863_long_description: 'Boost function mode',
         custom_popover_1864_long_description: 'Boost detection timer',
         custom_popover_1865_long_description: 'Boost detection timeout',
         custom_popover_1866_long_description: 'Maximum boost position',
         // Manual Operation PopOver Long Description
         custom_popover_700_long_description: 'Manual Control enabled',
         custom_popover_701_long_description: 'MCV-1 Manual control',
         custom_popover_702_long_description: 'MCV-2 Manual control',
         custom_popover_703_long_description: 'Pump (P1) Manual control',
         custom_popover_704_long_description: 'Valve1',
         custom_popover_706_long_description: 'Heat demand status output',
         custom_popover_707_long_description: 'MCV-1 Manual control[%]',
         custom_popover_708_long_description: 'MCV-1 Manual control[%]',
         custom_popover_1801_long_description: 'Elektisch element TE-Booster',
         custom_popover_709_long_description: 'Manual control timeout',
         // API keys
         client_single_api_key_approve_api_key_label: 'API Key',
         client_single_api_key_app_id_label: 'App Id',
         client_single_api_key_approve_api_key_button: 'Approve Account',
         client_single_api_key_suspend_api_key_button: 'Suspend Application',
         client_single_api_key_unblock_application_button:
           'Unblock Application',
         client_single_api_key_generate_api_key_button: 'Generate API Key',
         client_single_api_key_generate_api_key_success:
           'API Key is Generated Successfully',
         client_single_api_key_generate_api_limit_error:
           'Sorry, we cannot regenerate a new API Key as regenerate limit is reached.',
         client_single_api_key_generate_api_kong_error:
           'kong API Alarm. Please contact Administrator.',
         client_single_api_application_suspend_success:
           'kong Application is suspended successfully',
         client_single_api_application_unblock_success:
           'kong Application is Unblocked successfully',
         client_single_api_application_suspend_error:
           'Application is already suspended',
         client_single_api_application_unblock_errpr:
           'Application is already unblocked',
         client_single_api_key_account_pending_approval:
           'Your account is not approved yet. Please contact Administrator for more details.',
         client_single_api_key_account_suspended:
           'Your account is suspended. Please contact Administrator for more details.',
         // Clients Form
         three_scale_temporary_password_subject:
           'Fortes Energy - kong Account Created',
         clients_form_password_field: 'Password',
         clients_password_required_form_error:
           'Password must contain atleast one alphabet of uppercase, number and special character',
         // Devices Form
         devices_form_mbus_meters_are_not_connected:
           'MBus Meters are not connected.',
         MBUS_METER_HEATING: 'Heat meter',
         MBUS_METER_COOLING: 'Cool meter',
         MBUS_METER_ELECTRICITY: 'Electricity meter',
         MBUS_METER_WATER: 'Water meter',
         MBUS_METER_BI_DIRECTIONAL: 'Heat/cool meter',
         meter_enabled: 'Enabled',
         meter_disabled: 'Disabled',
         devices_mbus_registers_toggle_register_status_success:
           'The message has been successfully sent to device.',
         MBUS_METER_SERIAL_NUMBER: 'Serial number',
         MBUS_METER_MANUFACTURER: 'Manufacturer',
         MBUS_METER_METER_TYPE: 'Meter type',
         MBUS_METER_STATUS: 'Status',
         MBUS_METER_FLOW: 'Flow',
         MBUS_METER_POWER: 'Power',
         MBUS_METER_SUPPLY_TEMPERATURE: 'Supply temperature',
         MBUS_METER_RETURN_TEMPERATURE: 'Return temperature',
         MBUS_METER_HEATING_ENERGY: 'Accumulated heating energy',
         MBUS_METER_ELECTRICITY_ENERGY: 'Accumulated Electricity',
         MBUS_METER_VOLUME: 'Accumulated volume',
         MBUS_METER_COOLING_ENERGY: 'Accumulated cooling energy',
         MBUS_METER_CURRENT: 'Current',
         custom_popover_MBUS_METER_SERIAL_NUMBER_short_description:
           'Serial number',
         custom_popover_MBUS_METER_MANUFACTURER_short_description:
           'Manufacturer',
         custom_popover_MBUS_METER_METER_TYPE_short_description: 'Meter type',
         custom_popover_MBUS_METER_STATUS_short_description: 'Status',
         custom_popover_MBUS_METER_FLOW_short_description: 'Flow',
         custom_popover_MBUS_METER_POWER_short_description: 'Power',
         custom_popover_MBUS_METER_SUPPLY_TEMPERATURE_short_description:
           'Supply temperature',
         custom_popover_MBUS_METER_RETURN_TEMPERATURE_short_description:
           'Return temperature',
         custom_popover_MBUS_METER_HEATING_ENERGY_short_description:
           'Accumulated heating energy',
         custom_popover_MBUS_METER_ELECTRICITY_ENERGY_short_description:
           'Accumulated Electricity',
         custom_popover_MBUS_METER_VOLUME_short_description:
           'Accumulated volume',
         custom_popover_MBUS_METER_COOLING_ENERGY_short_description:
           'Accumulated cooling energy',
         custom_popover_MBUS_METER_CURRENT_short_description: 'Current',
         // Device Set Logs Per Device
         device_single_device_registers_tab: 'Set Logs',
         device_single_device_registers_menu_list: JSON.stringify([
           {
             key: 'operating_state',
             value: 'Operating state',
             permission: 'operating-state-tab-read',
           },
         ]),
         device_status_interval: 'Interval',
         device_status_interval_in_seconds: 'Seconds',
         device_single_set_registers_error:
           'Please select atleast one register to proceed.',
         device_single_set_registers_success:
           'Message is successfully forwarded to the device.',
         device_single_set_register_form_interval_required_error:
           'Interval (seconds) are required',
         device_single_set_register_form_interval_numeric_error:
           'Interval (seconds) must be numeric',
         device_single_set_register_form_send_button: 'Send',
         device_single_set_register_form_cancel_button: 'Cancel',
         clients_kong_email_error: 'Email already exists in Kong',
         page_title_appending_title: ' | Fortes Data Management',
         project_single_device_registers_tab: 'Set Logs',
         audits_user: 'User',
         audits_system_generated: 'Application',
         device_single_project_set_registers_error:
           'Message is not forwarded because there are no devices linked with the project',
         audits_user_filter_label: 'User',
         audits_event_type_field: 'Event Type',
         audits_select_event_type_field: 'Select Event Type',
         audits_select_event_type_incoming_option: 'Incoming',
         audits_select_event_type_outgoing_option: 'Outgoing',
         audits_select_event_type_system_generated_option: 'Application',
         audits_table_loading: 'Loading Events',
         appliance_type_reference_table_appliance_name: 'Name',
         appliance_type_reference_table_appliance_type: 'Appliance Type',
         appliance_type_reference_table_updated_at: 'Updated At',
         sidebar_appliance_type_reference_menu: 'Appliance Types',
         appliance_types_register_form_send_button: 'Save',
         appliance_types_register_form_cancel_button: 'Cancel',
         appliance_types: 'Appliance Types',
         appliance_types_table_no_record_found: 'No record found',
         appliance_types_table_row_per_page: 'Rows per page',
         add_appliance_type: 'Add Appliance Type',
         add_appliance_types_form_header: 'Add Appliance Type',
         edit_appliance_types_form_header: 'Edit Appliance Type',
         appliance_types_add_new: 'Add new',
         appliance_type_form_name_label: 'Name',
         appliance_type_form_type_label: 'Appliance Type',
         appliance_type_form_select_type_label: 'Select Appliance Type',
         appliance_name_form_required_error: 'Name is required',
         appliance_type_form_required_error: 'Appliance Type is required',
         add_appliance_type_form_success:
           'Appliance Type record is created successfully',
         add_appliance_type_form_api_error: 'Internal Server Alarm',
         edit_appliance_type_form_success:
           'Appliance Type record is is updated successfully',
         edit_appliance_type_form_api_error: 'Internal Server Alarm',
         device_status_menu_list: JSON.stringify([
           {
             key: 'operating_state',
             value: 'Operating state',
             permission: 'operating-state-tab-read',
           },
           {
             key: 'settings_hot_water',
             value: 'Settings hot water',
             permission: 'settings-hot-water-tab-read',
           },
           {
             key: 'settings_heating_and_cooling',
             value: 'Settings heating and cooling',
             permission: 'settings-heating-and-cooling-tab-read',
           },
           {
             key: 'manual_control',
             value: 'Manual control',
             permission: 'manual-control-tab-read',
           },
           {
             key: 'firmware_registers',
             value: 'Firmware Registers',
             permission: 'firmware-registers-tab-read',
           },
           {
             key: 'lin_pump_delta_parameters',
             value: 'LIN-Pump DeltaP Parameters',
             permission: 'lin-pump-tab-read',
           },
           {
             key: 'm_bus_meters',
             value: 'Energy Meters (M-Bus)',
             permission: 'm-bus-meters-tab-read',
           },
           {
             key: 'live_hot_water',
             value: 'Livelog hot water',
             permission: 'livelog-hot-water-tab-read',
           },
           {
             key: 'live_heating',
             value: 'Livelog heating',
             permission: 'livelog-heating-tab-read',
           },
           {
             key: 'live_cooling',
             value: 'Livelog cooling',
             permission: 'livelog-cooling-tab-read',
           },
         ]),
         appliance_type_reference_table_filter_reset_button: 'Reset',
         appliance_type_reference_table_search: 'Search',
         appliance_type_reference_status_menu_list: JSON.stringify([
           {
             key: 'operating_state',
             value: 'Operating state',
             permission: 'operating-state-tab-read',
           },
           {
             key: 'settings_hot_water',
             value: 'Settings hot water',
             permission: 'settings-hot-water-tab-read',
           },
           {
             key: 'settings_heating_and_cooling',
             value: 'Settings heating and cooling',
             permission: 'settings-heating-and-cooling-tab-read',
           },
           {
             key: 'manual_control',
             value: 'Manual control',
             permission: 'manual-control-tab-read',
           },
           {
             key: 'firmware_registers',
             value: 'Firmware Registers',
             permission: 'firmware-registers-tab-read',
           },
           {
             key: 'lin_pump_delta_parameters',
             value: 'LIN-Pump DeltaP Parameters',
             permission: 'lin-pump-tab-read',
           },
         ]),
         audits_filter_button: 'Filters',
         device_single_no_registers_are_available:
           'Registers are not available',
         device_single_device_diagnostics_tab: 'Diagnostics',
         device_single_dp_measurement_back_button: 'Previous',
         device_single_diagnostic_next_button: 'Next',
         device_single_dp_measurement_start_button: 'Start',
         device_single_diagnostict_finish_button: 'Finish',
         device_single_diagnostic_stop_button: 'Stop',
         device_single_dp_measurement_refresh_button: 'Refresh',
         device_single_dp_measurement_event_logs_title: 'Output',
         device_single_dp_measurement_select_mbus_meter_button:
           'Select M-Bus Meter',
         device_single_dp_measurement_step_1_title:
           'Differential pressure calculation - Choose the flow',
         device_single_dp_measurement_pressure_difference_stepper_1_title:
           'Choose the flow',
         device_single_dp_measurement_step_1_flow_1_label:
           'Differential pressure calculation',
         device_single_dp_measurement_step_1_flow_2_label: 'Domestic hot water',
         device_single_dp_measurement_pressure_difference_step_2_title:
           'Differential pressure calculation - Explanation of the wizard',
         device_single_dp_measurement_pressure_difference_stepper_2_title:
           'Explanation of the wizard',
         device_single_dp_measurement_pressure_difference_step_2_description:
           'Available differential pressure is always an issue in collective networks. With the powerful combination of AquaHeat aflversets and the Fortes Data Management platform, you can easily perform a differential pressure calculation at any point in your collective network through a user-friendly module. This gives an excellent first indication of a possible cause. With this diagnosis we enable you to calculate an initial indication of the available pressure difference. <br /><br /><strong>Required: Heat meter must be connected to the Mercury Communication Module</strong>',
         device_single_dp_measurement_pressure_difference_step_3_title:
           'Differential pressure calculation - Controlling the right components',
         device_single_dp_measurement_pressure_difference_stepper_3_title:
           'Handbediening register',
         device_single_dp_measurement_step_3_pressure_difference_output_1:
           'Output 1 - Turning on the manual control',
         device_single_dp_measurement_pressure_difference_output_2:
           'Output 2 - Opening the control valve',
         device_single_dp_measurement_pressure_difference_step_3_mbus_meter_title:
           'Select M-Bus Meter (for multiple meters, it concerns the energy meter that registers the tap water.)',
         device_single_dp_measurement_pressure_difference_stepper_4_title:
           'Select the right M-Bus Meter',
         device_single_dp_measurement_pressure_difference_step_4_flow_label:
           'Flow',
         device_single_dp_measurement_pressure_difference_stepper_5_title:
           'Calculation of the differential pressur',
         device_single_dp_measurement_pressure_difference_output_3:
           'Output 3 - Select meter',
         device_single_dp_measurement_pressure_difference_output_4:
           'Output 4 - Calculation of the differential pressure',
         device_single_dp_measurement_pressure_difference_stepper_6_title:
           'Resultaat',
         device_single_dp_measurement_pressure_difference_step_6_description:
           'Your differential pressure is OK! No further actions are required. ',
         device_single_dp_measurement_download_button: 'Download resultaten',
         device_single_dp_measurement_pressure_difference_step_7_description:
           'De drukverschil berekening is succesvol afgerond.',
         device_single_general_title: 'General',
         device_single_hotwater_title: 'Domestic hot water',
         device_single_dp_measurement_hot_water_flow_1_stepper_1_title:
           'Kies flow',
         device_single_dp_measurement_hot_water_flow_1_stepper_2_title:
           'Uitleg van de wizard',
         device_single_dp_measurement_hot_water_flow_1_stepper_3_title:
           'Open Faucet',
         device_single_dp_measurement_hot_water_flow_1_stepper_4_title:
           'Checking Faucet and Hot water valve',
         device_single_dp_measurement_hot_water_flow_1_stepper_5_title:
           'MBus Meter',
         device_single_dp_measurement_hot_water_flow_1_stepper_6_title:
           'Calculation of Hot Water Flow',
         device_single_dp_measurement_hot_water_flow_1_stepper_7_title:
           'Results',
         device_single_dp_measurement_hot_water_flow_1_step_2_title:
           'DP Measurement - Explanation of Flow',
         device_single_dp_measurement_hot_water_flow_1_step_2_description:
           'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eu proin amet vitae etiam. In mauris habitasse turpis quis tortor, integer magna dictum condimentum. In pellentesque proin eu ut viverra quam. Consequat pharetra proin lacus, ultrices enim. Tincidunt porta tortor lacinia varius mattis pellentesque. In augue sit vitae leo sed. Nibh sed mi bibendum convallis viverra vestibulum pretium commodo. Nibh quam vulputate malesuada sodales. Curabitur nisl leo quis sed vitae cras. Tempor risus, a volutpat consequat eget faucibus nulla fermentum. Ut dignissim proin nulla et congue mattis. Euismod et ipsum quis habitant in enim viverra. Mattis varius quis arcu cras vestibulum nunc mattis consectetur in. Tempus mauris egestas elit malesuada ullamcorper aliquet cras adipiscing ',
         device_single_dp_measurement_hot_water_flow_1_step_3_title:
           'Open Faucet',
         device_single_dp_measurement_hot_water_flow_1_step_3_faucet_error:
           'Flow Sensor Defect',
         device_single_dp_measurement_hot_water_flow_1_step_3_faucet_error_one_try_left:
           'Try one more time',
         diagnostic_flows_form_open_faucet_title: 'Faucet is opened by client',
         diagnostic_flows_form_open_faucet_off_option_description:
           'Faucet is not opened by client',
         device_single_dp_measurement_hot_water_flow_1_output_1:
           'Output 1 - Hot Water State',
         device_single_dp_measurement_hot_water_flow_1_output_2:
           'Output 2 - Hot water valve (M1)',
         device_single_dp_measurement_hot_water_flow_1_step_3_mbus_meter_title:
           'Select MBus Meter',
         device_single_dp_measurement_hot_water_flow_1_step_4_flow_label:
           'Flow',
         device_single_dp_measurement_step_4_hot_water_flow_1_output_3:
           'Output 3 - Select Meter',
         device_single_dp_measurement_hot_water_flow_1_output_4:
           'Output 4 - Mbus Flow',
         device_single_dp_measurement_hot_water_flow_1_output_5:
           'Output 5 - Calculation of Hot Water Flow',
         device_single_dp_measurement_hot_water_flow_1_step_7_description:
           'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eu proin amet vitae etiam. In mauris habitasse turpis quis tortor, integer magna dictum condimentum. In pellentesque proin eu ut viverra quam. Consequat pharetra proin lacus, ultrices enim. Tincidunt porta tortor lacinia varius mattis pellentesque. In augue sit vitae leo sed. Nibh sed mi bibendum convallis viverra vestibulum pretium commodo. Nibh quam vulputate malesuada sodales. Curabitur nisl leo quis sed vitae cras. Tempor risus, a volutpat consequat eget faucibus nulla fermentum. Ut dignissim proin nulla et congue mattis. Euismod et ipsum quis habitant in enim viverra. Mattis varius quis arcu cras vestibulum nunc mattis consectetur in. Tempus mauris egestas elit malesuada ullamcorper aliquet cras adipiscing ',
         device_single_dp_measurement_hot_water_flow_1_step_8_description:
           'Hot Water - Flow 1 Diagnostics is finished',
         device_single_heating_title: 'Heating',
         device_single_dp_measurement_step_1_flow_3_label: 'Flow 1',
         device_single_cooling_title: 'Cooling',
         device_single_dp_measurement_step_1_flow_4_label: 'Flow 1',
         device_single_temperature_graph_loading_data: 'Loading graph',
         device_single_temperature_no_graph_data_error:
           'The graph is unavailable',
         device_graph_week_filter: 'W',
         device_graph_weeks_filter: 'W',
         device_graph_day_filter: 'D',
         device_graph_days_filter: 'D',
         device_graph_hours_filter: 'H',
         device_single_registers_table_numeric_error:
           'Only numeric values are allowed',
         device_single_registers_table_min_max_error:
           'Value must be between min_value and max_value',
         MBUS_METER_TYPE_WATER: 'Water',
         MBUS_METER_TYPE_ELECTRICITY: 'Electricity',
         MBUS_METER_TYPE_HEATING: 'Heat',
         MBUS_METER_TYPE_BIDIRECTIONAL: 'Heat/cool',
         MBUS_METER_TYPE_COOLING: 'Cooling',
         UNKNOWN_MANUFACTURER: 'Unknown manufacturer',
         commissioning_form_header: 'Commissioning',
         commissioning_form_serial_number_scan_button: 'Scan Mercurius',
         commissioning_form_heat_interface_unit_scan_button:
           'Scan Heat Interface Unit',
         commissioning_form_search_field: 'Serial number Mercurius',
         sidebar_commissioning_overview: 'Commissioning',
         sidebar_commissioning: 'Commissioning',
         commissioning_form_success: 'Device is updated successfully!',
         commissioning_error_message: 'Device Not Found',
         commissioning_device_submit_button: 'Update Device',
         swapping_form_header: 'Device Swapping',
         swapping_old_device_title: 'Old Device',
         swapping_new_device_title: 'New Device',
         swapping_form_scan_button: 'Scan',
         swapping_form_search_field: 'Serial number Mercurius',
         sidebar_swapping_overview: 'Device Swapping Overview',
         sidebar_swapping: 'Swapping',
         swapping_form_success: 'Device is swapped successfully!',
         swapping_old_device_error_message: 'Old device not found',
         swapping_new_device_error_message: 'New device not found',
         swapping_audit_message: 'Device is swapped',
         swapping_device_submit_button: 'Swap devices',
         email_device_swapping_subject: 'Device swapping',
         email_device_swapping_recipient_name: 'Fortes Data Management',
         email_device_swapping_title:
           'Fortes Data Management - Device Swapping',
         email_device_swapping_old_device_title: 'Old device',
         email_device_swapping_new_device_title: 'New device',
         email_device_swapped_by: 'Device swapped by:',
         swapping_device_unique_error: 'Device already exist',
         clear_device_form_header: 'Clear device',
         clear_device_form_scan_button: 'Scan',
         clear_device_form_search_field: 'Serial number Mercurius',
         sidebar_clear_device_overview: 'Clear device',
         sidebar_clear_device: 'Clear device',
         clear_device_form_success: 'Device is successfully cleared!',
         clear_device_error_message: 'Device not found',
         clear_device_submit_button: 'Clear device',
         clear_device_audit_message: 'Device is cleared',
         device_single_swapped_devices_tab: 'Swapped devices',
         devices_single_swapped_old_device_name: 'Swapped From (Old)',
         devices_single_swapped_device_old_firmware: 'Old Firmware',
         devices_single_swapped_device_new_firmware: 'New Firmware',
         devices_single_swapped_old_device_type: 'Old Device type',
         devices_single_swapped_new_device_type: 'New Device Type',
         devices_single_swapped_device_old_box_serial_number:
           'Old Serial number HIU',
         devices_single_swapped_device_new_box_serial_number:
           'Serial number HIU',
         devices_single_swapped_device_old_sim_card_number: 'Old Sim Number',
         devices_single_swapped_device_new_sim_card_number: 'New Sim Number',
         devices_single_swapped_device_created_at: 'Swapped Date',
         devices_single_swapped_device_name_search: 'Search',
         devices_single_swapped_new_device_name: 'Swapped To (New)',
         devices_single_swapped_device_table_no_record_found: 'No record found',
         devices_single_swapped_device_table_loading: 'Loading',
         devices_single_swapped_device_table_row_per_page: 'Rows per page',
         sidebar_swapped_devices_overview: 'Swapped devices overview',
         sidebar_swapped_devices: 'Swapped devices',
         swapped_devices_form_header: 'Swapped devices',
         devices_bulk_edit_registers_form_no_devices_error:
           'Please select devices to proceed.',
         devices_bulk_edit_firmware_modal_title:
           'Are you sure you want to run a bulk update?',
         devices_bulk_edit_firmware_modal_subtitle:
           'You want to Bulk Update Firmware version ##firmware_value## for ##total_devices## devices?',
         devices_bulk_edit_registers_modal_title:
           'Are you sure you want to run a bulk update?',
         devices_bulk_edit_registers_modal_subtitle:
           'You want to Bulk Update Registers for ##total_devices## devices?',
         devices_bulk_edit_registers_modal_cancel_button: 'Cancel',
         devices_bulk_edit_registers_modal_submit_button: 'Confirm',
         devices_bulk_edit_firmware_modal_cancel_button: 'Cancel',
         devices_bulk_edit_firmware_modal_submit_button: 'Confirm',
         devices_bulk_export_button: 'Export Devices',
         projects_bulk_export_button: 'Export Projects',
         project_devices_bulk_export_button: 'Export Projects',
         devices_bulk_export_file_name: 'Device Bulk Export',
         projects_bulk_export_file_name: 'Project Bulk Export',
         project_devices_bulk_export_file_name: 'Device Bulk Export',
         sidebar_reporting_overview: 'Reporting',
         sidebar_bulk_edit_ota_reporting: 'OTA Report',
         sidebar_bulk_reporting_registers_table_title: 'Registers Report',
         edit_ota_reporting: 'OTA Audit',
         reporting_ota_bulk_export_button: 'Export',
         reporting_ota_filter_reset_button: 'Reset',
         reporting_ota_table_filter_search: 'Search',
         reporting_ota_table_updated_at: 'Date',
         reporting_ota_table_total_devices: 'Total devices',
         reporting_ota_table_user: 'User',
         reporting_ota_table_message: 'Message',
         reporting_ota_table_no_record_found: 'No record found',
         reporting_ota_table_row_per_page: 'Rows per page',
         edit_ota_reporting_details: 'OTA Audit Details',
         reporting_ota_details_all_tab: 'All',
         reporting_ota_details_pending_tab: 'Pending',
         reporting_ota_details_success_tab: 'Success',
         reporting_ota_details_failure_tab: 'Failed',
         reporting_ota_details_bulk_export_button: 'Export',
         reporting_ota_details_filter_reset_button: 'Reset',
         reporting_ota_details_table_filter_search: 'Search',
         reporting_ota_details_message: 'Firmware version updated to',
         reporting_ota_details_table_created_at: 'Date',
         reporting_ota_details_table_device: 'Device',
         reporting_ota_details_table_user: 'User',
         reporting_ota_details_table_old_firmware_version:
           'Old Firmware Version',
         reporting_ota_details_table_current_firmware_version:
           'Current Firmware Version',
         reporting_ota_details_table_current_status: 'Status',
         reporting_ota_details_table_message: 'Message',
         reporting_ota_details_table_no_record_found: 'No record found',
         reporting_ota_details_table_row_per_page: 'Rows Per Page',
         reporting_ota_bulk_export_file_name: 'Bulk OTA Reporting',
         reporting_ota_details_bulk_export_file_name:
           'Bulk OTA Details Reporting',
         devices_single_swapped_bulk_export_button_file_name:
           'Swapped Devices Reporting',
         devices_single_swapped_bulk_export_button: 'Export',
         reporting_registers_table_title: 'Registers Audit',
         reporting_registers_table_created_at: 'Date',
         reporting_registers_table_total_devices: 'Total devices',
         reporting_registers_table_user: 'User',
         reporting_registers_table_message: 'Message',
         reporting_registers_bulk_export_button: 'Export',
         reporting_registers_filter_reset_button: 'Reset',
         reporting_registers_table_filter_search: 'Search',
         reporting_registers_table_no_record_found: 'No record found',
         reporting_registers_table_row_per_page: 'Rows Per Page',
         reporting_registers_table_bulk_export_file_name:
           'Bulk Registers Reporting',
         registers_reporting_details_title: 'Registers Audit Details',
         reporting_registers_details_bulk_export_button: 'Export',
         reporting_registers_details_filter_reset_button: 'Reset',
         reporting_registers_details_table_filter_search: 'Search',
         reporting_registers_details_table_created_at: 'Date',
         reporting_registers_details_table_device: 'Device',
         reporting_registers_details_table_user: 'User',
         reporting_registers_details_table_message: 'Message',
         reporting_registers_details_table_failed_message:
           'Firmware version is not updated to',
         reporting_registers_details_table_pending_message:
           'Firmware version updating to',
         reporting_registers_details_table_successful_message:
           'Firmware version updated to',
         reporting_registers_details_table_no_record_found: 'No record found',
         reporting_registers_details_table_row_per_page: 'Rows Per Page',
         reporting_registers_details_bulk_export_file_name:
           'Bulk Registers Details Reporting',
         devices_bulk_edit_ota_form_firmware_field_select_label:
           'Select Firmware',
         dashboard_users_overview: 'Users Overview',
         dashboard_users_title: 'Users',
         dashboard_devices_overview: 'Devices Overview',
         dashboard_devices_title: 'Devices',
         dashboard_commissioning_overview: 'Commissioning overview',
         dashboard_commissioning_title: 'Commissioning',
         devices_filters: 'Filters:',
         devices_submit_button: 'Submit',
         device_single_device_documentation_tab: 'Docs',
         device_single_documentation_brochure_button: 'Brochure',
         device_single_documentation_installation_manual_button:
           'Installation Manual',
         device_single_documentation_dimensional_drawing_button:
           'Dimensional Drawing',
         device_single_documentation_parts_drawing_button: 'Parts Drawing',
         device_single_documentation_flow_direction_button: 'Flow Direction',
         device_single_documentation_principle_diagram_button:
           'Principle Diagram',
         device_single_documentation_information_end_user_button:
           'Information End User',
         device_single_documentation_malfunction_key_button: 'Malfunction Key',
         reporting_ota_failed_message: 'Firmware version is not updated to',
         reporting_ota_pending_message: 'Firmware version updating to',
         reporting_ota_successful_message: 'Firmware version updated to',
         ota_pending: 'Pending',
         ota_success: 'Successful',
         ota_failed: 'Failed',
         clear_devices_modal_title: 'Clear Device',
         clear_devices_modal_subtitle:
           'Are you you want to clear this device with serial number <strong>##serial_number##</strong>',
         clear_devices_modal_cancel_button: 'Cancel',
         clear_devices_modal_submit_button: 'Clear Device',
         sidebar_fortes_roles: 'Roles',
         sidebar_fortes_permissions: 'Permissions',
         roles_all: 'All',
         roles_active: 'Active',
         roles_inactive: 'InActive',
         roles_filter_delete_button: 'Delete',
         roles_table_identifier: 'Identifier',
         roles_table_name_en: 'Name (EN)',
         roles_table_name_nl: 'Name (NL)',
         roles_table_description_en: 'Description (EN)',
         roles_table_description_nl: 'Description (NL)',
         roles_table_status: 'Status',
         roles_table_updated_at: 'Updated At',
         roles_filter_search: 'Search',
         roles_no_record_found: 'No Record Found',
         roles_table_row_per_page: 'Rows Per Page',
         roles_bulk_no_record_is_selected_error_message:
           'Please select records for bulk de-activation.',
         roles_deactivated_message: 'Role is deactivated successfully',
         roles_activated_message: 'Role is activated successfully',
         roles_bulk_deactivated_message:
           '##ROLES_COUNT## Roles are deactivated successfully',
         roles_title: 'Roles',
         roles_add_new: 'Add New',
         roles_bread_crumb_main_title: 'Roles',
         add_roles_bread_crumb_first_link: 'Add Role',
         edit_roles_bread_crumb_first_link: 'Edit Role',
         add_roles_form_header: 'Add Role',
         edit_roles_form_header: 'Edit Role',
         roles_form_role_identifier_field: 'Identifier',
         roles_identifier_required_form_error: 'Identifier is required',
         roles_form_api_error: 'Internal Server Alarm',
         roles_form_unqiue_role_name_error: 'Identifer must be unique',
         roles_form_api_forbidden: 'User has no permissions to create role',
         roles_add_form_success: 'Role is created successfully',
         roles_edit_form_success: 'Role is updated successfully',
         roles_form_add_role_button: 'Add Role',
         roles_form_edit_role_button: 'Edit Role',
         roles_form_cancel_button: 'Cancel',
         roles_form_permissions_title: 'Permissions',
         sidebar_fortes_modules: 'Modules',
         modules_all: 'All',
         modules_active: 'Active',
         modules_inactive: 'InActive',
         modules_filter_delete_button: 'Delete',
         modules_table_identifier: 'Identifier',
         modules_table_name_en: 'Name (EN)',
         modules_table_name_nl: 'Name (NL)',
         modules_table_description_en: 'Description (EN)',
         modules_table_description_nl: 'Description (NL)',
         modules_table_status: 'Status',
         modules_table_updated_at: 'Updated At',
         modules_filter_search: 'Search',
         modules_no_record_found: 'No Record Found',
         modules_table_row_per_page: 'Rows Per Page',
         modules_bulk_no_record_is_selected_error_message:
           'Please select records for bulk de-activation.',
         modules_deactivated_message: 'Module is deactivated successfully',
         modules_activated_message: 'Module is activated successfully',
         modules_bulk_deactivated_message:
           '##MODULES_COUNT## Modules are deactivated successfully',
         modules_title: 'Modules',
         modules_add_new: 'Add New',
         modules_bread_crumb_main_title: 'Modules',
         add_modules_bread_crumb_first_link: 'Add Module',
         edit_modules_bread_crumb_first_link: 'Edit Module',
         add_modules_form_header: 'Add Module',
         edit_modules_form_header: 'Edit Module',
         modules_form_module_identifier_field: 'Identifier',
         modules_identifier_required_form_error: 'Identifier is required',
         modules_form_module_name_en_field: 'Name (EN)',
         modules_form_module_name_nl_field: 'Name (NL)',
         modules_name_en_required_form_error: 'Name (EN) is required',
         modules_name_nl_required_form_error: 'Name (NL) is required',
         modules_form_description_en_field: 'Description (EN)',
         modules_form_description_nl_field: 'Description (NL)',
         modules_form_api_error: 'Internal Server Alarm',
         modules_form_unqiue_module_name_error: 'Identifer must be unique',
         modules_form_api_forbidden: 'User has no permissions to create module',
         modules_add_form_success: 'Module is created successfully',
         modules_edit_form_success: 'Module is updated successfully',
         modules_form_add_module_button: 'Add Module',
         modules_form_edit_module_button: 'Edit Module',
         modules_form_cancel_button: 'Cancel',
         permissions_all: 'All',
         permissions_active: 'Active',
         permissions_inactive: 'Inactive',
         permissions_filter_delete_button: 'Delete',
         permissions_table_identifier: 'Identifier',
         permissions_table_module_name: 'Module',
         permissions_table_name_en: 'Name (EN)',
         permissions_table_name_nl: 'Name (NL)',
         permissions_table_description_en: 'Description (EN)',
         permissions_table_description_nl: 'Description (NL)',
         permissions_table_status: 'Status',
         permissions_filter_search: 'Search',
         permissions_no_record_found: 'No Record Found',
         permissions_table_row_per_page: 'Rows Per Page',
         permissions_bulk_no_record_is_selected_error_message:
           'Please select records for bulk de-activation.',
         permissions_deactivated_message:
           'Permission is deactivated successfully',
         permissions_activated_message: 'Permission is activated successfully',
         permissions_bulk_deactivated_message:
           '##PERMISSIONS_COUNT## Permissions are deactivated successfully',
         permissions_title: 'Permissions',
         permissions_add_new: 'Add New',
         permissions_bread_crumb_main_title: 'Permissions',
         add_permissions_bread_crumb_first_link: 'Add Permission',
         edit_permissions_bread_crumb_first_link: 'Edit Permission',
         edit_permissions_form_header: 'Edit Permission',
         add_permissions_form_header: 'Add Permission',
         permissions_form_permission_identifier_field: 'Identifier',
         permissions_form_permission_module_field: 'Module',
         permissions_form_permission_select_module_field: 'Select Module',
         permissions_module_required_form_error: 'Module is required',
         permissions_identifier_required_form_error: 'Identifier is required',
         permissions_form_permission_name_en_field: 'Name (EN)',
         permissions_form_permission_name_nl_field: 'Name (NL)',
         permissions_form_permission_sub_module_field: 'Sub Module',
         permissions_form_permission_select_sub_module_field:
           'Select Sub Module',
         permissions_sub_module_required_form_error: 'Sub Module is required',
         permissions_name_required_form_error: 'Name is required',
         permissions_form_description_en_field: 'Description (EN)',
         permissions_form_description_nl_field: 'Description (NL)',
         permissions_form_api_error: 'Internal Server Alarm',
         permissions_form_unqiue_permission_name_error:
           'Identifer must be unique',
         permissions_edit_form_success: 'Client is updated successfully!',
         permissions_form_api_forbidden:
           'User has no permissions to create permission',
         permissions_add_form_success: 'Permission is created successfully',
         permissions_form_add_permission_button: 'Add Permission',
         permissions_form_edit_permission_button: 'Edit Permission',
         permissions_form_cancel_button: 'Cancel',
         permissions_read: 'Read',
         permissions_create: 'Create',
         permissions_update: 'Update',
         permissions_delete: 'Delete',
         permissions_status: 'Toggle Status',
         permissions_get_all: 'Get All',
         permissions_get_by_id: 'Get By Id',
         permissions_bulk_deactivate: 'Bulk De-activate',
         permissions_form_title: 'Permissions',
         duplicate_roles_form_header: 'Duplicate Role',
         duplicate_roles_bread_crumb_first_link: 'Duplicate Role',
         roles_duplicate_form_success: 'Role is duplicated successfully',
         roles_filter_duplicate_button: 'Duplicate Role',
         roles_pre_identifier_required_form_error: 'Pre Identifier is required',
         roles_form_pre_identifier_field: 'Pre Identifier',
         roles_form_pre_identifier_select: 'Select Pre Identifier',
         duplicate_roles_identifier_message:
           '<ul style="margin: "0", padding-left: 15px"> <li>For new client role always start the identifier with client_</li> <li>For new sub client role always start the identifier with service_client_</li> <li>For new fortes role always start the identifier with fortes_</li> </ul>',
         devices_single_device_counters_title: 'Device Counters',
         devices_single_device_counters_offline_counter: 'Offline Counter',
         devices_single_device_counters_online_counter: 'Online Counter',
         devices_single_device_counters_ota_fail_counter: 'OTA Fail Counter',
         devices_single_device_counters_ota_update_counter:
           'OTA Update Counter',
         devices_single_device_counters_mbus_error_counter:
           'MBus alarm counter',
         devices_single_device_counters_modbus_error_counter:
           'Modbus alarm counter',
         devices_single_device_docs_directory: 'Directories',
         device_single_documentation_no_documents_found: 'No Documents Found',
         reporting_registers_details_table_registers_pending:
           'Pending Registers',
         reporting_registers_details_table_registers_updated_fail:
           'Failed Registers',
         reporting_registers_details_table_registers_updated_successful:
           'Successful Registers',
         reporting_registers_details_table_status: 'Status',
         reporting_ota_message: 'Update Firmware version to',
         devices_bulk_edit_registers_form_fix_register_values_error:
           'Please fix the alarms  in all tabs',
         login_permission_error:
           'Please get appropriate permissions from Fortes Administrator',
         monitoring_title: 'Monitoring',
         monitoring_vm_title: 'Virtual Machine',
         monitoring_ram_title: 'RAM',
         monitoring_cpu_title: 'CPU',
         monitoring_disk_title: 'Disk',
         monitoring_restarts_title: 'Restarts',
         monitoring_uptime_title: 'Uptime',
         monitoring_services_title: 'Services',
         monitoring_service_table_service_name: 'Name',
         monitoring_service_table_service_status: 'Status',
         devices_form_service_client_field: 'Service client',
         sidebar_kong_users: 'Kong Client Users',
         kong_users_title: 'Kong Client Users',
         kong_users_table_name: 'Name',
         kong_users_table_email: 'Email',
         kong_users_table_client: 'Client',
         kong_users_table_updated_at: 'Updated At',
         kong_users_bread_crumb_main_title: 'Kong Client Users',
         add_kong_users_bread_crumb_first_link: 'Add Kong Client User',
         add_kong_users_form_header: 'Add Kong Client User',
         kong_users_form_name_field: 'Name',
         kong_users_form_email_field: 'Email Address',
         kong_users_form_client_field: 'Client',
         kong_users_form_password_field: 'Password',
         kong_users_name_required_form_error: 'Name is required',
         kong_users_email_valid_form_error: 'Must be a valid email',
         kong_users_email_required_form_error: 'Email is required',
         kong_users_client_required_form_error: 'Client is required',
         kong_users_password_required_form_error:
           'Password must contain at least 8 characters with at least one uppercase letter, at least one number and at least one special character.',
         kong_users_no_record_found: 'No Records Found',
         kong_users_table_row_per_page: 'Rows Per Page',
         kong_users_add_new: 'Add Kong Client User',
         kong_users_filter_search: 'Search',
         kong_user_single_first_bread_crumb: 'Kong Client Users',
         kong_user_single_second_bread_crumb: 'View Kong Client Users',
         kong_user_single_apis_tab: 'API Keys',
         kong_user_single_edit_button_label: 'Edit',
         kong_user_single_user_label: 'User',
         kong_user_single_email_label: 'Email',
         kong_user_single_client_label: 'Client',
         edit_kong_users_form_header: 'Edit Kong Client User',
         edit_kong_users_bread_crumb_first_link: 'Edit Kong Client User',
         device_single_temperature_start_date: 'Start Date',
         device_single_temperature_end_date: 'End Date',
         device_single_temperature_start_date_error:
           'Start Date must be less than or equal to End Date',
         sidebar_kong_admins: 'Kong Admin Users',
         kong_user_admins_title: 'Kong Admin Users',
         kong_user_admins_table_name: 'Name',
         kong_user_admins_table_email: 'Email',
         kong_user_admins_table_updated_at: 'Updated At',
         kong_user_admins_bread_crumb_main_title: 'Kong Admin Users',
         add_kong_user_admins_bread_crumb_first_link: 'Add Kong Admin User',
         add_kong_user_admins_form_header: 'Add Kong Admin User',
         kong_user_admins_form_name_field: 'Name',
         kong_user_admins_form_email_field: 'Email Address',
         kong_user_admins_form_client_field: 'Admin',
         kong_user_admins_form_password_field: 'Password',
         kong_user_admins_name_required_form_error: 'Name is required',
         kong_user_admins_email_valid_form_error: 'Must be a valid email',
         kong_user_admins_email_required_form_error: 'Email is required',
         kong_user_admins_password_required_form_error:
           'Password must contain at least 8 characters with at least one uppercase letter, at least one number and at least one special character.',
         kong_user_admins_no_record_found: 'No Records Found',
         kong_user_admins_table_row_per_page: 'Rows Per Page',
         kong_user_admins_add_new: 'Add Kong Admin User',
         kong_user_admins_filter_search: 'Search',
         kong_user_admin_single_first_bread_crumb: 'Kong Admin Users',
         kong_user_admin_single_second_bread_crumb: 'View Kong Admin Users',
         kong_user_admin_single_apis_tab: 'API Keys',
         kong_user_admin_single_edit_button_label: 'Edit',
         kong_user_admin_single_user_label: 'User',
         kong_user_admin_single_email_label: 'Email',
         edit_kong_user_admins_form_header: 'Edit Kong Admin User',
         edit_kong_user_admins_bread_crumb_first_link: 'Edit Kong Admin User',
         projects_project_order_number_required_form_error:
           'Project Order Number is required',
         projects_form_project_order_number_field: 'Project Order Number',
         client_error_single_device_address: 'Installation address',
         navbar_notification_mark_all_as_read: 'Mark all as read',
         navbar_notification_view_all: 'View All',
         notifications_title: 'Notifications',
         notifications_all: 'All',
         notifications_unread: 'Unread',
         notifications_read: 'Read',
         notifications_table_title: 'Title (EN)',
         notifications_table_description: 'Description (EN)',
         notifications_table_notification_type: 'Notification Type',
         notifications_table_notification_category: 'Notification Category',
         notifications_table_date: 'Date',
         notifications_filter_search: 'Search',
         notifications_no_record_found: 'No Records Found',
         notifications_table_row_per_page: 'Rows per page',
         add_notifications_form_header: 'Add Notification',
         notifications_title_en_required_form_error: 'Title (EN) is required',
         notifications_title_nl_required_form_error: 'Title (NL) is required',
         notifications_description_en_required_form_error:
           'Description (EN) is required',
         notifications_description_nl_required_form_error:
           'Description (NL) is required',
         notifications_form_notification_type_field: 'Notification Type',
         notifications_notification_type_required_form_error:
           'Notification Type is required',
         notifications_form_notification_category_field:
           'Notification Category',
         notifications_notification_category_required_form_error:
           'Notification Category is required',
         notifications_form_title_en_field: 'Title (EN)',
         notifications_form_title_nl_field: 'Title (NL)',
         notifications_form_start_date_field: 'Start Date',
         notifications_form_end_date_field: 'End Date',
         notifications_form_description_en_field: 'Description (EN)',
         notifications_form_description_nl_field: 'Description (NL)',
         notifications_form_add_button: 'Add Notification',
         notifications_form_edit_button: 'Edit Notification',
         notifications_form_cancel_button: 'Cancel',
         notifications_add_form_success: 'Notification is added successfully',
         notifications_form_api_error: 'Internal Server Alarm',
         notification_type_information: 'Information',
         notification_type_warning: 'Warning',
         notification_category_simple: 'Simple',
         notification_category_timebased: 'Timebased',
         edit_notifications_form_header: 'Edit Notification',
         sidebar_notification_menu: 'Notifications',
         pop_over_close_button: 'Close',
         docs_user_type_end_user: 'End User',
         docs_user_type_installer: 'Installer',
         devices_single_device_docs_no_directory_found: 'No Directories Found',
         device_single_status_tab: 'Visuals',
         device_single_status_picture_tab: 'Picture',
         device_single_status_principle_tab: 'Principle',
         device_single_status_table_loading: 'Loading ...',
         device_single_status_mbus_export_button: 'Export',
         device_single_status_mbus_date_range_filter_label: 'Date Range',
         device_single_status_mbus_date_export_label: 'Date',
         device_single_status_mbus_time_export_label: 'Time',
         device_single_status_mbus_port_export_label: 'Port',
         device_single_status_mbus_meter_connected_at_export_label:
           'Meter Connected At',
         device_single_status_mbus_meter_status_export_label: 'Meter Status',
         device_single_status_mbus_meter_type_export_label: 'Meter Type',
         device_single_status_mbus_select_meter_type_export_label:
           'Select Meter Type',
         device_single_status_mbus_select_meter_type_error:
           'Meter Type is missing',
         device_single_status_mbus_export_internal_server_error:
           'Internal Server Alarm',
         device_single_status_mbus_export_no_data_found_error:
           'No record found',
         sidebar_diagnostic_formulas: 'Diagnostic Formulas',
         diagnostic_formulas_all: 'All',
         diagnostic_formulas_active: 'Active',
         diagnostic_formulas_inactive: 'InActive',
         diagnostic_formulas_filter_delete_button: 'Delete',
         diagnostic_formulas_table_identifier: 'Identifier',
         diagnostic_formulas_table_name_en: 'Name (EN)',
         diagnostic_formulas_table_name_nl: 'Name (NL)',
         diagnostic_formulas_table_description_en: 'Description (EN)',
         diagnostic_formulas_table_description_nl: 'Description (NL)',
         diagnostic_formulas_table_formula: 'Formula',
         diagnostic_formulas_table_status: 'Status',
         diagnostic_formulas_table_updated_at: 'Updated At',
         diagnostic_formulas_filter_search: 'Search',
         diagnostic_formulas_no_record_found: 'No Record Found',
         diagnostic_formulas_table_row_per_page: 'Rows Per Page',
         diagnostic_formulas_bulk_no_record_is_selected_error_message:
           'Please select records for bulk de-activation.',
         diagnostic_formulas_deactivated_message:
           'Diagnostic is deactivated successfully',
         diagnostic_formulas_activated_message:
           'Diagnostic is activated successfully',
         diagnostic_formulas_bulk_deactivated_message:
           '##DIAGNOSTICS_COUNT## Diagnostics are deactivated successfully',
         diagnostic_formulas_title: 'Diagnostics Formulas',
         diagnostic_formulas_add_new: 'Add New',
         diagnostic_formulas_bread_crumb_main_title: 'Diagnostic Formulas',
         add_diagnostic_formulas_bread_crumb_first_link:
           'Add Diagnostic Formulas',
         edit_diagnostic_formulas_bread_crumb_first_link:
           'Edit Diagnostic Formulas',
         add_diagnostic_formulas_form_header: 'Add Diagnostic Formulas',
         edit_diagnostic_formulas_form_header: 'Edit Diagnostic Formulas',
         diagnostic_formulas_form_diagnostic_formulas_identifier_field:
           'Identifier',
         diagnostic_formulas_identifier_required_form_error:
           'Identifier is required',
         diagnostic_formulas_form_diagnostic_formulas_name_en_field:
           'Name (EN)',
         diagnostic_formulas_form_diagnostic_formulas_name_nl_field:
           'Name (NL)',
         diagnostic_formulas_name_en_required_form_error:
           'Name (EN) is required',
         diagnostic_formulas_name_nl_required_form_error:
           'Name (NL) is required',
         diagnostic_formulas_formula_required_form_error: 'Formula is required',
         diagnostic_formulas_form_description_en_field: 'Description (EN)',
         diagnostic_formulas_form_description_nl_field: 'Description (NL)',
         diagnostic_formulas_form_forumla_field: 'Formula',
         diagnostic_formulas_form_api_error: 'Internal Server Alarm',
         diagnostic_formulas_form_unqiue_diagnostic_formulas_name_error:
           'Identifer must be unique',
         diagnostic_formulas_form_api_forbidden:
           'User has no permissions to create diagnostic_formulas',
         diagnostic_formulas_add_form_success:
           'Diagnostic is created successfully',
         diagnostic_formulas_edit_form_success:
           'Diagnostic is updated successfully',
         diagnostic_formulas_form_add_diagnostic_formulas_button:
           'Add Diagnostic',
         diagnostic_formulas_form_edit_diagnostic_formulas_button:
           'Edit Diagnostic',
         diagnostic_formulas_form_cancel_button: 'Cancel',
         sidebar_diagnostic_categories: 'Diagnostic Categories',
         diagnostic_categories_all: 'All',
         diagnostic_categories_active: 'Active',
         diagnostic_categories_inactive: 'InActive',
         diagnostic_categories_filter_delete_button: 'Delete',
         diagnostic_categories_table_identifier: 'Identifier',
         diagnostic_categories_table_name_en: 'Name (EN)',
         diagnostic_categories_table_name_nl: 'Name (NL)',
         diagnostic_categories_table_description_en: 'Description (EN)',
         diagnostic_categories_table_description_nl: 'Description (NL)',
         diagnostic_categories_table_status: 'Status',
         diagnostic_categories_table_updated_at: 'Updated At',
         diagnostic_categories_filter_search: 'Search',
         diagnostic_categories_no_record_found: 'No Record Found',
         diagnostic_categories_table_row_per_page: 'Rows Per Page',
         diagnostic_categories_bulk_no_record_is_selected_error_message:
           'Please select records for bulk de-activation.',
         diagnostic_categories_deactivated_message:
           'Category is deactivated successfully',
         diagnostic_categories_activated_message:
           'Category is activated successfully',
         diagnostic_categories_bulk_deactivated_message:
           '##DIAGNOSTICS_COUNT## Categories are deactivated successfully',
         diagnostic_categories_title: 'Diagnostic Categories',
         diagnostic_categories_add_new: 'Add New',
         diagnostic_categories_bread_crumb_main_title: 'Diagnostic Categories',
         add_diagnostic_categories_bread_crumb_first_link:
           'Add Diagnostic Category',
         edit_diagnostic_categories_bread_crumb_first_link:
           'Edit Diagnostic Category',
         add_diagnostic_categories_form_header: 'Add Diagnostic Category',
         edit_diagnostic_categories_form_header: 'Edit Diagnostic Category',
         diagnostic_categories_form_diagnostic_categories_identifier_field:
           'Identifier',
         diagnostic_categories_identifier_required_form_error:
           'Identifier is required',
         diagnostic_categories_form_diagnostic_categories_name_en_field:
           'Name (EN)',
         diagnostic_categories_form_diagnostic_categories_name_nl_field:
           'Name (NL)',
         diagnostic_categories_name_en_required_form_error:
           'Name (EN) is required',
         diagnostic_categories_name_nl_required_form_error:
           'Name (NL) is required',
         diagnostic_categories_form_description_en_field: 'Description (EN)',
         diagnostic_categories_form_description_nl_field: 'Description (NL)',
         diagnostic_categories_form_api_error: 'Internal Server Alarm',
         diagnostic_categories_form_unqiue_diagnostic_categories_name_error:
           'Identifer must be unique',
         diagnostic_categories_form_api_forbidden:
           'User has no permissions to create diagnostic_categories',
         diagnostic_categories_add_form_success:
           'Category is created successfully',
         diagnostic_categories_edit_form_success:
           'Category is updated successfully',
         diagnostic_categories_form_add_diagnostic_categories_button:
           'Add Category',
         diagnostic_categories_form_edit_diagnostic_categories_button:
           'Edit Category',
         diagnostic_categories_form_cancel_button: 'Cancel',
         sidebar_diagnostics_overview: 'Diagnostics',
         sidebar_firmware_menu: 'Firmware',
         firmwares_all: 'All',
         firmwares_active: 'Active',
         firmwares_inactive: 'InActive',
         firmwares_table_identifier: 'Identifier',
         firmwares_table_name_en: 'Name (EN)',
         firmwares_table_name_nl: 'Name (NL)',
         firmwares_table_firmware: 'Firmware',
         firmwares_table_status: 'Status',
         firmwares_table_updated_at: 'Updated At',
         firmwares_filter_search: 'Search',
         firmwares_no_record_found: 'No Record Found',
         firmwares_table_row_per_page: 'Rows Per Page',
         firmwares_bulk_no_record_is_selected_error_message:
           'Please select records for bulk de-activation.',
         firmwares_deactivated_message: 'Firmware is deactivated successfully',
         firmwares_activated_message: 'Firmware is activated successfully',
         firmwares_title: 'Firmware',
         firmwares_add_new: 'Add New',
         firmwares_bread_crumb_main_title: 'Firmware',
         add_firmwares_bread_crumb_first_link: 'Add Firmware',
         edit_firmwares_bread_crumb_first_link: 'Edit Firmware',
         add_firmwares_form_header: 'Add Firmware',
         edit_firmwares_form_header: 'Edit Firmware',
         firmwares_form_firmware_identifier_field: 'Identifier',
         firmwares_identifier_required_form_error: 'Identifier is required',
         firmwares_form_firmware_name_en_field: 'Name (EN)',
         firmwares_form_firmware_name_nl_field: 'Name (NL)',
         firmwares_form_firmware_firmware_field: 'Firmware',
         firmwares_name_en_required_form_error: 'Name (EN) is required',
         firmwares_name_nl_required_form_error: 'Name (NL) is required',
         firmwares_form_description_en_field: 'Description (EN)',
         firmwares_form_description_nl_field: 'Description (NL)',
         firmwares_form_api_error: 'Internal Server Alarm',
         firmwares_form_unqiue_firmware_name_error: 'Identifer must be unique',
         firmwares_form_api_forbidden:
           'User has no permissions to create firmware',
         firmwares_add_form_success: 'Firmware is created successfully',
         firmwares_edit_form_success: 'Firmware is updated successfully',
         firmwares_form_edit_firmware_button: 'Edit Firmware',
         firmwares_form_cancel_button: 'Cancel',
         diagnostic_flows_all: 'All',
         diagnostic_flows_active: 'Active',
         diagnostic_flows_inactive: 'InActive',
         diagnostic_flows_filter_delete_button: 'Delete',
         diagnostic_flows_table_identifier: 'Identifier',
         diagnostic_flows_table_category: 'Category',
         diagnostic_flows_table_name_en: 'Name (EN)',
         diagnostic_flows_table_name_nl: 'Name (NL)',
         diagnostic_flows_table_description_en: 'Description (EN)',
         diagnostic_flows_table_description_nl: 'Description (NL)',
         diagnostic_flows_table_status: 'Status',
         diagnostic_flows_table_updated_at: 'Updated At',
         diagnostic_flows_filter_search: 'Search',
         diagnostic_flows_no_record_found: 'No Record Found',
         diagnostic_flows_table_row_per_page: 'Rows Per Page',
         diagnostic_flows_bulk_no_record_is_selected_error_message:
           'Please select records for bulk de-activation.',
         diagnostic_flows_deactivated_message:
           'Flow is deactivated successfully',
         diagnostic_flows_activated_message: 'Flow is activated successfully',
         diagnostic_flows_bulk_deactivated_message:
           '##DIAGNOSTICS_COUNT## Flows are deactivated successfully',
         diagnostic_flows_title: 'Diagnostic Flows',
         diagnostic_flows_add_new: 'Add New',
         diagnostic_flows_bread_crumb_main_title: 'Diagnostic Flows',
         add_diagnostic_flows_bread_crumb_first_link: 'Add Diagnostic Flow',
         edit_diagnostic_flows_bread_crumb_first_link: 'Edit Diagnostic Flow',
         add_diagnostic_flows_form_header: 'Add Diagnostic Flow',
         edit_diagnostic_flows_form_header: 'Edit Diagnostic Flow',
         diagnostic_flows_form_diagnostic_flows_identifier_field: 'Identifier',
         diagnostic_flows_identifier_required_form_error:
           'Identifier is required',
         diagnostic_flows_form_diagnostic_flows_name_en_field: 'Name (EN)',
         diagnostic_flows_form_diagnostic_flows_name_nl_field: 'Name (NL)',
         diagnostic_flows_name_en_required_form_error: 'Name (EN) is required',
         diagnostic_flows_name_nl_required_form_error: 'Name (NL) is required',
         diagnostic_flows_category_required_form_error: 'Category is required',
         diagnostic_flows_form_description_en_field: 'Description (EN)',
         diagnostic_flows_form_description_nl_field: 'Description (NL)',
         diagnostic_flows_form_flow_condition_error_field:
           'Condition must have true and false rules',
         diagnostic_flows_form_flow_modal_title_field: 'Are you sure?',
         diagnostic_flows_form_flow_modal_subtitle_field:
           'You want to save the flow changes in browser?',
         diagnostic_flows_form_flow_modal_cancel_button_field: 'Cancel',
         diagnostic_flows_form_flow_modal_save_button_field: 'Save in Browser',
         diagnostic_flows_form_flow_modal_save_success_message:
           'Flow is successfully saved in Browser',
         diagnostic_flows_form_featured_image_field: 'Featured Image',
         diagnostic_flows_form_upload_featured_image_label:
           'Upload Featured Image',
         diagnostic_flows_form_thumbnail_field: 'Thumbnail',
         diagnostic_flows_form_upload_thumbnail_image_label:
           'Upload Thumbnail Image',
         diagnostic_flows_form_api_error: 'Internal Server Alarm',
         diagnostic_flows_form_unqiue_diagnostic_flows_name_error:
           'Identifer must be unique',
         diagnostic_flows_form_api_forbidden:
           'User has no permissions to create diagnostic_flows',
         diagnostic_flows_add_form_success:
           'Diagnostic Flow is created successfully',
         diagnostic_flows_edit_form_success:
           'Diagnostic Flow is updated successfully',
         diagnostic_flows_form_add_diagnostic_flows_button: 'Add Flow',
         diagnostic_flows_form_edit_diagnostic_flows_button: 'Edit Flow',
         diagnostic_flows_form_cancel_button: 'Cancel',
         audits_select_event_type_error_option: 'Alarm',
         diagnostic_flows_form_flow_field: 'Flow',
         diagnostic_flows_form_flow_condition_button: 'Condition',
         diagnostic_flows_form_flow_timer_button: 'Timer',
         diagnostic_flows_form_flow_normal_node_button: 'Node',
         diagnostic_flows_form_flow_download_image_button: 'Download Image',
         diagnostic_flows_form_flow_start_button: 'Start',
         diagnostic_flows_form_flow_end_button: 'End',
         devices_bulk_export_mbus_historic_data_button: 'Download Mbus Data',
         devices_bulk_export_mbus_historic_data_file_name: 'Mbus Historic Data',
         devices_bulk_mbus_download_title: 'Download Mbus Historical Data',
         devices_bulk_bulk_mbus_download_form_date_range: 'Date Range:',
         devices_bulk_bulk_mbus_download_form_submit_button:
           'Download Mbus Data',
         devices_bulk_bulk_mbus_download_form_cancel_button: 'Cancel',
         devices_bulk_mbus_download_form_success:
           'Mbus Historical Data is emailed to ##EMAIL## successfully!',
         devices_bulk_mbus_download_form_api_error: 'Internal Server Alarm',
         devices_bulk_mbus_download_no_devices_error: '',
         devices_bulk_mbus_download_form_no_devices_error:
           'Please select devices to proceed.',
         devices_bulk_bulk_mbus_download_modal_title: 'Are you sure?',
         devices_bulk_mbus_download_modal_subtitle:
           'You want to run a bulk download historical Mbus data?',
         devices_bulk_mbus_download_modal_cancel_button: 'Cancel',
         devices_bulk_mbus_download_modal_submit_button: 'Confirm',
         projects_bulk_export_mbus_historic_data_button: 'Download Mbus Data',
         projects_bulk_export_mbus_historic_data_file_name:
           'Mbus Historic Data',
         projects_bulk_mbus_download_title: 'Download Mbus Historical Data',
         projects_bulk_bulk_mbus_download_form_date_range: 'Date Range:',
         projects_bulk_bulk_mbus_download_form_data_export_type:
           'Date Export Type',
         projects_bulk_bulk_mbus_download_form_data_export_type_combined:
           'Combined',
         projects_bulk_bulk_mbus_download_form_data_export_type_daily: 'Daily',
         projects_bulk_bulk_mbus_download_form_data_export_type_normal:
           'Normal',
         projects_bulk_bulk_mbus_download_form_submit_button:
           'Download Mbus Data',
         projects_bulk_bulk_mbus_download_form_cancel_button: 'Cancel',
         projects_bulk_mbus_download_form_success:
           'Mbus Historical Data is emailed to ##EMAIL## successfully!',
         projects_bulk_mbus_download_form_api_error: 'Internal Server Alarm',
         projects_bulk_mbus_download_no_projects_error: '',
         projects_bulk_mbus_download_form_no_projects_error:
           'Please select projects to proceed.',
         projects_bulk_bulk_mbus_download_modal_title: 'Are you sure?',
         projects_bulk_mbus_download_modal_subtitle:
           'You want to run a bulk download historical Mbus data?',
         projects_bulk_mbus_download_modal_cancel_button: 'Cancel',
         projects_bulk_mbus_download_modal_submit_button: 'Confirm',
         projects_bulk_mbus_selected_projects: 'Projects Selected',
         sidebar_diagnostic_flows: 'Diagnostic Flows',
         diagnostic_flows_form_diagnostic_flows_category_field:
           'Diagnostic Flow Category',
         diagnostics_send_message_modal_registers_label: 'Registers',
         diagnostics_send_message_modal_operator_label: 'Operator',
         diagnostics_send_message_modal_value_label: 'Value',
         diagnostics_send_message_modal_registers_label_default_option:
           'Select Register',
         diagnostics_send_message_modal_save_button: 'Save',
         diagnostics_send_message_modal_cancel_button: 'Cancel',
         diagnostics_condition_modal_sensor_type_label: 'Sensor Type',
         diagnostics_condition_modal_modbus_label: 'Modbus Sensor',
         diagnostics_condition_modal_mbus_label: 'Mbus Sensor',
         diagnostics_condition_modal_formula_output_label: 'Formula Output',
         diagnostics_condition_modal_meter_type_label: 'Meter Type',
         diagnostics_condition_modal_meter_type_label_default_option:
           'Select Meter Type',
         diagnostics_condition_modal_operator_label: 'Operator',
         diagnostics_condition_modal_operator_option_1: 'Less',
         diagnostics_condition_modal_operator_option_2: 'Less than equal to',
         diagnostics_condition_modal_operator_option_3: 'Equal to',
         diagnostics_condition_modal_operator_option_4: 'Greater',
         diagnostics_condition_modal_operator_option_5: 'Greater than equal to',
         diagnostics_condition_modal_operator_option_6: 'Not Equal to',
         diagnostics_condition_modal_register_label: 'Register',
         diagnostics_condition_modal_value_label: 'Value',
         diagnostics_condition_modal_timer_label: 'Timer',
         diagnostics_condition_modal_retries_label: 'Retries',
         diagnostics_condition_modal_delay_label: 'Delay',
         diagnostics_condition_modal_times_label: 'times',
         diagnostics_condition_modal_second_label: 'sec',
         diagnostics_condition_modal_save_button: 'Save',
         diagnostics_condition_modal_cancel_button: 'Cancel',
         extra_white_space_form_error: 'Extra White space is not allowed',
         diagnostic_flows_form_incomplete_flow_error:
           'Please double check edges and the nodes with black color and red animation',
         diagnostic_flows_menu_information: 'Information',
         diagnostic_flows_menu_modbus: 'Modbus',
         diagnostic_flows_menu_message: 'Message',
         diagnostic_flows_menu_condition: 'Condition',
         diagnostic_flows_menu_user_interaction: 'User Interaction',
         diagnostic_flows_menu_steps: 'Page',
         diagnostic_flows_menu_timer: 'Timer',
         diagnostic_flows_menu_formula: 'Formula',
         diagnostic_flows_form_user_interaction_operation_type:
           'Operation Type',
         diagnostic_flows_form_user_interaction_operation_type_default_option:
           'Select Operation Type',
         diagnostic_flows_form_user_interaction_operation_type_option_choose_mbus_meter:
           'Choose Mbus Meter',
         diagnostic_flows_form_user_interaction_operation_type_option_choose_faucet:
           'Choose Faucet Register',
         diagnostic_flows_form_user_interaction_field_type_option_select_field:
           'Select Field Type',
         diagnostic_flows_form_user_interaction_field_type: 'Field Type',
         diagnostic_flows_form_user_interaction_field_type_default_option:
           'Select Field Type',
         diagnostic_flows_form_user_interaction_field_type_option_checkbox:
           'Checkbox',
         diagnostic_flows_form_user_interaction_field_type_option_radio_button:
           'Radio Button',
         diagnostic_flows_form_user_interaction_field_type_option_text_field:
           'Text Field',
         diagnostic_flows_form_user_interaction_description_en:
           'Description (EN)',
         diagnostic_flows_form_user_interaction_description_nl:
           'Description (NL)',
         diagnostic_flows_form_steps_label_en: 'Description (EN)',
         diagnostic_flows_form_steps_label_nl: 'Description (NL)',
         diagnostic_formulas_form_diagnostic_formulas_retries_field: 'Retries',
         diagnostic_formulas_form_diagnostic_formulas_delay_field: 'Delay',
         diagnostic_formulas_form_diagnostic_formulas_unit_field:
           'Formula Unit',
         diagnostic_formulas_form_forumla_field_placeholder:
           'Please choose @ to select Modbus or Mbus Registers',
         device_single_diagnostic_flow_missing_pages_error:
           '##SELECTED_FLOW## has no pages. Please add pages in the flow to proceed.',
         device_single_stepper_choose_flow_title: 'Choose the flow',
         device_single_stepper_choose_explanation_of_flow_wizard_title:
           'Explanation of the wizard',
         device_single_stepper_result_title: 'Result',
         diagnostic_flows_form_delete_node_modal_title: 'Are you sure?',
         diagnostic_flows_form_delete_node_modal_subtitle:
           'You want to delete ##NODE_LABEL## node?',
         diagnostic_flows_form_delete_node_modal_cancel_button: 'Cancel',
         diagnostic_flows_form_delete_node_modal_delete_button: 'Delete',
         diagnostic_flows_form_loading_text: 'Loading ...',
         diagnostic_flows_form_processing_text: 'Processing',
         diagnostic_flows_form_main_error_text: 'Flow is stopped due to alarm',
         diagnostic_flows_form_main_success_text:
           'Flow has completed successfully',
         devices_bulk_download_form_data_type: 'Data Type',
         devices_bulk_download_form_export_type: 'Export Type',
         devices_bulk_download_form_data_type_daily: 'Daily',
         devices_bulk_download_form_data_type_hourly: 'Hourly',
         devices_bulk_download_form_export_type_combined: 'Combined',
         devices_bulk_download_form_export_type_separated: 'Separated',
         diagnostic_flows_form_main_stopped_text: 'Flow is stopped by the user',
         diagnostic_execution_title: 'Diagnostic Executions',
         diagnostic_execution_table_created_at: 'Created At',
         diagnostic_execution_table_device: 'Device',
         diagnostic_execution_table_user: 'User',
         diagnostic_execution_table_flow: 'Flow',
         diagnostic_execution_table_status: 'Status',
         diagnostic_execution_table_filter_search: 'Search',
         diagnostic_executions_tab_all: 'All',
         diagnostic_executions_tab_completed: 'Completed',
         diagnostic_executions_tab_in_progress: 'In Progress',
         diagnostic_executions_tab_stopped: 'Stopped',
         diagnostic_executions_tab_error: 'Alarm',
         diagnostic_executions_table_no_record_found: 'No Records Found',
         diagnostic_executions_table_row_per_page: 'Rows Per Page',
         diagnostic_flows_menu_result: 'Result',
         diagnostic_flows_menu_result_form_description_en: 'Description (EN)',
         diagnostic_flows_menu_result_form_description_nl: 'Description (NL)',
         diagnostic_flows_menu_result_form_cancel_button: 'Cancel',
         diagnostic_flows_menu_result_form_save_button: 'Save',
         diagnostic_flows_menu_page_form_cancel_button: 'Cancel',
         diagnostic_flows_menu_page_form_save_button: 'Save',
         diagnostic_flows_menu_information_form_description_en:
           'Description (EN)',
         diagnostic_flows_menu_information_form_description_nl:
           'Description (NL)',
         diagnostic_flows_menu_information_form_cancel_button: 'Cancel',
         diagnostic_flows_menu_information_form_save_button: 'Save',
         sidebar_diagnostic_execution_title: 'Diagnostic Executions',
         diagnostic_flow_execution_single_first_bread_crumb:
           'Diagnostic Executions',
         diagnostic_flow_execution_single_second_bread_crumb:
           'View Diagnostic Execution',
         diagnostic_flow_execution_single_output_tab: 'Output',
         diagnostic_flow_execution_single_device_name: 'Device',
         diagnostic_flow_execution_single_flow: 'Flow',
         diagnostic_flow_execution_single_user: 'User',
         diagnostic_flow_execution_single_status: 'Status',
         diagnostic_flow_execution_single_created_at: 'Created At',
         diagnostic_flow_execution_single_bulk_export_file_name:
           'Bulk Diagnostic Executions',
         diagnostic_flow_execution_single_bulk_export_date: 'Date',
         diagnostic_flow_execution_single_bulk_export_time: 'Time',
         diagnostic_flow_execution_single_bulk_export_device_name:
           'Device Name',
         diagnostic_flow_execution_single_bulk_export_device_serial_number_mercurius:
           'Serial number Mercurius',
         diagnostic_flow_execution_single_bulk_export_device_user_full_name:
           'User',
         diagnostic_flow_execution_single_bulk_export_device_flow_name_en:
           'Flow Name (EN)',
         diagnostic_flow_execution_single_bulk_export_device_flow_name_nl:
           'Flow Name (NL)',
         diagnostic_flow_execution_single_bulk_export_device_status: 'Status',
         diagnostic_flows_form_main_flow_already_running_error_text:
           'A flow is already running on this device. Multiple flow executions are not allowed',
         diagnostic_flows_form_open_faucet_on_option: 'On',
         diagnostic_flows_form_open_faucet_off_option:
           'Off (Flow will go in alarm mode)',
         diagnostic_flows_form_mbus_meters_error:
           'Device does not have flow required Mbus Meters',
         diagnostic_flows_result_title: 'Result',
         duplicate_diagnostic_flows_form_header: 'Duplicate Diagnostic Flow',
         duplicate_diagnostic_flows_bread_crumb_first_link:
           'Duplicate Diagnostic Flow',
         diagnostic_flows_form_duplicate_diagnostic_flows_button: 'Duplicate',
         diagnostic_flows_duplicate_form_success:
           'Diagnostic Flow is duplicated successfully',
         diagnostic_flows_filter_duplicate_button: 'Duplicate Flow',
         diagnostic_flows_menu_result_form_id: 'Id',
         audits_street_number_filter_label: 'Street',
         audits_house_number_filter_label: 'House number',
         diagnostic_execution_counter_title: 'Diagnostic Execution Counters',
         diagnostic_execution_counter_table_id: 'Id',
         diagnostic_execution_counter_table_counter: 'Counters',
         diagnostic_execution_counter_table_flow: 'Flow',
         diagnostic_execution_counter_table_result: 'Result',
         diagnostic_execution_counter_table_filter_search: 'Search',
         diagnostic_execution_counter_table_no_record_found: 'No Records Found',
         diagnostic_execution_counter_table_row_per_page: 'Rows Per Page',
         sidebar_diagnostic_flow_execution_counter: 'Diagnostic Flow Counters',
         device_single_firmware_hiu_label: 'Firmware HIU',
         device_single_firmware_mercurius_label: 'Firmware Mercurius',
         custom_popover_105_long_description: 'Alarm Register Long Description',
         settings_menu_title: 'Settings',
         settings_menu_clients_title: 'Clients',
         settings_menu_admins_title: 'Admins',
         settings_menu_kong_admins_title: 'Kong admins',
         settings_menu_kong_clients_title: 'Kong clients',
         settings_menu_diagnostics_title: 'Diagnostics',
         settings_menu_formulas_title: 'Formulas',
         settings_menu_flows_title: 'Flows',
         settings_menu_categories_title: 'Categories',
         settings_menu_firmwares_title: 'Firmware',
         settings_menu_appliance_types_title: 'Appliance types',
         settings_menu_notifications_title: 'Notifications',
         settings_menu_roles_title: 'Roles',
         settings_menu_modules_title: 'Modules',
         settings_menu_permissions_title: 'Permissions',
         settings_menu_go_back_button: 'Go Back',
         audits_device_name_filter_label: 'Device name',
         device_single_documentation_parts_button: 'Onderdelen',
         device_single_documentation_lab_vision_button: 'Labvision',
         device_single_documentation_manuals_button: 'Handleiding',
         device_single_documentation_incident_button: 'Storingsleutel',
         navbar_avg_proof_switch: 'Privacy switch',
         clients_filter_bulk_delete_button: 'Delete',
         clients_bulk_delete_no_clients_with_zero_devices_is_selected_error_message:
           'Please select atleast one record with 0 devices',
         clients_bulk_delete_clients_with_devices_count_is_selected_error_message:
           'Please select only those records which have 0 devices',
         projects_filter_bulk_delete_button: 'Delete',
         projects_bulk_delete_no_projects_with_zero_devices_is_selected_error_message:
           'Please select atleast one record with 0 devices',
         projects_bulk_delete_projects_with_devices_count_is_selected_error_message:
           'Please select only those records which have 0 devices',
         projects_bulk_deleted_message:
           '{{ PROJECTS_COUNT }} Projects are deleted successfully',
         projects_delete_modal_title: 'Are you sure?',
         projects_delete_modal_subtitle: 'You want to delete Records?',
         projects_delete_modal_cancel_button: 'Cancel',
         projects_delete_modal_delete_button: 'Delete',
         users_delete_modal_title: 'Are you sure?',
         users_delete_modal_subtitle: 'You want to delete Records?',
         users_delete_modal_cancel_button: 'Cancel',
         users_delete_modal_delete_button: 'Delete',
         users_bulk_delete_no_user_is_selected_error_message:
           'Please select records to delete',
         users_bulk_deleted_message:
           '{{ USERS_COUNT }} Users are deleted successfully',
         service_client_single_filter_bulk_delete_button: 'Delete',
         service_client_single_no_user_selected_for_deleted_message:
           'Please select records to delete',
         admins_bulk_deleted_message:
           '{{ USERS_COUNT }} Admins are deleted successfully',
         admins_no_user_selected_for_deleted_message:
           'Please select records to deleted',
         admins_filter_bulk_delete_button: 'Delete',
         kong_admins_bulk_deleted_message:
           '{{ USERS_COUNT }} Kong Admins are deleted successfully',
         audits_message_type_label: 'Message Type',
         audit_bulk_export_file_name: 'Audits File',
         registers_reporting_details_all_tab: 'All',
         registers_reporting_details_pending_tab: 'Pending',
         registers_reporting_details_success_tab: 'Success',
         registers_reporting_details_failure_tab: 'Failed',
         devices_form_is_service_device_field: 'Service Device',
         service_portal_login_in_correct_qr_code:
           'Device Serial Number is incorrect',
         service_portal_login_in_correct_credentials:
           'Device credentials are incorrect. Please contact Fortes Administrator.',
         service_portal_login_not_a_registered_service_device:
           'Device with Serial Number {{ SERIAL_NUMBER }} is not registered.',
         devices_unprovisioned: 'Unprovisioned',
         sidebar_unprovisioned_devices: 'Devices - Unprovisioned',
         dashboard_unprovisioned: 'UNPROVISIONED',
         device_single_documentation_warmwater_button: 'Storing Warm Water',
         device_single_documentation_verwarming_button: 'Storing Verwarming',
         service_portal_login_in_serial_number_scan_button:
           'Scan Serial Number',
         service_portal_login_in_heat_interface_unit_scan_button:
           'Scan Heat Interface Unit',
         service_portal_login_in_serial_number_scanned_message:
           'Serial Number is scanned',
         service_portal_login_in_heat_interface_unit_scanned_message:
           'Heat Interface Unit is scanned',
         swapping_device_missing_new_device_error:
           'New Device is not imported in the Mercurius database',
         device_single_dashboard_mbus_title: 'MBus',
         device_single_dashboard_tab: 'Dashboard',
         device_single_offline_detailed_message: 'Device is "Offline"',
         device_single_online_detailed_message:
           'Device is "Online", everything is working fine',
         device_single_error_detailed_message: 'Device is in "Alarm" mode',
         device_single_unprovisioned_detailed_message:
           'Device is in "Unprovisioned" mode',
         device_single_status_documents_link: 'Device Documents',
         email_device_delete_subscription_title:
           'Fortes Data Management - Delete Subscription',
         email_device_delete_subscription_api_status_title:
           'Maxitel API Response:',
         email_device_delete_subscription_type_swapped_device_message:
           'Device subscription is deleted in Device Swapping module',
         email_device_delete_subscription_type_clear_device_message:
           'Device subscription is deleted in Device Clear module',
         devices_form_subscription_id_field: 'Subscription Id',
         device_single_rss_sim_status: 'SIM Status',
         device_monitoring_error_list_table_title: 'Historic Alarm List',
         device_monitoring_error_list_table_device: 'Device',
         device_monitoring_error_list_table_alarm_code: 'Alarm Code',
         device_monitoring_error_list_table_start_date: 'Start Date',
         device_monitoring_error_list_table_end_date: 'End Date',
         device_monitoring_data_consumed_list_table_title: 'Data Consumed',
         device_monitoring_data_consumed_list_table_device: 'Device',
         device_monitoring_data_consumed_list_table_data_usage: 'Data Usage',
         device_monitoring_data_consumed_list_table_date: 'Date',
         device_monitoring_ota_history_list_table_title: 'OTA History',
         device_monitoring_ota_history_list_table_device: 'Device',
         device_monitoring_ota_history_list_table_status: 'Status',
         device_monitoring_ota_history_list_table_date: 'Date',
         device_monitoring_device_status_history_title: 'Device Status History',
         device_monitoring_device_status_history_hr: 'Hr',
         device_monitoring_device_status_history_no_graph_data_error:
           'The graph is unavailable',
         device_monitoring_device_status_history_graph_loading_data:
           'Loading graph',
         device_monitoring_firmware_history_title: 'Firmware History',
         device_monitoring_device_firmware_history_graph_loading_data:
           'Loading barchart',
         device_monitoring_device_firmware_history_no_graph_data_error:
           'The barchart is unavailable',
         sidebar_devices_monitoring: 'Devices Monitoring',
         device_monitoring_projects_counter_title: 'Projects Counter',
         device_monitoring_device_projects_counter_graph_loading_data:
           'Loading barchart',
         device_monitoring_device_projects_counter_no_graph_data_error:
           'The barchart is unavailable',
         device_monitoring_users_counter_title: 'Users Counter',
         device_monitoring_device_users_counter_graph_loading_data:
           'Loading barchart',
         device_monitoring_device_users_counter_no_graph_data_error:
           'The barchart is unavailable',
         device_monitoring_sim_counter_title: 'SIM Data Counter',
         device_monitoring_sim_counter_exceeded_data_title: 'Exceeded',
         device_monitoring_sim_counter_in_package_data_title:
           'In Package Limit',
         device_monitoring_device_sim_counter_graph_loading_data:
           'Loading barchart',
         device_monitoring_device_sim_counter_no_graph_data_error:
           'The barchart is unavailable',
         service_portal_login_in_dont_have_hiu_qr_code_checkbox_field:
           "Don't have HIU QR Code",
         service_portal_login_hiu_autocomplete: 'Heat Interface Unit',
         device_monitoring_device_error_counters_title:
           'Historic Alarm Counters',
         device_monitoring_device_error_counters_error: 'No data found',
         device_monitoring_device_error_counters_no_graph_data_error:
           'The piechart is unavailable',
         device_monitoring_date_range_field: 'Date Range',
         reporting_ota_details_retries_tab: 'Retries',
         device_monitoring_single_page_title: 'Device Monitoring',
         device_monitoring_ota_history_list_table_fail_counter: 'Retries',
         device_monitoring_ota_history_list_table_user: 'User',
         device_monitoring_ota_history_list_table_message: 'Message',
         device_monitoring_ota_history_list_table_old_firmware_version:
           'Old Firmware Version',
         device_monitoring_project_list_table_title: 'Projects',
         device_monitoring_firmware_list_table_title: 'Firmwares',
         device_monitoring_firmware_list_table_firmware_version: 'Firmware',
         device_monitoring_firmware_list_table_device: 'Device',
         device_monitoring_firmware_list_table_project: 'Project',
         device_monitoring_firmware_list_table_saved_at: 'Date',
         monitoring_users_list_table_title: 'Users',
         monitoring_kong_users_list_table_title: 'Kong Users',
         monitoring_kong_users_filter_kong_admin: 'Kong Admin',
         monitoring_kong_users_filter_kong_client: 'Kong Client',
         client_single_users_table_role: 'Role',
         device_monitoring_device_status_list_table_title: 'Device Status',
         navbar_languages_english: 'English',
         navbar_languages_dutch: 'Nederlands',
         navbar_languages_german: 'Deutsch',
         device_single_device_settings_tab: 'Settings v2',
         device_single_device_settings_title: 'Device v2 Settings',
         device_single_device_settings_secondary_device_type_field:
           'Secondary Device Type',
         device_single_device_settings_base_topic_field: 'Base Topic',
         device_single_device_settings_baud_rate_uart_field: 'Baud Rate UART',
         device_single_device_settings_select_baud_rate_uart_field:
           'Select Baud Rate UART',
         device_single_device_settings_modbus_error_register_address_field:
           'Modbus alarm register address',
         device_single_device_settings_modbus_error_register_value_field:
           'Modbus expected alarm register value',
         device_single_device_settings_reboot_device_v2: 'Reboot',
         device_single_device_settings_send_button_v2: 'Send',
         device_single_device_settings_secondary_device_type_message_forwarded:
           'Device Secondary Device Type message is forwarded to device',
         device_single_device_settings_reboot_message_forwarded:
           'Device Reboot message is forwarded to device',
         device_single_device_settings_base_topic_message_forwarded:
           'Device Base Topic message is forwarded to device',
         device_single_device_settings_baud_rate_uart_message_forwarded:
           'Device Baud Rate UART message is forwarded to device',
         device_single_device_settings_modbus_error_register_address_message_forwarded:
           'Device Modbus alarm register address message is forwarded to device',
         device_single_device_settings_modbus_expected_error_register_value_message_forwarded:
           'Device Modbus expected alarm register value message is forwarded to device',
         device_single_device_settings_secondary_device_type_error:
           'Secondary Device Type must be between 1 and 254',
         device_single_device_settings_base_topic_error:
           'Base Topic length must be between 5 and 50',
         device_single_device_settings_baud_rate_uart_error:
           'Please select a option for Baud Rate UART',
         device_single_device_settings_modbus_error_register_address_error:
           'Modbus alarm register address must be between 0 and 65535',
         device_single_device_settings_modbus_error_register_value_error:
           'Modbus expected alarm register value must be between 0 and 65535',
         device_monitoring_device_error_counters_loading_data:
           'Loading piechart',
         diagnostic_formulas_form_diagnostic_formulas_name_de_field:
           'Name (DE)',
         diagnostic_formulas_name_de_required_form_error:
           'Name (DE) is required',
         diagnostic_formulas_form_description_de_field: 'Description (DE)',
         diagnostic_flows_form_diagnostic_flows_name_de_field: 'Name (DE)',
         diagnostic_flows_name_de_required_form_error: 'Name (DE) is required',
         diagnostic_flows_form_description_de_field: 'Description (DE)',
         diagnostic_categories_form_diagnostic_categories_name_de_field:
           'Name (DE)',
         diagnostic_categories_name_de_required_form_error:
           'Name (DE) is required',
         diagnostic_categories_form_description_de_field: 'Description (DE)',
         diagnostic_categories_table_name_de: 'Name (DE)',
         diagnostic_flows_table_name_de: 'Name (DE)',
         diagnostic_formulas_table_name_de: 'Name (DE)',
         modules_form_module_name_de_field: 'Name (DE)',
         modules_name_de_required_form_error: 'Name (DE) is required',
         modules_form_description_de_field: 'Description (DE)',
         modules_table_name_de: 'Name (DE)',
         modules_table_description_de: 'Description (DE)',
         roles_form_role_name_de_field: 'Name (DE)',
         roles_name_de_required_form_error: 'Name (DE) is required',
         roles_form_description_de_field: 'Description (DE)',
         roles_table_name_de: 'Name (DE)',
         roles_table_description_de: 'Description (DE)',
         permissions_form_permission_name_de_field: 'Name (DE)',
         permissions_form_description_de_field: 'Description (DE)',
         permissions_table_name_de: 'Name (DE)',
         permissions_table_description_de: 'Description (DE)',
         notifications_form_title_de_field: 'Title (DE)',
         notifications_form_description_de_field: 'Description (DE)',
         firmwares_name_de_required_form_error: 'Name (DE)',
         firmwares_form_firmware_name_de_field: 'Name (DE) is required',
         navbar_languages_danish: 'Danish',
         firmwares_name_dk_required_form_error: 'Name (DK)',
         firmwares_form_firmware_name_dk_field: 'Name (DK) is required',
         diagnostic_formulas_form_diagnostic_formulas_name_dk_field:
           'Name (DK)',
         diagnostic_formulas_name_dk_required_form_error:
           'Name (DK) is required',
         diagnostic_formulas_form_description_dk_field: 'Description (DK)',
         diagnostic_flows_form_diagnostic_flows_name_dk_field: 'Name (DK)',
         diagnostic_flows_name_dk_required_form_error: 'Name (DK) is required',
         diagnostic_flows_form_description_dk_field: 'Description (DK)',
         diagnostic_categories_form_diagnostic_categories_name_dk_field:
           'Name (DK)',
         diagnostic_categories_name_dk_required_form_error:
           'Name (DK) is required',
         diagnostic_categories_form_description_dk_field: 'Description (DK)',
         diagnostic_categories_table_name_dk: 'Name (DK)',
         diagnostic_flows_table_name_dk: 'Name (DK)',
         diagnostic_formulas_table_name_dk: 'Name (DK)',
         modules_form_module_name_dk_field: 'Name (DK)',
         modules_name_dk_required_form_error: 'Name (DK) is required',
         modules_form_description_dk_field: 'Description (DK)',
         modules_table_name_dk: 'Name (DK)',
         modules_table_description_dk: 'Description (DK)',
         roles_form_role_name_dk_field: 'Name (DK)',
         roles_name_dk_required_form_error: 'Name (DK) is required',
         roles_form_description_dk_field: 'Description (DK)',
         roles_table_name_dk: 'Name (DK)',
         roles_table_description_dk: 'Description (DK)',
         permissions_form_permission_name_dk_field: 'Name (DK)',
         permissions_form_description_dk_field: 'Description (DK)',
         permissions_table_name_dk: 'Name (DK)',
         permissions_table_description_dk: 'Description (DK)',
         notifications_form_title_dk_field: 'Title (DK)',
         notifications_form_description_dk_field: 'Description (DK)',
         device_monitoring_data_consumed_list_table_project: 'Project',
         project_single_device_list_search_mbus_registers_by_project:
           'Search Mbus Registers',
         project_single_fetch_mbus_registers_by_project_success_message:
           'Message is forwarded to Project ##PROJECT_NAME## Devices successfully',
         project_single_fetch_mbus_registers_by_project_error_message:
           'Interval Server Alarm',
         devices_list_diagnostic_filters_title: 'Registers Filter',
         devices_list_diagnostics_condition_modal_sensor_type_label:
           'Sensor Type',
         devices_list_diagnostics_condition_modal_modbus_label: 'Modbus Sensor',
         devices_list_diagnostics_condition_modal_mbus_label: 'Mbus Sensor',
         devices_list_diagnostics_condition_modal_formula_output_label:
           'Formula Output',
         devices_list_diagnostics_condition_modal_meter_type_label:
           'Meter Type',
         devices_list_diagnostics_condition_modal_meter_type_label_default_option:
           'Select Meter Type',
         devices_list_diagnostics_condition_modal_operator_label: 'Operator',
         devices_list_diagnostics_condition_modal_operator_option_1: 'Less',
         devices_list_diagnostics_condition_modal_operator_option_2:
           'Less than equal to',
         devices_list_diagnostics_condition_modal_operator_option_3: 'Equal to',
         devices_list_diagnostics_condition_modal_operator_option_4: 'Greater',
         devices_list_diagnostics_condition_modal_operator_option_5:
           'Greater than equal to',
         devices_list_diagnostics_condition_modal_operator_option_6:
           'Not Equal to',
         devices_list_diagnostics_condition_modal_register_label: 'Register',
         devices_list_diagnostics_condition_modal_register_required_error:
           'Register is required',
         devices_list_diagnostics_send_message_modal_registers_label_default_option:
           'Select Register',
         devices_list_diagnostics_condition_modal_value_label: 'Value',
         devices_list_diagnostics_condition_modal_value_is_required_error:
           'Value is required',
         devices_list_diagnostics_condition_modal_operator_is_required_error:
           'Operator is required',
         devices_list_diagnostics_condition_modal_meter_is_required_error:
           'Meter is required',
         devices_list_diagnostics_condition_modal_value_invalid_error:
           'Invalid Value, please check',
         devices_list_diagnostics_condition_modal_filter_button: 'Filter',
         devices_list_diagnostics_condition_modal_close_button: 'Close',
         devices_list_diagnostics_condition_modal_add_button:
           'Add more filters',
         error_check_table_title: 'Device Alarm Checks',
         error_check_table_filter_search: 'Search',
         error_check_table_no_record_found: 'No Records Found',
         error_check_table_row_per_page: 'Rows Per Page',
         error_check_table_created_at: 'Created At',
         error_check_table_total_devices: 'Total Devices',
         error_check_details_table_title: 'Device Alarm Check Details',
         error_check_details_table_filter_search: 'Search',
         error_check_details_table_no_record_found: 'No Records Found',
         error_check_details_table_row_per_page: 'Rows Per Page',
         error_check_details_table_created_at: 'Created At',
         error_check_details_table_device: 'Device',
         error_check_details_table_old_error: 'Old Alarm',
         error_check_details_table_new_error: 'New Alarm',
         error_check_details_table_status: 'Status',
         error_check_details_table_status_success: 'Success',
         error_check_details_table_status_failed: 'Failure',
         error_check_details_table_all_tab: 'All',
         error_check_details_table_success_tab: 'Success',
         error_check_details_table_failure_tab: 'Failure',
         error_check_details_table_device_name: 'Device Name',
         error_check_details_table_device_serial_number: 'Serial Number',
         sidebar_devices_error_check: 'Alarm Devices',
         error_check_details_table_bulk_export_file_name:
           'Alarm Devices Details List',
         error_check_table_bulk_export_file_name: 'Alarm Devices List',
         device_single_registers_table_min_error:
           'Value must be greater than or equal to min_value',
         device_single_registers_table_invalid_value_error:
           'Please enter a valid number',
         project_single_project_setting_tab: 'Project Setting',
         project_single_project_setting_mbus_registers_title: 'MBus Registers',
         project_single_project_setting_mbus_register_accumulated_heating_energy_title:
           'Accumulated heating energy Unit',
         project_single_project_setting_mbus_register_accumulated_heating_energy_success_message:
           'Accumulated heating energy unit is successfully updated',
         project_single_project_setting_mbus_register_accumulated_heating_energy_error_message:
           'Failed to update Accumulated heating energy unit',
         project_single_project_setting_select_mbus_register_accumulated_heating_energy_title:
           'Select Accumulated heating energy',
         project_single_project_setting_select_mbus_register_update_button:
           'Update',
         custom_popover_100_short_description: 'Heating state',
         custom_popover_101_short_description: 'Hot Water state',
         custom_popover_102_short_description: 'Preheat state',
         custom_popover_103_short_description: 'Thermal disinfection state',
         custom_popover_104_short_description: 'Cooling state',
         custom_popover_1802_short_description: 'TE Heating Element State',
         custom_popover_105_short_description: 'Alarm code',
         custom_popover_107_short_description: 'Hot water valve (M1)',
         custom_popover_108_short_description: 'Heating/cooling valve (M2)',
         custom_popover_109_short_description: 'Pump',
         custom_popover_110_short_description: '6-way-valve',
         custom_popover_113_short_description: 'Room thermostat input',
         custom_popover_114_short_description: 'OpenTherm Indicator',
         custom_popover_115_short_description: 'Appliance Type',
         custom_popover_200_short_description: 'Hot water flow rate',
         custom_popover_201_short_description: 'Hot water temperature',
         custom_popover_202_short_description: 'Primary supply',
         custom_popover_203_short_description: 'Primary return/Outdoor',
         custom_popover_205_short_description: 'Secondary supply',
         custom_popover_206_short_description: 'Secondary return',
         custom_popover_204_short_description: 'Calculated heating setpoint',
         custom_popover_207_short_description: 'Room Temperature (OpenTherm)',
         custom_popover_208_short_description: 'Room Setpoint (OpenTherm)',
         custom_popover_210_short_description: 'Secondary water pressure',
         custom_popover_800_short_description: 'Total system run time',
         custom_popover_801_short_description: 'Heating burn time',
         custom_popover_802_short_description: 'Cooling burn time',
         custom_popover_803_short_description: 'Hot water burn Time',
         custom_popover_804_short_description: 'Number of tappings',
         custom_popover_805_short_description: 'Hot water Volume',
         custom_popover_806_short_description: 'Power cuts',
         create_role_stepper_information_title: 'Information',
         create_role_stepper_client_title: 'Client',
         create_role_stepper_service_client_title: 'Service Client',
         create_role_stepper_project_title: 'Project',
         create_role_stepper_device_management_title: 'Device Management',
         create_role_stepper_commissioning_title: 'Commissioning',
         create_role_stepper_reporting_title: 'Reporting',
         create_role_stepper_general_title: 'General',
         roles_form_role_name_field: 'Name',
         roles_name_required_form_error: 'Name is required',
         roles_form_description_field: 'Description',
         create_role_stepper_back_button: 'Back',
         create_role_stepper_next_button: 'Next',
         create_role_stepper_finish_button: 'Finish',
         create_role_stepper_yes_label: 'Yes',
         create_role_stepper_no_label: 'No',
         create_role_stepper_step_2_client_view_all_users: 'View all users?',
         create_role_stepper_step_2_client_create_new_users:
           'Create new users?',
         create_role_stepper_step_2_client_edit_new_users:
           'Modify existing users like the role?',
         create_role_stepper_step_3_service_client_create_new:
           "Create a new 'service client'?",
         create_role_stepper_step_3_service_client_view_users:
           "View existing 'service client' users?",
         create_role_stepper_step_3_service_client_create_users:
           "Create new 'service client' users?",
         create_role_stepper_step_3_service_client_modify_users:
           "Modify 'service client' users like the role?",
         create_role_stepper_step_4_project_view: 'View projects?',
         create_role_stepper_step_4_project_create_new: 'Create new projects?',
         create_role_stepper_step_4_project_export_mbus_data:
           'Export energy meter data from projects?',
         create_role_stepper_step_5_device_view_single_page: 'Open a device?',
         create_role_stepper_step_5_device_view_single_page_setting_registers:
           'View settings?',
         create_role_stepper_step_5_device_edit_single_page_setting_registers:
           'Modify settings?',
         create_role_stepper_step_5_device_edit_single_page_manual_control:
           'Use manual control?',
         create_role_stepper_step_5_device_single_page_view_history:
           'View history?',
         create_role_stepper_step_5_device_single_page_view_meter_data:
           'View meter data?',
         create_role_stepper_step_5_device_single_page_use_diagnostics_module:
           'Use the diagnostics module?',
         create_role_stepper_step_5_device_single_page_information_and_delivery_set_data:
           'View information such as device info, address details, and delivery set data?',
         create_role_stepper_step_6_commissioning_module_put_devices_into_operation:
           'Commissioning module to put devices into operation?',
         create_role_stepper_step_6_commissioning_module_swapping:
           'Exchange devices (transfer data from old device to new device)?',
         create_role_stepper_step_7_reporting_audit:
           'The logbook that contains all messages, alarms, and actions on devices?',
         create_role_stepper_step_7_reporting_swapped_devices:
           'Logbook of exchanged devices?',
         create_role_stepper_step_7_reporting_error_devices:
           'Logbook of devices with faults?',
         create_role_stepper_step_7_reporting_bulk_registers_update:
           'Results of group changes?',
         create_role_stepper_step_8_view_dashboard:
           'Dashboard all access and sidebar device counters',
         create_role_stepper_step_8_general_create_role: 'Creating roles?',
         create_role_stepper_question_required_error:
           'One option is required to proceed',
         roles_form_role_name_en_field: 'Name (EN)',
         roles_form_role_name_nl_field: 'Name (NL)',
         roles_name_en_required_form_error: 'Name (EN) is required',
         roles_name_nl_required_form_error: 'Name (NL) is required',
         roles_form_description_en_field: 'Description (EN)',
         roles_form_description_nl_field: 'Description (NL)',
         project_single_project_setting_device_v2_settings_title:
           'Device V2 Settings',
         project_single_device_settings_secondary_device_type_field:
           'Secondary Device Type',
         project_single_project_setting_base_topic_field: 'Base Topic',
         project_single_device_settings_baud_rate_uart_field: 'Baud Rate UART',
         project_single_device_settings_select_baud_rate_uart_field:
           'Select Baud Rate UART',
         project_single_device_settings_modbus_error_register_address_field:
           'Modbus alarm register address',
         project_single_device_settings_modbus_error_register_value_field:
           'Modbus expected alarm register value',
         project_single_project_setting_device_v2_send_button: 'Send',
         project_single_project_setting_base_topic_success_message:
           'Base Topic is successfully forwarded to ##SENT_MESSAGE_TO_DEVICES_COUNTER## devices of Project',
         project_single_project_setting_secondary_device_type_success_message:
           'Secondary Device Type is successfully forwarded to ##SENT_MESSAGE_TO_DEVICES_COUNTER## devices of Project',
         project_single_project_setting_reboot_message:
           'Device Reboot Message is successfully forwarded to ##SENT_MESSAGE_TO_DEVICES_COUNTER## devices of Project',
         project_single_project_setting_baut_rate_uart_success_message:
           'Device Baut Rate UART Message is successfully forwarded to ##SENT_MESSAGE_TO_DEVICES_COUNTER## devices of Project',
         project_single_project_setting_modbus_expected_error_register_value_success_message:
           'Device Modbus Expected Alarm Register Value Message is successfully forwarded to ##SENT_MESSAGE_TO_DEVICES_COUNTER## devices of Project',
         project_single_project_setting_modbus_error_register_address_success_message:
           'Device Reboot Message is successfully forwarded to ##SENT_MESSAGE_TO_DEVICES_COUNTER## devices of Project',
         docs_third_tab_video_instruction: 'Video Instruction',
         docs_third_tab_video_instruction_title: 'Video Instruction',
         custom_popover_106_short_description: 'Software version',
         custom_popover_106_long_description: 'Software version',
         EXPORT_MBUS_METER_SERIAL_NUMBER: 'Serial number meter',
         navbar_languages_french: 'French',
         diagnostic_formulas_form_diagnostic_formulas_name_fr_field:
           'Name (FR)',
         diagnostic_formulas_name_fr_required_form_error:
           'Name (FR) is required',
         diagnostic_formulas_form_description_fr_field: 'Description (FR)',
         diagnostic_flows_form_diagnostic_flows_name_fr_field: 'Name (FR)',
         diagnostic_flows_name_fr_required_form_error: 'Name (FR) is required',
         diagnostic_flows_form_description_fr_field: 'Description (FR)',
         diagnostic_categories_form_diagnostic_categories_name_fr_field:
           'Name (FR)',
         diagnostic_categories_name_fr_required_form_error:
           'Name (FR) is required',
         diagnostic_categories_form_description_fr_field: 'Description (FR)',
         modules_form_module_name_fr_field: 'Name (FR)',
         modules_name_fr_required_form_error: 'Name (FR) is required',
         modules_form_description_fr_field: 'Description (FR)',
         roles_form_role_name_fr_field: 'Name (FR)',
         roles_name_fr_required_form_error: 'Name (FR) is required',
         roles_form_description_fr_field: 'Description (FR)',
         permissions_form_permission_name_fr_field: 'Name (FR)',
         permissions_form_description_fr_field: 'Description (FR)',
         firmwares_form_firmware_name_fr_field: 'Name (FR)',
         firmwares_name_fr_required_form_error: 'Name (FR) is required',
         notifications_form_title_fr_field: 'Name (FR)',
         notifications_form_description_fr_field: 'Description (FR)',
         notifications_title_dk_required_form_error: 'Name (DK) is required',
         notifications_title_fr_required_form_error: 'Name (FR) is required',
         notifications_title_de_required_form_error: 'Name (DE) is required',
         notifications_description_dk_required_form_error:
           'Description (DK) is required',
         notifications_description_de_required_form_error:
           'Description (DE) is required',
         notifications_description_fr_required_form_error:
           'Description (FR) is required',
         client_single_error_devices_bread_crumb: 'Alarm Devices',
         service_client_single_error_devices_bread_crumb: 'Alarm Devices',
         devices_list_diagnostics_condition_modal_fetch_and_filter_button:
           'Fetch & Filter',
         diagnostic_register_drawer_selected_devices_title: 'Selected Devices',
         diagnostic_register_drawer_fetch_and_filter_message_1:
           'Fetching devices data',
         diagnostic_register_drawer_fetch_and_filter_message_2:
           'Database refresh',
         diagnostic_register_drawer_fetch_and_filter_message_3:
           'Filtering devices',
         devices_bulk_selected_devices_title: 'Devices Selected',
         custom_popover_100_long_description: 'Heating state',
         custom_popover_101_long_description: 'Hot Water state',
         custom_popover_103_long_description: 'Thermal disinfection state',
         custom_popover_102_long_description: 'Preheat state',
         custom_popover_104_long_description: 'Cooling state',
         custom_popover_1802_long_description: 'TE Heating Element State',
         custom_popover_107_long_description: 'Hot water valve (M1)',
         custom_popover_108_long_description: 'Heating/cooling valve (M2)',
         custom_popover_109_long_description: 'Pump',
         custom_popover_110_long_description: '6-way-valve',
         custom_popover_113_long_description: 'Room thermostat input',
         custom_popover_114_long_description: 'OpenTherm Indicator',
         custom_popover_115_long_description: 'Appliance Type',
         custom_popover_200_long_description: 'Hot water flow rate',
         custom_popover_201_long_description: 'Hot water temperature',
         custom_popover_202_long_description: 'Primary supply',
         custom_popover_203_long_description: 'Primary return/Outdoor',
         custom_popover_205_long_description: 'Secondary supply',
         custom_popover_206_long_description: 'Secondary return',
         custom_popover_204_long_description: 'Calculated heating setpoint',
         custom_popover_207_long_description: 'Room Temperature (OpenTherm)',
         custom_popover_208_long_description: 'Room Setpoint (OpenTherm)',
         custom_popover_210_long_description: 'Secondary water pressure',
         custom_popover_800_long_description: 'Total system run time',
         custom_popover_801_long_description: 'Heating burn time',
         custom_popover_802_long_description: 'Cooling burn time',
         custom_popover_803_long_description: 'Hot water burn Time',
         custom_popover_804_long_description: 'Number of tappings',
         custom_popover_805_long_description: 'Hot water Volume',
         custom_popover_806_long_description: 'Power cuts',
         project_single_project_setting_mbus_hourly_logs_title:
           'Mbus Hourly Logs',
         project_single_project_setting_mbus_hourly_logs_field:
           'Fetch Mbus Hourly',
         project_single_project_setting_mbus_hourly_logs_update_button:
           'Update',
         project_single_project_setting_mbus_hourly_logs_success_set_message:
           'Mbus Hourly logs are successfully set for the project',
         project_single_project_setting_mbus_hourly_logs_error_message:
           'Failed to update Mbus Hourly logs for the project',
         sidebar_mbus_reporting: 'Mbus Reporting',
         mbus_reporting_table_device: 'Device',
         mbus_reporting_table_project: 'Project',
         mbus_reporting_table_created_at: 'Created At',
         mbus_reporting_table_viewed_by: 'Viewed By',
         mbus_reporting_table_viewed_at: 'Viewed At',
         mbus_reporting_table_firmware: 'Firmware',
         mbus_reporting_table_no_record_found: 'No Records Found',
         mbus_reporting_table_all_filter: 'All',
         mbus_reporting_table_read_filter: 'Read',
         mbus_reporting_table_unread_filter: 'Unread',
         mbus_reporting_table_row_per_page: 'Rows per page',
         mbus_reporting_table_title: 'Mbus Reporting',
         mbus_reporting_anomaly_table_title: 'Mbus Anomalies',
         mbus_reporting_anomaly_table_difference: 'Difference',
         mbus_reporting_anomaly_table_detection: 'Detection',
         mbus_reporting_anomaly_table_mbus_meter_type: 'Meter',
         mbus_reporting_anomaly_table_mbus_serial_number: 'Mbus Serial Number',
         mbus_reporting_anomaly_table_mbus_old_value: 'Old Value',
         mbus_reporting_anomaly_table_mbus_new_value: 'New Value',
         mbus_reporting_anomaly_table_mbus_port: 'Port',
         mbus_reporting_anomaly_table_mbus_register: 'Register',
         mbus_reporting_anomaly_table_mbus_reason: 'Reason',
         mbus_reporting_anomaly_table_mbus_fail_reason: 'Greater than',
         mbus_reporting_anomaly_table_mbus_suspicious_reason: 'Lies in between',
         mbus_reporting_anomaly_table_fail: 'Fail',
         mbus_reporting_anomaly_table_suspicious: 'Suspicious',
         mbus_reporting_table_bulk_view_reports_success_message:
           'Mbus Reporting Messages are successfully viewed',
         mbus_reporting_table_bulk_view_reports_error_message:
           'Please select Mbus Reporting records to proceed',
         mbus_reporting_table_bulk_view_button: 'Bulk View',
         mbus_reporting_table_view_button: 'View',
         mbus_reporting_table_filters_project_field: 'Project',
         mbus_reporting_table_filters_device_name_field: 'Device',
         mbus_reporting_table_filters_start_date: 'Start Date',
         mbus_reporting_table_filters_end_date: 'End Date',
         mbus_reporting_table_filters_firmware: 'Firmware',
         mbus_reporting_table_filters_mbus_serial_number: 'Mbus Serial Number',
         mbus_reporting_table_filters_viewed_by: 'Viewed By',
         business_situation_measured_values_TR03_209: 'Outdoor Temperature',
         custom_popover_209_short_description: 'Outdoor Temperature',
         custom_popover_209_long_description: 'Outdoor Temperature',
         appliance_types_set_registers_table_dashboard: 'Dashboard',
         appliance_types_set_registers_table_dashboard_error_message:
           'Device dashboard registers must be either 0 or exactly 8.',
         sidebar_missing_hourly_reporting: 'Mbus Missing Data Report',
         missing_hourly_reporting_table_title:
           'Mbus Hourly Missing Data Reporting',
         mbus_hourly_missing_reporting_table_filters_project_field: 'Project',
         mbus_hourly_missing_reporting_table_filters_device_name_field:
           'Device',
         mbus_hourly_missing_reporting_table_filters_firmware_field: 'Firmware',
         mbus_hourly_missing_reporting_table_last_seen: 'Mbus Message At',
         mbus_hourly_missing_reporting_table_created_at: 'Created At',
         mbus_hourly_missing_reporting_table_device: 'Device',
         mbus_hourly_missing_reporting_table_project: 'Project',
         mbus_hourly_missing_reporting_table_firmware: 'Firmware',
         mbus_hourly_missing_reporting_table_no_record_found:
           'No Records Found',
         mbus_hourly_missing_reporting_table_row_per_page: 'Rows per page',
         device_monitoring_device_frequency_history_counters_title:
           'Device Anomalies Frequency',
         device_monitoring_device_frequency_history_counters_error:
           'No data found',
         device_monitoring_device_frequency_history_counters_no_graph_data_error:
           'The piechart is unavailable',
         device_monitoring_device_frequency_history_counters_loading_data:
           'Loading ...',
         device_monitoring_project_frequency_history_counters_title:
           'Project Anomalies Frequency',
         device_monitoring_project_frequency_history_counters_error:
           'No data found',
         device_monitoring_project_frequency_history_counters_no_graph_data_error:
           'The piechart is unavailable',
         device_monitoring_project_frequency_history_counters_loading_data:
           'Loading ...',
         device_monitoring_firmware_anomalies_history_title:
           'Firmware Anomalies Frequency',
         device_monitoring_device_firmware_anomalies_history_graph_loading_data:
           'The barchart is unavailable',
         device_monitoring_device_firmware_anomalies_history_no_graph_data_error:
           'Loading ...',
         devices_device_id: 'Device Id',
         device_monitoring_device_frequency_details_table_title:
           'Device Anomalies Frequency',
         device_monitoring_device_frequency_details_table_firmware: 'Firmware',
         device_monitoring_device_frequency_details_table_device: 'Device',
         device_monitoring_device_frequency_details_table_project: 'Project',
         device_monitoring_device_frequency_details_table_saved_at: 'Date',
         device_monitoring_device_frequency_details_table_startup_messages_count:
           'Start up messages count',
         device_monitoring_project_frequency_details_table_title:
           'Project Anomalies Frequency',
         device_monitoring_project_frequency_details_table_project: 'Project',
         device_monitoring_project_frequency_details_table_devices_count:
           'Devices Count',
         device_monitoring_project_frequency_details_table_startup_messages_count:
           'Start up messages count',
         device_monitoring_firmware_frequency_details_table_title:
           'Firmware Anomalies Frequency',
         device_monitoring_firmware_frequency_details_table_firmware:
           'Firmware',
         device_monitoring_firmware_frequency_details_table_startup_messages_count:
           'Start up messages count',
         client_single_users_list_reset_and_send_email_button: 'Reset Password',
         user_reset_password_form_success:
           'User password is updated successfully',
         users_reset_password_modal_title: 'Reset Password',
         users_reset_password_modal_subtitle:
           'Do you want to reset password for this user and send email?',
         users_reset_password_modal_cancel_button: 'Close',
         users_reset_password_modal_reset_password_button:
           'Reset and Send Email',
         reset_password_subject: 'Fortes Data Management - Reset Password',
         clients_form_is_2fa_enabled_field:
           'Enable Two-Factor Authentication (2FA)',
         service_clients_form_is_2fa_enabled_field:
           'Enable Two-Factor Authentication (2FA)',
         two_factor_authentication_qr_verified_title:
           'Two-Factor Authentication (2FA)',
         two_factor_authentication_qr_unverified_title:
           'Setup Two-Factor Authentication (2FA)',
         two_factor_authentication_permission_error: '',
         two_factor_authentication_description_step_1:
           'Install one of the following applications on your mobile:',
         two_factor_authentication_description_step_2:
           'Open the application and scan the QR Code:',
         two_factor_authentication_description_step_2_rescan:
           'Regenerate QR Code',
         two_factor_authentication_description_step_3:
           'Enter the one-time code provided by the application and click Submit to finish the setup.',
         two_factor_authentication_form_otp_field: 'OTP Code',
         two_factor_authentication_form_otp_characters_limit_error:
           'OTP must be 6 characters',
         two_factor_authentication_form_otp_required_error: 'OTP is required',
         two_factor_authentication_form_incorrect_otp_error:
           'Invalid OTP, please retry again with a new OTP',
         two_factor_authentication_form_success:
           'OTP is successfully authenticated',
         two_factor_authentication_submit_button: 'Submit',
         client_single_users_list_enable_2fa_qr_code_button:
           'Enable Two-Factor Authentication (2FA) QR Code',
         service_client_single_users_list_enable_2fa_qr_code_button:
           'Enable Two-Factor Authentication (2FA) QR Code',
         users_enable_2fa_qr_code_modal_title:
           'Enable Two-Factor Authentication (2FA) QR Code',
         users_enable_2fa_qr_code_modal_subtitle:
           'Are you sure you want to enable Two-Factor Authentication (2FA) QR Code for this user?',
         users_enable_2fa_qr_code_modal_cancel_button: 'Cancel',
         users_enable_2fa_qr_code_modal_enable_2fa_qr_code_button:
           'Enable Two-Factor Authentication (2FA) QR Code',
         client_single_users_list_enable_2fa_qr_code_success_message:
           'Two-Factor Authentication (2FA) QR Code is successfully enabled',
         client_single_2fa_label: 'Two-Factor Authentication (2FA)',
         enabled_2fa_label: 'Enabled',
         disabled_2fa_label: 'Disabled',
         service_client_single_2fa_label: 'Two-Factor Authentication (2FA)',
         client_single_users_table_last_access: 'Last Seen',
         service_client_single_users_table_last_access: 'Last Seen',
         projects_form_header: 'Project Information',
         projects_commissioning_form_header: 'Project Commissioning',
         projects_commissioning_form_export_button: 'Export Devices',
         projects_commissioning_form_export_file_name:
           'Project Commissioning Export',
         projects_commissioning_form_import_button: 'Import Devices',
         projects_commissioning_form_import_message:
           "<strong>Steps to Import Devices</strong> <ol> <li>Download the Project Commissioning File Template from green Export Devices Button.</li> <li>Update the file and don't change the header column names. When they're changed, the file import will fail.</li> <li>Import the file and changes will be updated.</li> </ol>",
         projects_commissioning_form_import_success_message:
           'Devices data is successfully commissioned',
         commissioning_device_stepper_step_1_scan_qr_serial_number_title:
           'Scan QR code Mercurius',
         commissioning_device_stepper_step_3_validate_project_setting_title:
           'Validate connectivity',
         commissioning_device_stepper_step_4_update_address_information_title:
           'Update address',
         commissioning_device_stepper_step_2_hiu_commissioning_title:
           'Scan QR code HIU',
         commissioning_device_stepper_step_5_preview_and_submit_title:
           'Preview and submit',
         commissioning_form_dont_have_serial_number_checkbox:
           "Don't have Serial QR Code?",
         commissioning_form_back_button: 'Previous',
         commissioning_form_next_button: 'Next',
         commissioning_form_finish_button: 'Finish',
         commissioning_form_device_serial_is_missing_error:
           'Serial Number is required',
         commissioning_form_modbus_mbus_validation_error:
           'Validation failed, do you want to proceed anyway?',
         commissioning_form_stepper_validation_project_setting_title:
           'Project Settings',
         commissioning_form_stepper_validation_current_setting_title:
           'Device Settings',
         commissioning_form_stepper_validation_validate_to_view:
           'Validate to view details',
         commissioning_form_stepper_validation_modbus_title: 'Modbus',
         commissioning_form_stepper_validation_mbus_title: 'M-Bus',
         commissioning_form_stepper_validation_modbus_connected_title:
           'Connected',
         commissioning_form_stepper_validation_modbus_not_connected_title:
           'Not Connected',
         commissioning_form_stepper_validation_mbus_meters_title: 'meter(s)',
         project_single_project_setting_modbus_and_mbus_validation_form_title:
           'Modbus and Mbus Setting',
         commissioning_form_stepper_validation_is_modbus_connected:
           'Is Modbus Connected',
         commissioning_form_stepper_validation_mbus_meters_select_field:
           'M-Bus Meters',
         commissioning_form_stepper_validation_mbus_meters_select_option_field:
           'Select M-Bus Meters',
         commissioning_form_stepper_validation_mbus_meters_validate_button:
           'Validate',
         commissioning_form_upload_file_type_error:
           'Only XLSX files are allowed.',
         commissioning_form_upload_file_invalid_column_names_error:
           "Invalid column ##COLUMNS##, please don't change the column names",
         commissioning_form_upload_file_size_error:
           'File size should be less than 5 MB.',
         commissioning_form_uploading_text: 'Uploading...',
         project_single_project_setting_mbus_reporting_form_title:
           'Mbus Reporting Setting',
         project_single_project_setting_mbus_hourly_missing_data_reporting_value_field:
           'Mbus Hourly Missing Data Reporting',
         project_single_project_setting_mbus_anomaly_reporting_value_field:
           'Mbus Anomaly Reporting',
         project_single_project_setting_mbus_reporting_form_button: 'Update',
         project_single_project_setting_mbus_reporting_success_message:
           'Mbus Reporting data is successfully set for the project',
         project_single_project_setting_mbus_reporting_error_message:
           'Failed to update Mbus Reporting data for the project',
         commissioning_form_upload_file_incorrect_serial_number_error:
           'Incorrect Serial Number(s) found for the project commissioning',
         commissioning_form_upload_file_incorrect_devices_data_error:
           'Incorrect Device(s) data found for the project commissioning',
         commissioning_form_upload_file_empty_sheet_error:
           'Project Commissioning file is empty',
         commissioning_form_upload_success_message:
           'Project Commissioning is successfully completed',
         commissioning_validation_failed_subject:
           'Mercurius Commissioning Report',
         commissioning_form_stepper_validation_mbus_meters_loading_title:
           'Mbus meters check takes upto 30 - 60 seconds',
         commissioning_form_stepper_validation_mbus_meters_retries_label:
           'Mbus Retries',
         commissioning_form_stepper_validation_mbus_meters_retries_button:
           'Retry',
         mbus_reporting_table_bulk_snooze_button: 'Bulk Snooze',
         mbus_reporting_table_bulk_snooze_devices_success_message:
           'Mbus Reporting Devices are successfully snoozed',
         mbus_reporting_table_bulk_snooze_modal_title: 'Are you sure?',
         mbus_reporting_table_bulk_snooze_modal_sub_title:
           'You want to snooze Mbus Reporting for the selected devices?',
         mbus_reporting_table_bulk_snooze_modal_cancel_button: 'Cancel',
         mbus_reporting_table_bulk_snooze_modal_snooze_button: 'Snooze',
         mbus_reporting_table_bulk_snooze_modal_snooze_duration:
           'Snooze Duration',
         mbus_reporting_table_bulk_snooze_modal_select_snooze_duration:
           'Select Snooze Duration',
         mbus_reporting_table_bulk_snooze_modal_snooze_duration_day: 'Day',
         mbus_reporting_table_bulk_snooze_modal_snooze_duration_week: 'Weeks',
         mbus_reporting_table_bulk_snooze_modal_snooze_duration_month: 'Months',
         mbus_reporting_table_bulk_snooze_modal_snooze_duration_year: 'Years',
         sidebar_mbus_reporting_snoozed_devices:
           'Mbus Reporting - Snoozed Devices',
         mbus_reporting_snoozed_devices_table_title: 'Snoozed Devices',
         mbus_reporting_table_bulk_un_snooze_devices_success_message:
           'Mbus Reporting Devices are successfully UnSnoozed',
         mbus_reporting_table_bulk_un_snooze_modal_title: 'Are you sure?',
         mbus_reporting_table_bulk_un_snooze_modal_sub_title:
           'You want to UnSnooze Mbus Reporting for the selected devices?',
         mbus_reporting_table_bulk_un_snooze_modal_cancel_button: 'Cancel',
         mbus_reporting_table_bulk_un_snooze_modal_snooze_button: 'UnSnooze',
         mbus_reporting_table_bulk_un_snooze_button: 'Bulk UnSnooze',
         mbus_reporting_table_snooze_request_at: 'Request At',
         mbus_reporting_table_snooze_end_at: 'End At',
         mbus_reporting_snoozed_devices_table_all_filter: 'All',
         mbus_reporting_snoozed_devices_table_snoozed_filter: 'Snoozed',
         mbus_reporting_snoozed_devices_table_unsnoozed_filter: 'UnSnoozed',
         devices_list_diagnostics_condition_modal_single_meter_label: 'Meter',
         devices_list_diagnostics_condition_modal_multiple_meters_label:
           'Meters',
         devices_list_diagnostics_condition_modal_mbus_meters_dropdown_label:
           'Connected Mbus Meters',
         devices_list_diagnostics_condition_modal_are_mbus_connected_value_connected_label:
           'Connected',
         devices_list_diagnostics_condition_modal_are_mbus_connected_value_not_connected_label:
           'Not Connected',
         devices_list_diagnostics_condition_modal_mbus_meters_dropdown_select_record_label:
           'Select Connected Mbus Meters',
         devices_list_diagnostics_condition_modal_are_mbus_connected_dropdown_label:
           'Mbus Meters Connection',
         devices_list_diagnostics_condition_modal_are_mbus_connected_select_field_label:
           'Select connection status',
         devices_search_mbus_registers_multiple_devices_success:
           'The message has been successfully sent to the selected device(s).',
         devices_testing_button: 'Device Testing',
         devices_testing_form_header: 'Device Testing',
         devices_testing_device_serial_field: 'Device Serial',
         devices_testing_modbus_registers_field: 'Modbus Registers',
         devices_testing_modbus_registers_button_field: 'Send Modbus Message',
         devices_testing_single_mbus_register_field: 'Single MBus Register',
         devices_testing_single_mbus_register_button_field: 'Send Message',
         devices_testing_send_fetch_mbus_message: 'Send Fetch MBus Message',
         devices_testing_send_scan_mbus_message: 'Send Scan MBus Message',
         project_single_project_setting_mbus_hourly_logs_success_unset_message:
           'Mbus Hourly logs are successfully unset for the project',
         mbus_reporting_table_export_button: 'Export',
         mbus_reporting_table_export_file: 'Mbus Reporting',
         mbus_hourly_missing_reporting_export_button: 'Export',
         mbus_hourly_missing_reporting_export_file:
           'Mbus Hourly Missing Data Reporting',
         snoozed_devices_export_button: 'Export',
         snoozed_devices_export_file: 'Snoozed Devices',
         device_single_documentation_instructie_pomp_button: 'Instructie Pomp',
         sidebar_inconsistent_mbus_devices_reporting:
           'Inconsistent Mbus Devices',
         inconsistent_mbus_devices_reporting_table_header:
           'Inconsistent Mbus Devices',
         inconsistent_mbus_devices_reporting_bulk_export_button: 'Export',
         inconsistent_mbus_devices_reporting_filter_reset_button: 'Reset',
         inconsistent_mbus_devices_reporting_table_filter_search: 'Search',
         inconsistent_mbus_devices_reporting_table_created_at: 'Created At',
         inconsistent_mbus_devices_reporting_table_total_devices:
           'Total Devices',
         inconsistent_mbus_devices_reporting_table_total_projects:
           'Total Projects',
         inconsistent_mbus_devices_reporting_table_no_record_found:
           'No Record Found',
         inconsistent_mbus_devices_reporting_table_row_per_page:
           'Rows per page',
         inconsistent_mbus_devices_reporting_details_table_header:
           'Inconsistent Mbus Devices',
         inconsistent_mbus_devices_reporting_details_bulk_export_button:
           'Export',
         inconsistent_mbus_devices_reporting_details_filter_reset_button:
           'Reset',
         inconsistent_mbus_devices_reporting_details_table_filter_search:
           'Search',
         inconsistent_mbus_devices_reporting_details_table_created_at:
           'Created At',
         inconsistent_mbus_devices_reporting_details_table_device: 'Device',
         inconsistent_mbus_devices_reporting_details_table_project: 'Project',
         inconsistent_mbus_devices_reporting_details_table_client: 'Client',
         inconsistent_mbus_devices_reporting_details_table_firmware: 'Firmware',
         inconsistent_mbus_devices_reporting_details_table_actual_rmeters_count:
           'Actual Meters Count',
         inconsistent_mbus_devices_reporting_details_table_shown_meters_count:
           'Shown Meters Count',
         inconsistent_mbus_devices_reporting_details_table_no_record_found:
           'No Record Found',
         inconsistent_mbus_devices_reporting_details_table_row_per_page:
           'Rows per page',
         devices_mbus_meter_count: 'Mbus Meters',
         devices_bulk_modbus_download_form_data_type: 'Data Type',
         devices_bulk_modbus_download_form_export_type: 'Export Type',
         devices_bulk_modbus_download_form_data_type_daily: 'Daily',
         devices_bulk_modbus_download_form_data_type_hourly: 'Hourly',
         devices_bulk_modbus_download_form_export_type_combined: 'Combined',
         devices_bulk_modbus_download_form_export_type_separated: 'Separated',
         devices_bulk_export_modbus_historic_data_button:
           'Download Modbus Data',
         devices_bulk_export_modbus_historic_data_file_name:
           'Modbus Historic Data',
         devices_bulk_modbus_download_title: 'Download Modbus Historical Data',
         devices_bulk_modbus_download_form_date_range: 'Date Range:',
         devices_bulk_modbus_download_form_submit_button:
           'Download Modbus Data',
         devices_bulk_modbus_download_form_cancel_button: 'Cancel',
         devices_bulk_modbus_download_form_success:
           'Modbus Historical Data is emailed to ##EMAIL## successfully!',
         devices_bulk_modbus_download_form_api_error: 'Internal Server Alarm',
         devices_bulk_modbus_download_no_devices_error:
           'Please select atleast 1 device with correct TR Type (TR03/TR04)',
         devices_bulk_modbus_download_form_no_devices_error:
           'Please select devices to proceed.',
         devices_bulk_modbus_download_modal_title: 'Are you sure?',
         devices_bulk_modbus_download_modal_subtitle:
           'You want to run a bulk download historical Modbus data?',
         devices_bulk_modbus_download_modal_cancel_button: 'Cancel',
         devices_bulk_modbus_download_modal_submit_button: 'Confirm',
         projects_bulk_export_modbus_historic_data_file_name:
           'Modbus Historic Data',
         projects_bulk_modbus_download_title: 'Download Modbus Historical Data',
         projects_bulk_bulk_modbus_download_form_date_range: 'Date Range:',
         projects_bulk_bulk_modbus_download_form_data_export_type:
           'Date Export Type',
         projects_bulk_bulk_modbus_download_form_data_export_type_combined:
           'Combined',
         projects_bulk_bulk_modbus_download_form_data_export_type_daily:
           'Daily',
         projects_bulk_bulk_modbus_download_form_data_export_type_normal:
           'Normal',
         projects_bulk_bulk_modbus_download_form_submit_button:
           'Download Modbus Data',
         projects_bulk_bulk_modbus_download_form_cancel_button: 'Cancel',
         projects_bulk_modbus_download_form_success:
           'Modbus Historical Data is emailed to ##EMAIL## successfully!',
         projects_bulk_modbus_download_form_api_error: 'Internal Server Alarm',
         projects_bulk_modbus_download_no_projects_error: '',
         projects_bulk_modbus_download_form_no_projects_error:
           'Please select projects to proceed.',
         projects_bulk_bulk_modbus_download_modal_title: 'Are you sure?',
         projects_bulk_modbus_download_modal_subtitle:
           'You want to run a bulk download historical Modbus data?',
         projects_bulk_modbus_download_modal_cancel_button: 'Cancel',
         projects_bulk_modbus_download_modal_submit_button: 'Confirm',
         projects_bulk_modbus_selected_projects: 'Projects Selected',
         device_single_status_modbus_date_export_label: 'Date',
         device_single_download_modbus_data: 'Modbus Export',
         device_monitoring_maxitel_status_heading: 'Network Status',
         device_monitoring_maxitel_status_online: 'Online',
         device_monitoring_maxitel_status_offline: 'Offline',
         device_monitoring_maxitel_operational_status: 'Operational',
         device_monitoring_maxitel_non_operational_status: 'Not Operational',
         device_monitoring_maxitel_mobile_on_cloud_network_green:
           'MaxiTEL MobileOnCloud - Network Purple',
         device_monitoring_maxitel_mobile_on_cloud_network_purple:
           'MaxiTEL MobileOnCloud - Network Green',
         device_monitoring_maxitel_mobile_data_network_purple:
           'Mobile data - Network Purple',
         device_monitoring_maxitel_mobile_m2m_blend: 'M2M Blend',
         device_monitoring_maxitel_other_api: 'API',
         device_monitoring_maxitel_other_portal: 'Portal',
         device_monitoring_maxitel_updated_at: 'Updated',
         admins_last_seen: 'Last Seen',
         device_monitoring_send_grid_email_reached: 'Email Limit Reached',
         sidebar_email_reporting: 'Email Report',
         email_reporting_title: 'Email Reporting',
         email_reporting_tab_all: 'All',
         email_reporting_tab_passed: 'Passed',
         email_reporting_tab_failed: 'Failed',
         email_reporting_table_email_forwarded_at: 'Forwarded Date',
         email_reporting_table_to: 'To',
         email_reporting_table_recipient_name: 'Recipient Name',
         email_reporting_table_subject: 'Subject',
         email_reporting_table_status: 'Status',
         email_reporting_table_no_record_found: 'No Records Found',
         email_reporting_single_output_tab: 'Email Content',
         email_reporting_single_second_bread_crumb: 'Email Detail',
         email_reporting_single_email_logs_title: 'Email Logs',
         email_reporting_table_resend_failed_email_success_message:
           'Emails are forwarded again.',
         email_reporting_table_resend_failed_email_error_message:
           'Please select atleast records to resend email',
         email_reporting_table_resend_failed_email_button: 'Resend Email',
         email_reporting_table_filter_search: 'Search',
         email_reporting_table_row_per_page: 'Rows per page',
         settings_menu_modbus_global_configuration_title:
           'Modbus Global Configuration',
         settings_menu_modbus_global_configuration_title_form_header:
           'Modbus Global Configuration',
         settings_menu_modbus_global_configuration_TR03_tab: 'TR03 Settings',
         settings_menu_modbus_global_configuration_TR04_tab: 'TR04 Settings',
         settings_menu_modbus_global_configuration_form_success:
           'Modbus Global Configurations are saved successully',
         settings_menu_modbus_global_configuration_form_error:
           'Failed to update Modbus Global Configurations',
         settings_menu_modbus_global_configuration_form_save_button:
           'Save Modbus Settings',
         commissioning_form_stepper_validation_modbus_loading_title:
           'Modbus check takes upto 1 - 3 minutes',
         settings_menu_modbus_global_configuration_title_form_header_add_new:
           'Add New',
         settings_menu_modbus_global_configuration_title_add_form_header:
           'Add Article Number',
         settings_menu_modbus_global_configuration_article_number_field:
           'Article Number',
         settings_menu_modbus_global_configuration_article_number_required_form_error:
           'Article Number is required',
         settings_menu_modbus_global_configuration_article_number_unique_form_error:
           'Article Number already exists. Please provide a unique Article Number',
         settings_menu_modbus_global_configuration_type_field: 'Type',
         settings_menu_modbus_global_configuration_type_required_form_error:
           'Type is required',
         settings_menu_modbus_global_configuration_type_default_option:
           'Select a Type',
         settings_menu_modbus_global_configuration_add_success_message:
           'Article Number is successfully added',
         settings_menu_modbus_global_configuration_cancel_button: 'Cancel',
         settings_menu_modbus_global_configuration_save_button: 'Save',
         missing_article_number_message:
           'The Article Number field is either empty or not registered in the Modbus Global Configurations. Please commission the device. If the issue persists, contact your administrator.',
         // General Modbus Control / Status registers(90-99) - TR04
         general_modbus_control_TR04_80: 'Firmware Image status',
         general_modbus_control_TR04_81: 'Firmware Image ID',
         general_modbus_control_TR04_82: 'Defaults Image status',
         general_modbus_control_TR04_83: 'Defaults Image Checksum',
         general_modbus_control_TR04_96: 'Modbus Version',
         general_modbus_control_TR04_97: 'Modbus Device type / table',
         general_modbus_control_TR04_98: 'Unit selection ',
         general_modbus_control_TR04_99: 'Control register ',

         // Operating Status - TR04
         business_situation_operating_status_TR04_title:
           'Operating state Heat Interface Unit',
         business_situation_operating_status_TR04_100: 'CH Control state',
         business_situation_operating_status_TR04_100_list: JSON.stringify({
           list: {
             0: 'Idle',
             1: 'Request',
             2: 'Demand',
             3: 'Post Circulation',
             4: 'Off',
             5: 'Pre Circulation',
           },
         }),
         business_situation_operating_status_TR04_101: 'DHW Control State',
         business_situation_operating_status_TR04_101_list: JSON.stringify({
           list: {
             0: 'Idle',
             1: 'Request',
             2: 'Demand',
             3: 'Post Circulation',
             4: 'Off',
           },
         }),
         business_situation_operating_status_TR04_102: 'Preheat Control State',
         business_situation_operating_status_TR04_102_list: JSON.stringify({
           list: {
             0: 'Idle',
             1: 'Request',
             2: 'Demand',
             3: 'Post Circulation',
             4: 'Off',
           },
         }),
         business_situation_operating_status_TR04_103:
           'Anti-Legionella control state',
         business_situation_operating_status_TR04_103_list: JSON.stringify({
           list: {
             0: 'Idle',
             1: 'Request',
             2: 'Demand',
             3: 'Post Circulation',
             4: 'Off',
           },
         }),
         business_situation_operating_status_TR04_104: 'Cooling Control state',
         business_situation_operating_status_TR04_104_list: JSON.stringify({
           list: {
             0: 'Idle',
             1: 'Request',
             2: 'Demand',
             3: 'Post Cooling',
             4: 'Off',
             5: 'Pre Circulation',
             6: 'Init',
           },
         }),

         business_situation_operating_status_TR04_105: 'Alarm Code',
         business_situation_operating_status_TR04_106: 'Software version',
         business_situation_operating_status_TR04_107:
           'StepperMotor1 Actual Position',
         business_situation_operating_status_TR04_108:
           'StepperMotor2 Actual Position',
         business_situation_operating_status_TR04_109: 'Pump',
         business_situation_operating_status_TR04_109_list: JSON.stringify({
           list: {
             0: 'Off',
             1: 'On',
           },
         }),
         business_situation_operating_status_TR04_110: 'Valve1',
         business_situation_operating_status_TR04_110_list: JSON.stringify({
           list: {
             0: 'Position: Heating',
             1: 'Position: Cooling',
           },
         }),
         business_situation_operating_status_TR04_112_list: JSON.stringify({
           list: {
             0: 'Heating or demand',
             1: 'Cooling',
           },
         }),
         business_situation_operating_status_TR04_113: 'Room thermostat input',
         business_situation_operating_status_TR04_113_list: JSON.stringify({
           list: {
             0: 'Open',
             1: 'Closed',
           },
         }),
         business_situation_operating_status_TR04_114: 'OpenTherm Indicator',
         business_situation_operating_status_TR04_114_list: JSON.stringify({
           list: {
             0: 'Inactive',
             1: 'Active',
           },
         }),
         business_situation_operating_status_TR04_115: 'Appliance Type',

         // Business situation - TR04
         business_situation_measured_values_TR04_title: 'Measurements',
         business_situation_measured_values_TR04_200: 'Flow rate',
         business_situation_measured_values_TR04_201: 'DHW Out temperature',
         business_situation_measured_values_TR04_202: 'Primary supply',
         business_situation_measured_values_TR04_203: 'Primary return',
         business_situation_measured_values_TR04_205: 'Secondary CH Supply',
         business_situation_measured_values_TR04_206: 'Secondary CH Return',
         business_situation_measured_values_TR04_204: 'CH calculated setpoint',
         business_situation_measured_values_TR04_207: 'OT Room Temperature',
         business_situation_measured_values_TR04_208: 'OT CH Setpoint',
         business_situation_measured_values_TR04_209: 'Outdoor Temperature',
         business_situation_measured_values_TR04_210: 'Water pressure',
         business_situation_measured_values_TR04_213: 'Primary DHW Return',
         business_situation_measured_values_TR04_214: 'Primary CH Return',

         // Operating time - TR04
         business_situation_operating_time_TR04_title: 'Operating Time',
         business_situation_operating_time_TR04_800: 'System Run Time',
         business_situation_operating_time_TR04_801: 'CH Burn Time',
         business_situation_operating_time_TR04_802: 'Cooling Time',
         business_situation_operating_time_TR04_803: 'DHW Burn Time',
         business_situation_operating_time_TR04_804: 'Number of tappings',

         // Lockout History-TR04
         lockout_time_TR04_title: 'Lockout History',
         lockout_time_TR04_820: 'Lock-out 1',
         lockout_time_TR04_821: 'Lock-out 2',
         lockout_time_TR04_822: 'Lock-out 3',
         lockout_time_TR04_823: 'Lock-out 4',
         lockout_time_TR04_824: 'Lock-out 5',
         lockout_time_TR04_825: 'Lock-out 6',
         lockout_time_TR04_826: 'Lock-out 7',
         lockout_time_TR04_827: 'Lock-out 8',
         lockout_time_TR04_828: 'Lock-out 9',
         lockout_time_TR04_829: 'Lock-out 10',
         lockout_time_TR04_830: 'Lock-out 11',
         lockout_time_TR04_831: 'Lock-out 12',
         lockout_time_TR04_832: 'Lock-out 13',
         lockout_time_TR04_833: 'Lock-out 14',
         lockout_time_TR04_834: 'Lock-out 15',
         lockout_time_TR04_835: 'Lock-out 16',
         lockout_time_TR04_836: 'Lock-out history time 1',
         lockout_time_TR04_837: 'Lock-out history time 2',
         lockout_time_TR04_838: 'Lock-out history time 3',
         lockout_time_TR04_839: 'Lock-out history time 4 ',
         lockout_time_TR04_840: 'Lock-out history time 5 ',
         lockout_time_TR04_841: 'Lock-out history time 6 ',
         lockout_time_TR04_842: 'Lock-out history time 7',
         lockout_time_TR04_843: 'Lock-out history time 8',
         lockout_time_TR04_844: 'Lock-out history time 9',
         lockout_time_TR04_845: 'Lock-out history time 10',
         lockout_time_TR04_846: 'Lock-out history time 11',
         lockout_time_TR04_847: 'Lock-out history time 12',
         lockout_time_TR04_848: 'Lock-out history time 13',
         lockout_time_TR04_849: 'Lock-out history time 14',
         lockout_time_TR04_850: 'Lock-out history time 15',
         lockout_time_TR04_851: 'Lock-out history time 16',
         // Blocking History-TR04
         blocking_history_TR04_860: 'Blocking 1',
         blocking_history_TR04_861: 'Blocking 2',
         blocking_history_TR04_862: 'Blocking 3',
         blocking_history_TR04_863: 'Blocking 4',
         blocking_history_TR04_864: 'Blocking 5',
         blocking_history_TR04_865: 'Blocking 6',
         blocking_history_TR04_866: 'Blocking 7',
         blocking_history_TR04_867: 'Blocking 8',
         blocking_history_TR04_868: 'Blocking 9',
         blocking_history_TR04_869: 'Blocking 10',
         blocking_history_TR04_870: 'Blocking 11',
         blocking_history_TR04_871: 'Blocking 12',
         blocking_history_TR04_872: 'Blocking 13',
         blocking_history_TR04_873: 'Blocking 14',
         blocking_history_TR04_874: 'Blocking 15',
         blocking_history_TR04_875: 'Blocking 16',
         blocking_history_TR04_876: 'Blocking history time 1',
         blocking_history_TR04_877: 'Blocking history time 2',
         blocking_history_TR04_878: 'Blocking history time 3',
         blocking_history_TR04_879: 'Blocking history time 4',
         blocking_history_TR04_880: 'Blocking history time 5',
         blocking_history_TR04_881: 'Blocking history time 6',
         blocking_history_TR04_882: 'Blocking history time 7',
         blocking_history_TR04_883: 'Blocking history time 8',
         blocking_history_TR04_884: 'Blocking history time 9',
         blocking_history_TR04_885: 'Blocking history time 10',
         blocking_history_TR04_886: 'Blocking history time 11',
         blocking_history_TR04_887: 'Blocking history time 12',
         blocking_history_TR04_888: 'Blocking history time 13',
         blocking_history_TR04_889: 'Blocking history time 14',
         blocking_history_TR04_890: 'Blocking history time 15',
         blocking_history_TR04_891: 'Blocking history time 16',
         // Warmtapwater - TR04
         settings_dhw_warm_tap_water_TR04_title: 'Settings hot water',
         settings_dhw_warm_tap_water_TR04_300: 'DHW setpoint',
         settings_dhw_warm_tap_water_TR04_301: 'Preheat mode',
         settings_dhw_warm_tap_water_TR04_301_list: JSON.stringify({
           list: { 0: 'Eco', 1: 'Anti freeze', 2: 'Comfort', 3: 'Dynamic' },
         }),
         settings_dhw_warm_tap_water_TR04_302: 'Preheat Comfort setpoint',
         settings_dhw_warm_tap_water_TR04_303: 'Flow rate start threshold',
         settings_dhw_warm_tap_water_TR04_304: 'DHW Mode',
         settings_dhw_warm_tap_water_TR04_304_list: JSON.stringify({
           list: {
             0: 'Off',
             8: 'PID Controlled',
           },
         }),
         settings_dhw_warm_tap_water_TR04_305: 'DHW Primary Boost Exit Time',
         settings_dhw_warm_tap_water_TR04_306:
           'DHW Mode8 Dynamic Setpoint Active',
         settings_dhw_warm_tap_water_TR04_306_list: JSON.stringify({
           list: {
             0: 'Off',
             1: 'On',
           },
         }),
         settings_dhw_warm_tap_water_TR04_307: 'DHW Actual Setpoint',

         // Thermal disinfection - TR04
         settings_thermal_disinfection_TR04_title:
           'Settings Thermal disinfection',
         settings_thermal_disinfection_TR04_400: 'Aleg enabled',
         settings_thermal_disinfection_TR04_400_list: JSON.stringify({
           list: {
             0: 'Off',
             1: 'On',
           },
         }),
         settings_thermal_disinfection_TR04_401: 'Aleg burn time',
         settings_thermal_disinfection_TR04_402: 'Aleg burn time',
         settings_thermal_disinfection_TR04_403: 'Aleg wait time',

         // Heating - TR04
         heating_and_cooling_settings_heating_TR04_title: 'Settings heating',
         heating_and_cooling_settings_heating_TR04_500: 'CH Max Setpoint',
         heating_and_cooling_settings_heating_TR04_501: 'CH Min Setpoint',
         heating_and_cooling_settings_heating_TR04_502: 'OutdoorResetMin',
         heating_and_cooling_settings_heating_TR04_503: 'OutdoorResetMax',
         heating_and_cooling_settings_heating_TR04_504: 'WarmWeatherShut',
         heating_and_cooling_settings_heating_TR04_506:
           'Maximum primary return',
         heating_and_cooling_settings_heating_TR04_507:
           'Max Primary Return perc',
         heating_and_cooling_settings_heating_TR04_508:
           'Delta Prim CH Setpoint',
         heating_and_cooling_settings_heating_TR04_509: 'Delta Prim min',
         heating_and_cooling_settings_heating_TR04_510: 'Max Heating Temp',
         heating_and_cooling_settings_heating_TR04_514: 'CH Setpoint',
         heating_and_cooling_settings_heating_TR04_515: 'CH Mode',
         heating_and_cooling_settings_heating_TR04_515_list: JSON.stringify({
           list: {
             0: 'PID',
             8: 'Open/Close',
             9: 'Primary Delta-T',
             10: 'Secondary Delta-T',
           },
         }),

         // Cooling - TR04
         heating_and_cooling_settings_cooling_TR04_title: 'Settings cooling',
         heating_and_cooling_settings_cooling_TR04_600: 'CoolTempSetpoint',
         heating_and_cooling_settings_cooling_TR04_601:
           'Cool MaxPrimary Return',
         heating_and_cooling_settings_cooling_TR04_602:
           'Cool % of Max Setpoint compensation',
         heating_and_cooling_settings_cooling_TR04_605: 'Max Cooling Temp',
         heating_and_cooling_settings_cooling_TR04_606: 'Cool setpoint min',
         heating_and_cooling_settings_cooling_TR04_607: 'Cool setpoint max',
         heating_and_cooling_settings_cooling_TR04_608: 'Condens protection',
         heating_and_cooling_settings_cooling_TR04_608_list: JSON.stringify({
           list: {
             0: 'Off',
             1: 'On',
           },
         }),
         heating_and_cooling_settings_cooling_TR04_609: 'Condens timer',
         heating_and_cooling_settings_cooling_TR04_610:
           'Condens Increased setpoint',
         heating_and_cooling_settings_cooling_TR04_611: 'Cooling enable',
         heating_and_cooling_settings_cooling_TR04_611_list: JSON.stringify({
           list: {
             0: 'Off',
             1: 'On',
           },
         }),

         // Secondary General - TR04
         heating_and_cooling_settings_secondary_general_TR04_title:
           'Settings general',
         heating_and_cooling_settings_secondary_general_TR04_512:
           'CH Min Pressure',
         heating_and_cooling_settings_secondary_general_TR04_513:
           'CH Max Pressure',
         heating_and_cooling_settings_secondary_general_TR04_603:
           'CoolHeatWaitingTime',
         heating_and_cooling_settings_secondary_general_TR04_604:
           '6-way valve waiting time',

         // Manual Operation - TR04
         settings_manual_operation_TR04_title: 'Manual control',
         settings_manual_operation_TR04_700: 'Manual control enable',
         settings_manual_operation_TR04_700_list: JSON.stringify({
           list: {
             0: 'Off',
             1: 'On',
           },
         }),
         settings_manual_operation_TR04_701: 'MCV-1 Manual control',
         settings_manual_operation_TR04_702: 'MCV-2 Manual control',
         settings_manual_operation_TR04_703: 'Manual (CH) Pump setting',
         settings_manual_operation_TR04_703_list: JSON.stringify({
           list: {
             0: 'Off',
             1: 'On',
           },
         }),
         settings_manual_operation_TR04_704: 'Manual 6-way valve position',
         settings_manual_operation_TR04_704_list: JSON.stringify({
           list: {
             0: 'Heating',
             1: 'Cooling',
           },
         }),
         settings_manual_operation_TR04_707: 'MCV-1 Manual control[%]',
         settings_manual_operation_TR04_708: 'MCV-2 Manual control[%]',
         settings_manual_operation_TR04_709: 'Manual control timeout',
         // DeltaP Parameters(LIN-PUMP)
         deltap_parameters_TR04_1870_1871: 'Customer installation pressure',
         deltap_parameters_TR04_1872_1873: 'DeltaP KV-Value',
         deltap_parameters_TR04_1874_1875: 'DeltaP Max Pressure',
         device_status_name_TR03: 'Name (TR03)',
         device_status_name_TR04: 'Name (TR04)',
         device_single_set_register_device_tr_type_unavailable:
           'Device Type is unavailable for the whole project',
         sidebar_terms_and_conditions_title: 'Terms and Conditions',
         sidebar_support_text: 'Questions or comments? Email',
         sidebar_support_text_copied: 'Email Copied!',
         settings_menu_legal_document_title: 'Legal Documents',
         legal_documents_name_en_required_form_error:
           'Document Name (EN) is required',
         legal_documents_name_nl_required_form_error:
           'Document Name (NL) is required',
         legal_documents_name_fr_required_form_error:
           'Document Name (FR) is required',
         legal_documents_name_de_required_form_error:
           'Document Name (DE) is required',
         legal_documents_name_dk_required_form_error:
           'Document Name (DK) is required',
         legal_documents_title_en_required_form_error:
           'Document Popup Title (EN) is required',
         legal_documents_title_nl_required_form_error:
           'Document Popup Title (NL) is required',
         legal_documents_title_fr_required_form_error:
           'Document Popup Title (FR) is required',
         legal_documents_title_de_required_form_error:
           'Document Popup Title (DE) is required',
         legal_documents_title_dk_required_form_error:
           'Document Popup Title (DK) is required',
         legal_documents_checkbox_label_en_required_form_error:
           'Document Checkbox Label (EN) is required',
         legal_documents_checkbox_label_nl_required_form_error:
           'Document Checkbox Label (NL) is required',
         legal_documents_checkbox_label_fr_required_form_error:
           'Document Checkbox Label (FR) is required',
         legal_documents_checkbox_label_de_required_form_error:
           'Document Checkbox Label (DE) is required',
         legal_documents_checkbox_label_dk_required_form_error:
           'Document Checkbox Label (DK) is required',
         legal_documents_document_url_required_form_error:
           'Legal Document is required',
         legal_documents_version_required_form_error: 'Version is required',
         legal_documents_type_required_form_error: 'Document Type is required',
         legal_documents_add_form_success:
           'Legal Document is successfully created',
         legal_documents_form_api_error:
           'Failed to created Legal Document due to Internal Server Alarm',
         legal_documents_form_legal_document_name_en_field:
           'Document Name (EN)',
         legal_documents_form_legal_document_name_nl_field:
           'Document Name (NL)',
         legal_documents_form_legal_document_name_fr_field:
           'Document Name (FR)',
         legal_documents_form_legal_document_name_de_field:
           'Document Name (DE)',
         legal_documents_form_legal_document_name_dk_field:
           'Document Name (DK)',
         legal_documents_form_legal_document_title_en_field:
           'Document Popup Title (EN)',
         legal_documents_form_legal_document_title_nl_field:
           'Document Popup Title (NL)',
         legal_documents_form_legal_document_title_fr_field:
           'Document Popup Title (FR)',
         legal_documents_form_legal_document_title_de_field:
           'Document Popup Title (DE)',
         legal_documents_form_legal_document_title_dk_field:
           'Document Popup Title (DK)',
         legal_documents_form_legal_document_checkbox_label_en_field:
           'Document Checkbox Label (EN)',
         legal_documents_form_legal_document_checkbox_label_nl_field:
           'Document Checkbox Label (NL)',
         legal_documents_form_legal_document_checkbox_label_fr_field:
           'Document Checkbox Label (FR)',
         legal_documents_form_legal_document_checkbox_label_de_field:
           'Document Checkbox Label (DE)',
         legal_documents_form_legal_document_checkbox_label_dk_field:
           'Document Checkbox Label (DK)',
         legal_documents_form_legal_document_document_url_field:
           'Upload Legal Document (PDF)',
         legal_documents_form_legal_document_version_field: 'Version',
         legal_documents_form_legal_document_type_field: 'Document Type',
         legal_documents_form_legal_is_mandatory_field:
           'Is Document Manadatory',
         legal_documents_form_add_legal_document_button: 'Add Document',
         legal_documents_form_cancel_button: 'Cancel',
         add_legal_documents_form_header: 'Add Legal Document',
         add_legal_documents_bread_crumb_first_link: 'Add Legal Document',
         legal_documents_bread_crumb_main_title: 'Legal Documents',
         legal_documents_edit_form_success:
           'Legal Document is successfully updated',
         legal_documents_form_edit_legal_document_button: 'Edit Document',
         edit_legal_documents_form_header: 'Edit Legal Document',
         edit_legal_documents_bread_crumb_first_link: 'Edit Legal Document',
         loginTermsOfUseInfo: 'To continue, please agree to the Terms of Use',
         legal_documents_table_document_name_en: 'Document Name (EN)',
         legal_documents_table_document_title_en: 'Document Popup Title (EN)',
         legal_documents_table_document_checkbox_label_en:
           'Document Checkbox Label (EN)',
         legal_documents_table_document_document_url: 'Legal Document',
         legal_documents_table_document_type: 'Document Type',
         legal_documents_table_version: 'Version',
         legal_documents_table_updated_at: 'Updated At',
         legal_documents_table_is_default: 'Status',
         legal_documents: 'Legal Documents',
         legal_documents_add_new: 'Add Legal Document',
         legal_documents_table_row_per_page: 'Rows per page',
         legal_documents_no_record_found: 'No Records Found',
         legal_documents_filter_delete_button: 'Delete',
         legal_documents_status_default: 'Default',
         legal_documents_status_archived: 'Archived',
         legal_documents_all: 'All',
         legal_documents_filter_search: 'Search',
         legal_documents_default_document_success_message:
           '"LEGAL_DOC_TYPE" default Legal Document is successfully updated.',
         legal_documents_bulk_delete_button: 'Delete',
         legal_documents_bulk_delete_success_message:
           'Legal Document(s) are successfully deleted',
         legal_documents_bulk_delete_error_message:
           'Please select multiple records to delete',
         legal_documents_bulk_delete_title: 'Are you sure?',
         legal_documents_bulk_delete_subtitle: 'You want to delete Records?',
         legal_documents_upload_success:
           'Document is upload successfully, please submit the changes.',
         legal_documents_upload_file_type_error: 'Only PDF files are allowed.',
         legal_documents_upload_file_size_error:
           'File size should be less than 20 MB.',
         legal_documents_uploading_text: 'Uploading...',
         legal_documents_reset_legal_documents_status_modal_title:
           'Are you sure?',
         legal_documents_reset_legal_documents_status_modal_subtitle:
           'Users will have to accept the document again. Are you sure you want to continue?',
         legal_documents_reset_legal_documents_status_cancel_button: 'Cancel',
         legal_documents_reset_legal_documents_status_update_without_acceptance_request_button:
           'Update without Acceptance Request',
         legal_documents_reset_legal_documents_status_update_with_acceptance_request_button:
           'Update with Acceptance Request',
         legal_documents_table_already_default_document_message:
           'This document is already set as a default "LEGAL_DOC_TYPE" document',
         cookie_banner_main_title: 'Manage Consent',
         cookie_banner_main_subtitle:
           'This website uses cookies to improve your user experience. By using our website you consent to all cookies in accordance with our Cookie Policy.',
         cookie_banner_essential_cookie_title: 'Essential Cookies',
         cookie_banner_essential_cookie_status_title: 'Always Active',
         cookie_banner_essential_cookie_subtitle:
           'Essential Cookies are crucial for a website basic functions, such as keeping you logged in, remembering settings, and ensuring security. They are necessary for the site to work properly and cannot be turned off.',
         cookie_banner_tracking_cookie_title: 'Tracking Cookies',
         cookie_banner_tracking_cookie_subtitle:
           'Tracking Cookies used by Google Analytics collect data on how you interact with the website, such as pages visited and time spent. This helps us understand user behavior and improve website performance. These cookies are optional and can be turned off.',
         cookie_banner_accept_button_title: 'Accept',
         cookie_banner_decline_button_title: 'Decline',
         cookie_banner_preferences_button_title: 'Preferences',
         cookie_banner_save_preferences_button_title: 'Save',
         settings_cookie_consent_title: 'Manage Cookies Consent',
         settings_cookie_tracking_cookies_title: 'Tracking Cookies',
         settings_cookie_tracking_cookies_success_message:
           'Tracking Cookies Status is updated successfully',
         settings_menu_partner_setting_title: 'Portal Settings',
         partner_settings_form_header: 'Portal Settings',
         partner_settings_form_logo_title: 'Logo',
         partner_settings_form_primary_color_title: 'Primary Color',
         partner_settings_form_secondary_color_title: 'Secondary Color',
         partner_settings_form_submit_button: 'Save Changes',
         partner_settings_form_white_label_success_message:
           'White-label is updated successfully.',
         devices_bulk_edit_registers_tr_device_type_unavailable:
           'Selected devices have no proper TR Type. Please perform device commissioning the devices',
         commissioning_form_stepper_validation_sim_connectivity_title:
           'Connectivity',
         commissioning_form_stepper_validation_sim_connectivity_default_setting:
           'Active',
         commissioning_form_stepper_validation_sim_connectivity_success:
           'Connectivity Active',
         commissioning_form_stepper_validation_sim_connectivity_error:
           'Connectivity Alarm',
         commissioning_form_stepper_validation_sim_connectivity_loading_title:
           'Connectivity check takes around 1 minute',
         device_single_device_settings_fetch_latest_settings_button_v2:
           'Data Collect',
         kong_account_created_subject:
           'Fortes Data Management - New API Gateway Account Created',
         kong_admin_user_form_create_success_message:
           'Kong Admin User created successfully!',
         kong_client_user_form_create_success_message:
           'Kong Client User created successfully!',
         kong_admin_user_form_update_success_message:
           'Kong Admin User updated successfully!',
         kong_client_user_form_update_success_message:
           'Kong Client User updated successfully!',
         kong_admin_user_form_error_message: 'Internal Server Alarm',
         kong_client_user_form_error_message: 'Internal Server Alarm',
         kong_admin_user_form_unique_error_message:
           'Email must be unique in Kong',
         kong_client_user_form_unique_error_message:
           'Email must be unique in Kong',
         kong_user_admin_single_api_documentation_link_label:
           'OpenAPI Specification',
         kong_client_bulk_deleted_message:
           '{{ USERS_COUNT }} Kong Clients are deleted successfully',
         devices_form_project_disabled_field:
           'The Project Field is disabled because this device is a service device',
         partner_settings_white_label: 'White Label',
         partner_settings_general_settings: 'General Setting',
         partner_settings_general_settings_partner_locales:
           'Available Languages',
         partner_settings_form_general_settings_success_message:
           'General Settings are updated successfully.',
         commissioning_form_article_number_is_missing_error:
           'Article Number is missing',
         commissioning_form_stepper_validation_sim_connectivity_check_started_title:
           'Started Connectivity Check',
         commissioning_form_stepper_validation_sim_connectivity_check_success_title:
           'Connectivity Success',
         commissioning_form_stepper_validation_project_modbus_settings_check_started_title:
           'Project Modbus Setting Check Started',
         commissioning_form_stepper_validation_project_modbus_settings_success_title:
           'Project Modbus Setting is Enabled',
         commissioning_form_stepper_validation_project_modbus_settings_disabled_title:
           'No Modbus specified in Project',
         commissioning_form_stepper_validation_sim_connectivity_missing_sim_number_error_event:
           'Connectivity Alarm - SIM Number is missing in the database',
         commissioning_form_stepper_validation_sim_connectivity_maxitel_error_event:
           'Connectivity Alarm - Network Provider API is not responding',
         commissioning_form_stepper_validation_firmware_is_less_then_2_title:
           'Device Firmware version i.e. ###DEVICE_FIRMWARE_VERSION### must be 2.x.x, Please perform an OTA operation to update the firmware version',
         commissioning_form_stepper_validation_firmware_is_missing_title:
           'Device Firmware version is missing',
         commissioning_form_stepper_validation_baud_rate_fetch_failed_error_event:
           'Modbus - Unable to Fetch Baud Rate. Expected Baud Rate was ###BAUD_RATE###',
         commissioning_form_stepper_validation_baud_rate_set_failed_error_event:
           'Modbus - Unable to Set Baud Rate ###BAUD_RATE###',
         commissioning_form_stepper_validation_modbus_connection_error_event:
           'Modbus - Not Connected',
         commissioning_form_stepper_validation_modbus_connection_success_event:
           'Modbus - Connected',
         commissioning_form_stepper_validation_mbus_meters_check_success_event:
           'Mbus - Device Mbus Meters Count i.e. ###DEVICE_MBUS_METERS_COUNT### matched with Project Settings Meters Count i.e. ###PROJECT_SETTINGS_MBUS_METERS_COUNT###',
         commissioning_form_stepper_validation_mbus_meters_check_error_event:
           "Mbus - Device Mbus Meters Count i.e. ###DEVICE_MBUS_METERS_COUNT### doesn't match with Project Settings Meters Count i.e. ###PROJECT_SETTINGS_MBUS_METERS_COUNT###",
         commissioning_form_stepper_validation_complete_success_event:
           'Validation process is successfully completed',
         device_bulk_insert_form_header: 'Device Insert',
         devices_form_order_type_field: 'Order Type',
         partner_settings_general_settings_distributor_article_number_label:
           'HIU Settings',
         partner_settings_general_settings_distributor_article_number_enable_settings_label:
           'Enable Distributor Article and Serial Number',
         partner_settings_general_settings_distributor_article_number_disable_settings_label:
           'Disable Distributor HIU Settings',
         devices_partner_serial_number:
           'Distributor Serial Number heat interface unit',
         devices_partner_article_number_field:
           'Distributor Article number heat interface unit',
         commissioning_form_stepper_validation_baud_rate_retries_label:
           'Baud Rate Retries',
         commissioning_form_stepper_validation_modbus_retries_label:
           'Modbus Connection Retries',
         commissioning_form_header_updated_information_title:
           'Updated Information',
         commissioning_form_header_report_title: 'Report',
         commissioning_form_header_report_connectivity:
           'Connectivity Step Status: ',
         commissioning_form_header_report_modbus_validation_title:
           'Modbus Validation: ',
         commissioning_form_header_report_mbus_validation_title:
           'Mbus Validation: ',
         commissioning_form_header_report_failed_status_title: 'Failed',
         commissioning_form_header_report_passed_status_title: 'Passed',
         commissioning_form_header_report_not_status_title: 'N/A',
         commissioning_form_stepper_validation_sim_connectivity_maxitel_success_event:
           'Network Provider API is working fine',
         project_single_project_error_devices_tab: 'Project Alarm History',
         device_monitoring_project_active_device_errors_counters_title:
           'Active Alarm Devices Counters',
         device_monitoring_project_active_device_errors_list_title:
           'Active Alarm Devices List',
         device_v2_settings_tab_general: 'General',
         device_v2_settings_tab_modbus: 'Modbus',
         device_v2_settings_tab_mbus: 'Mbus',
         device_single_device_settings_hiu_reset_device_v2: 'HIU Reset',
         device_single_device_settings_hiu_reset_message_forwarded:
           'Device HIU Modbus Reset message is forwarded to device',
         device_single_device_settings_interval_field: 'Interval',
         device_single_device_settings_interval_in_seconds_field:
           'Interval (Minutes)',
         device_single_device_settings_mbus_interval_message_forwarded:
           'Set Mbus Interval message is forwarded to device',
         device_single_device_settings_mbus_interval_error_message_forwarded:
           'Mbus Interval must be greater than or equal to 0',
         device_single_device_settings_mbus_interval: 'Mbus Interval',
         mbus_export_is_validated_field: 'Is Validated',
         device_single_device_settings_fqdn_field: 'Device FQDN',
         device_single_device_settings_fqdn_field_default_option: 'Select FQDN',
         device_single_device_settings_fqdn_error:
           'Please select a FQDN to proceed',
         device_single_device_settings_fqdn_message_forwarded:
           'FQDN message is forwarded to the device',
         projects_table_online_devices: 'Online Devices',
         add_subscriptions_form_header: 'Create Subscription Extension',
         subscriptions_bread_crumb_main_title: 'Subscriptions',
         add_subscriptions_bread_crumb_first_link:
           'Create Subscription Extension',
         subscriptionOrderNumber_required_form_error:
           'Subscription Order Number is required',
         subscriptionPeriod_required_form_error:
           'Subscription Period is required',
         projectId_required_form_error: 'Project is required',
         clientId_required_form_error: 'Client is required',
         subscriptionType_required_form_error: 'Subscription Type is required',
         subscription_form_subscriptionOrderNumber_field:
           'Subscription Order Number',
         subscription_form_subscriptionPeriod_field:
           'Subscription Period (months)',
         subscription_form_projectId_field: 'Project',
         subscription_form_clientId_field: 'Client',
         subscription_form_subscriptionType_field: 'Subscription Type',
         subscription_form_subscriptionStartDate_field:
           'Subscription Start Date',
         subscription_form_subscriptionEndDate_field:
           'Subscription Expected End Date',
         subscription_form_description_field: 'Description',
         subscription_form_notes_field: 'Notes',
         subscription_form_add_subscription_button: 'Save Changes',
         subscription_form_cancel_button: 'Cancel',
         subscription_add_form_success: 'Subscription is successfully created',
         subscription_form_api_error:
           'Failed to created Subscription due to Internal Server Alarm',
         subscriptions_form_header: 'Subscriptions',
         subscriptions_add_new: 'Create Subscription Extension',
         subscriptions_table_project: 'Project',
         subscriptions_table_client: 'Client',
         subscriptions_table_start_date: 'Start Date',
         subscriptions_table_end_date: 'End Date',
         subscriptions_table_subscriptionPeriod: 'Duration',
         subscriptions_table_total_device: 'Total Devices',
         subscriptions_table_total_credit: 'Total Credits',
         subscriptions_table_credit_used: 'Credits Used',
         subscriptions_table_credit_left: 'Credits Left',
         subscriptions_table_month_to_zero_credit: 'Months to Zero Credit',
         subscriptions_table_status: 'Status',
         subscriptions_table_loading: 'Loading...',
         subscriptions_no_record_found: 'No Records Found',
         subscriptions_all: 'All',
         subscriptions_active: 'Active',
         subscriptions_inactive: 'Inactive',
         subscriptions_expired: 'Expired',
         subscriptions_expiring_soon: 'Expiring Soon',
         subscriptions_table_row_per_page: 'Rows per page',
         subscriptions_filter_search: 'Search',
         subscriptions_filters: 'Filters',
         sidebar_subscriptions_overview: 'Subscriptions Overview',
         sidebar_subscriptions: 'Subscriptions',
         project_single_project_subscription_devices_tab:
           'Device Subscriptions',
         project_single_project_subscription_overview_tab:
           'Subscription Extensions',
         sidebar_subscriptions_analytics: 'Subscription Analytics',
         subscriptions_analytics_form_header: 'Subscription Analytics',
         devices_form_order_type_order_with_hiu: 'Order with HIU',
         devices_form_order_type_order_without_hiu: 'Order without HIU',
         subscription_status_overview_title: 'Subscription Status Overview',
         subscription_analytics_data_missing_message: 'Data is not available',
         subscription_analytics_data_loading_message: 'Data is loading ...',
         subscription_status_overview_subscriptions: 'Subscriptions',
         subscription_status_overview_expiring_soon: 'Expiring soon',
         subscription_status_overview_not_expiring_in_3_months:
           'Not expiring in 3 months',
         subscription_status_overview_expired: 'Expired',
         subscription_analytics_subscriptions_expiring_soon_title:
           'Subscriptions Expiring Soon',
         subscription_analytics_subscriptions_expiring_soon_2_weeks: '2 Weeks',
         subscription_analytics_subscriptions_expiring_soon_1_month: '1 month',
         subscription_analytics_subscriptions_expiring_soon_2_months:
           '2 months',
         subscription_analytics_subscriptions_expiring_soon_3_months:
           '3 months',
         subscription_analytics_subscriptions_expiring_soon_6_months:
           '6 months',
         subscription_analytics_subscriptions_expiring_soon_12_months:
           '12 months',
         subscription_analytics_subscriptions_expiring_soon_no_of_subscriptions:
           'No. of Subscriptions',
         subscription_analytics_projects_credits_timeline_title:
           'Projects Credits Timeline',
         subscription_analytics_projects_credits_timeline_no_of_credits:
           'No. of Credits',
         subscription_analytics_projects_credits_timeline_months: 'Months',
         subscription_analytics_projects_credits_timeline_jan: 'Jan',
         subscription_analytics_projects_credits_timeline_feb: 'Feb',
         subscription_analytics_projects_credits_timeline_mar: 'Mar',
         subscription_analytics_projects_credits_timeline_apr: 'Apr',
         subscription_analytics_projects_credits_timeline_may: 'May',
         subscription_analytics_projects_credits_timeline_jun: 'Jun',
         subscription_analytics_projects_credits_timeline_jul: 'Jul',
         subscription_analytics_projects_credits_timeline_aug: 'Aug',
         subscription_analytics_projects_credits_timeline_sep: 'Sep',
         subscription_analytics_projects_credits_timeline_oct: 'Oct',
         subscription_analytics_projects_credits_timeline_nov: 'Nov',
         subscription_analytics_projects_credits_timeline_dec: 'Dec',
         subscription_analytics_projects_credits_consumed: 'Credits Consumed',
         subscription_analytics_projects_credits_details_active_subscriptions:
           'Active Subscriptions',
         subscription_analytics_projects_credits_details_expiring_soon:
           'Expiring soon',
         subscription_analytics_projects_credits_details_expired_subscriptions:
           'Expired Subscriptions',
         subscription_analytics_projects_credits_details_expiring_in_3_months:
           'Expiring in 3 months',
         subscription_analytics_projects_credits_details_expiring_in_6_months:
           'Expiring in 6 months',
         partner_settings_general_settings_partner_timezone: 'Default Timezone',
         distributor_timezone_modal_update_distributor_and_external_api_timezone_only:
           'Update Distributor and External API timezone only',
         distributor_timezone_modal_update_distributor_and_all_users_timezone:
           'Update Distributor and all users timezone',
         distributor_timezone_modal_cancel: 'Cancel',
         distributor_timezone_modal_title: 'Are you sure?',
         distributor_timezone_modal_subtitle:
           'You want to update the timezone for the distributor module?',
         distributor_timezone_modal_success_message:
           'Timezone is successfully updated',
         distributor_timezone_modal_error_message: 'Timezone updation failed',
         commissioning_email_commissioned_at_field: 'Commissioned at',
         commissioning_email_commissioned_by_field: 'Commissioned by',
         commissioning_email_commissioned_status_field: 'Commissioned status',
         commissioning_email_commissioned_completed_hiu_details_field:
           'Completed HIU details',
         commissioning_email_mobile_connectivity_validation_field:
           'Mobile connectivity validation',
         commissioning_email_modbus_connectivity_validation_field:
           'Modbus connectivity validation',
         commissioning_email_mbus_connectivity_validation_field:
           'Mbus connectivity validation',
         commissioning_email_updated_address_details_field:
           'Updated address details',
         commissioning_email_title: 'Mercurius Commissioning Report',
         commissioning_email_commissioned_by_message:
           'Has proceeded to complete the commissioning process.',
         commissioning_email_subtitle:
           'Please find below the commissioning report of the recently commissioned Mercurius in your project.',
         commissioning_email_information:
           '{{ distributorName }} generates this report after completing the Mercurius commissioning process. This will allow you or your organisation to take timely action to resolve any issues with connecting the heating interface units and ensure correct commissioning.',
         commissioning_email_questions: `Questions? Please contact <a href="mailto:${process.env.REACT_APP_SUPPORT_EMAIL}"><span>${process.env.REACT_APP_SUPPORT_EMAIL}</span></a> for further support.`,
         commissioning_none_added_status: 'None Added',
         commissioning_partially_updated_status: 'Partially Updated',
         commissioning_completed_status: 'Completed',
         commissioning_hiu_failed: 'Failed',
         commissioning_hiu_passed: 'Passed',
         subscription_credits_overview_title: 'Credits Overview',
         subscription_credits_positive_credits: 'Positive',
         subscription_credits_negative_credits: 'Negative',
         partner_settings_general_settings_partner_locale: 'Default Language',
         distributor_locale_modal_update_distributor_locale_only:
           'Update Default Language only',
         distributor_locale_modal_update_distributor_and_all_users_locale:
           'Update Distributor and all users locale',
         distributor_locale_modal_cancel: 'Cancel',
         distributor_locale_modal_title: 'Are you sure?',
         distributor_locale_modal_subtitle:
           'You want to update the locale for the distributor module?',
         distributor_locale_modal_success_message:
           'Language is successfully updated',
         distributor_locale_modal_error_message: 'Language updation failed',
         users_form_timezone_field: 'Timezone',
         users_form_locale_field: 'Language',
         error_check_details_table_new_tab: 'New',
         error_check_details_table_resolved_tab: 'Resolved',
         error_check_details_table_active_tab: 'Active',
         error_check_details_table_error_status: 'Alarm Status',
         error_check_details_table_error: 'Alarm Code',
         error_check_details_table_error_at: 'Alarm At',
         partner_settings_general_settings_distributor_serial_number_and_article_number_settings_label:
           'Distributor Serial, Article and Order Number',
         kong_user_admin_single_client_label: 'Client',
         commissioning_updated_information_title: 'Updated Information',
         subscription_form_customerReference_field: 'Customer Reference',
         subscriptionCustomerReference_required_form_error:
           'Customer Reference is required',
         subscription_previous_credits_left: 'Previous Credits Left',
         subscription_new_credits_added: 'New Credits Added',
         subscription_actual_credits_available: 'Actual Credits Available',
         subscription_start_date: 'Start Date',
         subscription_expected_expiry_date: 'Expected Expiry Date',
         subscription_created_at: 'Created At',
         subscription_created_by: 'Created By',
         subscription_notes_detail_for_users:
           '(For Fortes Internal Use Only): Sales notes, follow-ups, and other relevant information can be documented here.',
         subscription_extension_overview: 'Subscription Extension Overview',
         view_subscriptions_form_header: 'View Subscription',
         current_subscription_state: 'Current subscription state',
         subscription_analytics_projects_credits_details_expiring_in_1_month:
           'Expiring in 1 month',
         business_situation_measured_values_TR04_211:
           'Filtered Outdoor Temperature',
         business_situation_measured_values_TR04_212:
           'Secondary Incoming Cold Water',
         business_situation_measured_values_TR04_215: 'Primary DHW Supply',
         business_situation_measured_values_TR04_216: 'Primary CH Supply',
         appliance_types_applicable: 'Applicable',
         appliance_types_device_dashboard: 'Device Dashboard',
         appliance_types_register_name: 'Register Name',
         firmware_registers_TR04_80: 'Firmware Image status',
         firmware_registers_TR04_80_list: JSON.stringify({
           list: {
             0: 'Partial image (Receiving image)',
             1: 'Valid image (Ready for programming)',
             2: 'Corrupt image',
             3: 'Unknown image',
             4: 'Unknown image',
             5: 'Unknown image',
             6: 'Unknown image',
             7: 'Unknown image',
             8: 'Unknown image',
             9: 'Unknown image',
             10: 'Unknown image',
           },
         }),
         firmware_registers_TR04_81_list: JSON.stringify({
           list: {
             0: 'Firmware/application image',
             1: 'Defaults image',
             2: 'Unknown image',
             3: 'Unknown image',
             4: 'Unknown image',
             5: 'Unknown image',
             6: 'Unknown image',
             7: 'Unknown image',
             8: 'Unknown image',
             9: 'Unknown image',
             10: 'Unknown image',
           },
         }),
         firmware_registers_TR04_82_list: JSON.stringify({
           list: {
             0: 'Partial image (Receiving image)',
             1: 'Valid image (Ready for programming)',
             2: 'Corrupt image',
             3: 'Unknown image',
             4: 'Unknown image',
             5: 'Unknown image',
             6: 'Unknown image',
             7: 'Unknown image',
             8: 'Unknown image',
             9: 'Unknown image',
             10: 'Unknown image',
           },
         }),
         firmware_registers_TR04_98_list: JSON.stringify({
           list: {
             0: '°C bar',
             1: '°F bar',
             2: '°C psi',
             3: '°F psi',
           },
         }),
         firmware_registers_TR04_81: 'Firmware Image ID',
         firmware_registers_TR04_82: 'Defaults Image status',
         firmware_registers_TR04_98: 'Unit selection',
         firmware_registers_TR04_title: 'Firmware Registers',
         lin_pump_delta_parameters_TR04_title: 'LIN-Pump DeltaP Parameters',
         lin_pump_delta_parameters_TR04_1871: 'DeltaP Customer Installation',
         lin_pump_delta_parameters_TR04_1873: 'DeltaP Kv Value',
         lin_pump_delta_parameters_TR04_1875: 'NV DeltaP Max',
         appliance_types_form_cancel_button: 'Cancel',
         appliance_types_form_submit_button: 'Save Changes',
         custom_popover_211_short_description: 'Filtered Outdoor Temperature',
         custom_popover_212_short_description: 'Secondary Incoming Cold Water',
         custom_popover_215_short_description: 'Primary DHW Supply',
         custom_popover_216_short_description: 'Primary CH Supply',
         custom_popover_80_short_description: 'Firmware Image status',
         custom_popover_81_short_description: 'Firmware Image ID',
         custom_popover_82_short_description: 'Defaults Image status',
         custom_popover_98_short_description: 'Unit selection',
         custom_popover_1871_short_description: 'DeltaP Customer Installation',
         custom_popover_1873_short_description: 'DeltaP Kv Value',
         custom_popover_1875_short_description: 'NV DeltaP Max',
         edit_devices_device_name_unique_error: 'Device Name must be unique',
         edit_devices_serial_number_unique_error:
           'Serial Number Mercurius must be unique',
         edit_devices_description_error: 'Type Heat Interface Unit is required',
         edit_devices_box_serial_number_unique_error:
           'Serial Number Heat Interface Unit must be unique',
         edit_devices_article_number_error: 'Article Number is required',
         edit_devices_distributor_article_number_error:
           'Distributor Article Number is required',
         edit_devices_distributor_serial_number_unique_error:
           'Distributor Serial Number Heat Interface Unit must be unique',
         edit_devices_prod_order_nr_week_error:
           'Production order number is required',
         edit_devices_sim_card_number_error: 'Sim card number is required',
         edit_devices_production_date_error: 'Production Date is required',
         custom_popover_211_long_description: 'Filtered Outdoor Temperature',
         custom_popover_212_long_description: 'Secondary Incoming Cold Water',
         custom_popover_215_long_description: 'Primary DHW Supply',
         custom_popover_216_long_description: 'Primary CH Supply',
         custom_popover_80_long_description: 'Firmware Image status',
         custom_popover_81_long_description: 'Firmware Image ID',
         custom_popover_82_long_description: 'Defaults Image status',
         custom_popover_98_long_description: 'Unit selection',
         custom_popover_1871_long_description: 'DeltaP Customer Installation',
         custom_popover_1873_long_description: 'DeltaP Kv Value',
         custom_popover_1875_long_description: 'NV DeltaP Max',
         devices_form_backend_error_message:
           'There are some issues with the fields. Kindly review the form and correct the errors to proceed.',
         devices_sim_card_number_length_and_type_form_error:
           'SIM card number must be numeric and exactly 19 digits',
         devices_sim_card_number_required_form_error:
           'SIM card number is required',
         devices_name_type_form_error:
           'Device name should contain only capital alphabets and numbers.',
         devices_name_min_length_form_error:
           'Device name length should be at least 5 characters long.',
         devices_name_max_length_form_error:
           'Device name length should be at most 6 characters long.',
         devices_serial_number_type_form_error:
           'Serial Number Mercurius should contain only alphabets and numbers.',
         devices_serial_number_min_length_form_error:
           'Serial Number Mercurius should be exactly 24 characters long.',
         devices_serial_number_max_length_form_error:
           'Serial Number Mercurius should be exactly 24 characters long.',
         devices_article_number_min_length_form_error:
           'Article Number should be between 10 and 13 characters.',
         devices_article_number_max_length_form_error:
           'Article Number should be between 10 and 13 characters.',
         device_single_device_error_reporting_tab: 'Alarm Reporting',
         error_reporting_alarm_type_field: 'Alarm Type',
         error_reporting_description_field: 'Description',
         error_reporting_resolution_field: 'Resolution',
         error_reporting_error_start_date_field: 'Start Date',
         error_reporting_error_end_date_field: 'End Date',
         error_reporting_error_counters_title: 'Historic Alarm Counters',
         error_reporting_error_counters_error: 'No data found',
         error_reporting_error_counters_no_graph_data_error:
           'The piechart is unavailable',
         error_reporting_error_counters_loading_data: 'Loading ...',
         errorReporting_TR04_255_errorName: 'NO_ERROR',
         errorReporting_TR04_255_errorDescription: 'No error',
         errorReporting_TR04_255_errorResolution: 'None',

         errorReporting_TR04_0_errorName: 'E2PROM_READ_ERROR',
         errorReporting_TR04_0_errorDescription: 'Internal software error',
         errorReporting_TR04_0_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR04_8_errorName: 'RAM_ERROR',
         errorReporting_TR04_8_errorDescription: 'Internal software error',
         errorReporting_TR04_8_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR04_10_errorName: 'E2PROM_ERROR',
         errorReporting_TR04_10_errorDescription:
           'Wrong safety parameters in E2prom',
         errorReporting_TR04_10_errorResolution: 'Replace controller',

         errorReporting_TR04_11_errorName: 'STATE_ERROR',
         errorReporting_TR04_11_errorDescription: 'Internal software error',
         errorReporting_TR04_11_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR04_12_errorName: 'ROM_ERROR',
         errorReporting_TR04_12_errorDescription: 'Internal software error',
         errorReporting_TR04_12_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR04_15_errorName: 'MAX_TEMP_ERROR',
         eerrorReporting_TR04_15_errorDescription:
           'The external overheat protection is enabled or the Secondary CH Supply sensor (TT-4) measures a temp higher than Maximum heating temp',
         errorReporting_TR04_15_errorResolution:
           'Resolve error and press reset button',

         errorReporting_TR04_17_errorName: 'STACK_ERROR',
         errorReporting_TR04_17_errorDescription: 'Internal software error',
         errorReporting_TR04_17_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR04_18_errorName: 'INSTRUCTION_ERROR',
         errorReporting_TR04_18_errorDescription: 'Internal software error',
         errorReporting_TR04_18_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR04_23_errorName: 'CORRUPTED_ERROR_NR',
         errorReporting_TR04_23_errorDescription:
           'Error code RAM byte was corrupted to an unknown error code',
         errorReporting_TR04_23_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR04_29_errorName: 'PSM_ERROR',
         errorReporting_TR04_29_errorDescription: 'Internal software error',
         errorReporting_TR04_29_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR04_30_errorName: 'REGISTER_ERROR',
         errorReporting_TR04_30_errorDescription: 'Internal software error',
         errorReporting_TR04_30_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR04_37_errorName: 'ADC_ERROR',
         errorReporting_TR04_37_errorDescription: 'Internal hardware error',
         errorReporting_TR04_37_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR04_39_errorName: 'E2PROM_VERSION_CHECK_ERROR',
         errorReporting_TR04_39_errorDescription: 'Internal software error',
         errorReporting_TR04_39_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR04_106_errorName: 'REFHI_TOO_HIGH',
         errorReporting_TR04_106_errorDescription: 'Internal hardware error',
         errorReporting_TR04_106_errorResolution: 'Replace controller',

         errorReporting_TR04_107_errorName: 'REFHI_TOO_LOW',
         errorReporting_TR04_107_errorDescription: 'Internal hardware error',
         errorReporting_TR04_107_errorResolution: 'Replace controller',

         errorReporting_TR04_108_errorName: 'REFLO_TOO_HIGH',
         errorReporting_TR04_108_errorDescription: 'Internal hardware error',
         errorReporting_TR04_108_errorResolution: 'Replace controller',

         errorReporting_TR04_109_errorName: 'REFLO_TOO_LOW',
         errorReporting_TR04_109_errorDescription: 'Internal hardware error',
         errorReporting_TR04_109_errorResolution: 'Replace controller',

         errorReporting_TR04_114_errorName: 'E2PROM_VERSION_ERROR',
         errorReporting_TR04_114_errorDescription: 'Internal software error',
         errorReporting_TR04_114_errorResolution: 'Replace controller',

         errorReporting_TR04_116_errorName: 'LOW_WATER_PRESSURE_SENSOR',
         errorReporting_TR04_116_errorDescription: 'Low water pressure',
         errorReporting_TR04_116_errorResolution:
           'Top up secondary water circuit to desired value',

         errorReporting_TR04_119_errorName: 'T_PRIMARY_CH_RETURN_OPEN',
         errorReporting_TR04_119_errorDescription:
           'Primary CH Return sensor open',
         errorReporting_TR04_119_errorResolution:
           'Check a/o replace return sensor a/o cable',

         errorReporting_TR04_120_errorName: 'T_PRIMARY_SUPPLY_OPEN',
         errorReporting_TR04_120_errorDescription: 'Primary Supply sensor open',
         errorReporting_TR04_120_errorResolution:
           'Check a/o replace supply sensor a/o cable',

         errorReporting_TR04_122_errorName: 'T_DHW_OUT_OPEN',
         errorReporting_TR04_122_errorDescription: 'DHW Output sensor open',
         errorReporting_TR04_122_errorResolution:
           'Check a/o replace DHW sensor a/o cable',

         errorReporting_TR04_126_errorName: 'T_PRIMARY_CH_RETURN_SHORTED',
         errorReporting_TR04_126_errorDescription:
           'Primary CH Return sensor shorted',
         errorReporting_TR04_126_errorResolution:
           'Check a/o replace return sensor a/o cable',

         errorReporting_TR04_127_errorName: 'T_PRIMARY_SUPPLY_SHORTED',
         errorReporting_TR04_127_errorDescription:
           'Primary Supply sensor shorted',
         errorReporting_TR04_127_errorResolution:
           'Check a/o replace supply sensor a/o cable',

         errorReporting_TR04_129_errorName: 'T_DHW_OUT_SHORTED',
         errorReporting_TR04_129_errorDescription: 'DHW Output sensor shorted',
         errorReporting_TR04_129_errorResolution:
           'Check a/o replace DHW sensor a/o cable',

         errorReporting_TR04_134_errorName: 'RESET_BUTTON_ERROR',
         errorReporting_TR04_134_errorDescription:
           'Too many re sets in a short time period',
         errorReporting_TR04_134_errorResolution:
           'Interrupt power supply HIU for approx.. 10 seconds',

         errorReporting_TR04_158_errorName: 'T_SECONDARY_CH_SUPPLY_OPEN',
         errorReporting_TR04_158_errorDescription:
           'Secondary CH Supply sensor open',
         errorReporting_TR04_158_errorResolution:
           'Check a/o replace supply sensor a/o cable',

         errorReporting_TR04_159_errorName: 'T_SECONDARY_CH_RETURN_OPEN',
         errorReporting_TR04_159_errorDescription:
           'Secondary CH Return sensor open',
         errorReporting_TR04_159_errorResolution:
           'Check a/o replace return sensor a/o cable',

         errorReporting_TR04_160_errorName: 'T_SECONDARY_CH_SUPPLY_SHORTED',
         errorReporting_TR04_160_errorDescription:
           'Secondary CH Supply sensor shorted',
         errorReporting_TR04_160_errorResolution:
           'Check a/o replace supply sensor a/o cable',

         errorReporting_TR04_161_errorName: 'T_SECONDARY_CH_RETURN_SHORTED',
         errorReporting_TR04_161_errorDescription:
           'Secondary CH Return sensor shorted',
         errorReporting_TR04_161_errorResolution:
           'Check a/o replace return sensor a/o cable',

         errorReporting_TR04_171_errorName: 'ADC_UNSTABLE',
         errorReporting_TR04_171_errorDescription:
           'ADC measurement detected too many unstable measurements',
         errorReporting_TR04_171_errorResolution: 'Replace controller',

         errorReporting_TR04_174_errorName: 'T_PRIMARY_DHW_RETURN_OPEN',
         errorReporting_TR04_174_errorDescription:
           'Primary DHW Return sensor open',
         errorReporting_TR04_174_errorResolution:
           'Check a/o replace DHW sensor a/o cable',

         errorReporting_TR04_175_errorName: 'T_PRIMARY_DHW_RETURN_SHORTED',
         errorReporting_TR04_175_errorDescription:
           'Primary DHW Return sensor shorted',
         errorReporting_TR04_175_errorResolution:
           'Check a/o replace DHW sensor a/o cable',

         errorReporting_TR04_203_errorName: 'HIGH_WATER_PRESSURE_SENSOR',
         errorReporting_TR04_203_errorDescription:
           'High (CH) water pressure detected',
         errorReporting_TR04_203_errorResolution:
           'Lower (CH) water pressure to below 3 bar',

         errorReporting_TR04_206_errorName: 'TE_BOOSTER_WARNING',
         errorReporting_TR04_206_errorDescription:
           'Water in TE Booster has not reached 75C during 24h or thermal safety lock enabled',
         errorReporting_TR04_206_errorResolution:
           'Power cycle TE Booster, press reset button on controller, power cycle TE Booster. Press red safety pin on bottom of TE Booster when protruded',

         errorReporting_TR04_207_errorName: 'POWERPACK_DEFECT_WARNING',
         errorReporting_TR04_207_errorDescription: 'PowerPack is defective',
         errorReporting_TR04_207_errorResolution: 'Replace controller',

         errorReporting_TR04_208_errorName: 'ERRORLOG_STORAGE_FAULT',
         errorReporting_TR04_208_errorDescription: 'Internal software warning',
         errorReporting_TR04_208_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR04_209_errorName: 'DATALOG_STORAGE_FAULT',
         errorReporting_TR04_209_errorDescription: 'Internal software warning',
         errorReporting_TR04_209_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR04_210_errorName: 'FIRMWARE_STORAGE_FAULT',
         errorReporting_TR04_210_errorDescription: 'Internal software warning',
         errorReporting_TR04_210_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR04_211_errorName: 'DEFAULTS_STORAGE_FAULT',
         errorReporting_TR04_211_errorDescription: 'Internal software warning',
         errorReporting_TR04_211_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR04_212_errorName: 'NO_PRIMARY_FLOW',
         errorReporting_TR04_212_errorDescription: 'No primary flow',
         errorReporting_TR04_212_errorResolution:
           'Check and/or replace primary piping, ball valves and/or MCV-1',

         errorReporting_TR04_213_errorName: 'LOW_PRIMARY_FLOW',
         errorReporting_TR04_213_errorDescription: 'Primary flow too low',
         errorReporting_TR04_213_errorResolution:
           'Check and/or replace primary piping, filter and/or MCV-1',

         errorReporting_TR04_214_errorName: 'UNDESIRED_PRIMARY_FLOW_MCV1',
         errorReporting_TR04_214_errorDescription:
           'Undesired primary flow warning for MCV1',
         errorReporting_TR04_214_errorResolution:
           'Check closure MCV-1, clogging and/or too high Delta-p',

         errorReporting_TR04_215_errorName: 'UNDESIRED_PRIMARY_FLOW_MCV1_2',
         errorReporting_TR04_215_errorDescription:
           'Undesired primary flow warning for MCV1 and MCV-2',
         errorReporting_TR04_215_errorResolution:
           'Check closure MCV-1 and MCV-2, clogging and/or too high Delta-p',

         errorReporting_TR04_216_errorName: 'T_ALEG_TOO_LOW',
         errorReporting_TR04_216_errorDescription:
           'Return temp too low during Anti-Legionella demand',
         errorReporting_TR04_216_errorResolution:
           'Check primary return temperature',

         errorReporting_TR04_217_errorName: 'T_DHW_TOO_HIGH',
         errorReporting_TR04_217_errorDescription:
           'DHW temp is too high ( > 70ºC for > 5 s.)',
         errorReporting_TR04_217_errorResolution:
           'Check primary supply temperature DHW',

         errorReporting_TR04_218_errorName: 'EVALUATION_TIMER_EXPIRED',
         errorReporting_TR04_218_errorDescription:
           'Evaluation Timer has expired',
         errorReporting_TR04_218_errorResolution: 'N/A',

         errorReporting_TR04_219_errorName: 'WATER_LEAK',
         errorReporting_TR04_219_errorDescription: 'Water leak detected',
         errorReporting_TR04_219_errorResolution: 'Solve water leakage',

         errorReporting_TR03_255_errorName: 'NO_ERROR',
         errorReporting_TR03_255_errorDescription: 'No error',
         errorReporting_TR03_255_errorResolution: 'None',

         errorReporting_TR03_0_errorName: 'E2PROM_READ_ERROR',
         errorReporting_TR03_0_errorDescription: 'Internal software error',
         errorReporting_TR03_0_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR03_4_errorName: 'BLOCKING_TOO_LONG',
         errorReporting_TR03_4_errorDescription:
           'Controller had a blocking error for more than 20 hours',
         errorReporting_TR03_4_errorResolution:
           'Press reset button and resolve underlying blocking error',

         errorReporting_TR03_8_errorName: 'RAM_ERROR',
         errorReporting_TR03_8_errorDescription: 'Internal software error',
         errorReporting_TR03_8_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR03_9_errorName: 'WRONG_EEPROM_SIGNATURE',
         errorReporting_TR03_9_errorDescription:
           'Contents of E2prom is not up to date',
         errorReporting_TR03_9_errorResolution: 'Replace controller',

         errorReporting_TR03_10_errorName: 'E2PROM_ERROR',
         errorReporting_TR03_10_errorDescription:
           'Wrong safety parameters in E2prom',
         errorReporting_TR03_10_errorResolution: 'Replace controller',

         errorReporting_TR03_11_errorName: 'STATE_ERROR',
         errorReporting_TR03_11_errorDescription: 'Internal software error',
         errorReporting_TR03_11_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR03_12_errorName: 'ROM_ERROR',
         errorReporting_TR03_12_errorDescription: 'Internal software error',
         errorReporting_TR03_12_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR03_15_errorName: 'MAX_TEMP_ERROR',
         errorReporting_TR03_15_errorDescription:
           'The external overheat protection is enabled or the Secondary Supply sensor (TT-1) measures a temp higher than Maximum heating temp',
         errorReporting_TR03_15_errorResolution:
           'Resolve error and press reset button',

         errorReporting_TR03_17_errorName: 'STACK_ERROR',
         errorReporting_TR03_17_errorDescription: 'Internal software error',
         errorReporting_TR03_17_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR03_18_errorName: 'INSTRUCTION_ERROR',
         errorReporting_TR03_18_errorDescription: 'Internal software error',
         errorReporting_TR03_18_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR03_23_errorName: 'CORRUPTED_ERROR_NR',
         errorReporting_TR03_23_errorDescription:
           'Error code RAM byte was corrupted due to an unknown error code',
         errorReporting_TR03_23_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR03_29_errorName: 'PSM_ERROR',
         errorReporting_TR03_29_errorDescription: 'Internal software error',
         errorReporting_TR03_29_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR03_30_errorName: 'REGISTER_ERROR',
         errorReporting_TR03_30_errorDescription: 'Internal software error',
         errorReporting_TR03_30_errorResolution:
           'Press reset button. If error remains, replace controller',

         errorReporting_TR03_36_errorName: 'COOLING_TO_HIGH',
         errorReporting_TR03_36_errorDescription:
           'Cooling temp on secondary supply too high. Cooling temp above Max cooling temp for >3 minutes.',
         errorReporting_TR03_36_errorResolution:
           'Reduce cooling temp. Press reset button. If alarm remains or returns, increase Max cooling temp to 55C. If alarm remains, replace controller.',

         errorReporting_TR03_106_errorName: 'REFHI_TOO_HIGH',
         errorReporting_TR03_106_errorDescription: 'Internal hardware error',
         errorReporting_TR03_106_errorResolution: 'Replace controller',

         errorReporting_TR03_107_errorName: 'REFHI_TOO_LOW',
         errorReporting_TR03_107_errorDescription: 'Internal hardware error',
         errorReporting_TR03_107_errorResolution: 'Replace controller',

         errorReporting_TR03_108_errorName: 'REFLO_TOO_HIGH',
         errorReporting_TR03_108_errorDescription: 'Internal hardware error',
         errorReporting_TR03_108_errorResolution: 'Replace controller',

         errorReporting_TR03_109_errorName: 'REFLO_TOO_LOW',
         errorReporting_TR03_109_errorDescription: 'Internal hardware error',
         errorReporting_TR03_109_errorResolution: 'Replace controller',

         errorReporting_TR03_110_errorName: 'REFHI2_TOO_HIGH',
         errorReporting_TR03_110_errorDescription: 'Internal hardware error',
         errorReporting_TR03_110_errorResolution: 'Replace controller',

         errorReporting_TR03_111_errorName: 'REFHI2_TOO_LOW',
         errorReporting_TR03_111_errorDescription: 'Internal hardware error',
         errorReporting_TR03_111_errorResolution: 'Replace controller',

         errorReporting_TR03_112_errorName: 'REFLO2_TOO_HIGH',
         errorReporting_TR03_112_errorDescription: 'Internal hardware error',
         errorReporting_TR03_112_errorResolution: 'Replace controller',

         errorReporting_TR03_113_errorName: 'REFLO2_TOO_LOW',
         errorReporting_TR03_113_errorDescription: 'Internal hardware error',
         errorReporting_TR03_113_errorResolution: 'Replace controller',

         errorReporting_TR03_115_errorName: 'LOW_WATER_PRESSURE_ERROR',
         errorReporting_TR03_115_errorDescription: 'Low water pressure error',
         errorReporting_TR03_115_errorResolution:
           'Top up secondary water circuit to desired value',

         errorReporting_TR03_116_errorName: 'LOW_WATER_PRESSURE_SENSOR',
         errorReporting_TR03_116_errorDescription: 'Low water pressure',
         errorReporting_TR03_116_errorResolution:
           'Top up secondary water circuit to desired value',

         errorReporting_TR03_119_errorName: 'RETURN_OPEN',
         errorReporting_TR03_119_errorDescription: 'Return sensor open',
         errorReporting_TR03_119_errorResolution:
           'Check a/o replace return sensor a/o cable',

         errorReporting_TR03_120_errorName: 'SUPPLY_OPEN',
         errorReporting_TR03_120_errorDescription: 'Supply sensor open',
         errorReporting_TR03_120_errorResolution:
           'Check a/o replace supply sensor a/o cable',

         errorReporting_TR03_121_errorName: 'SUPPLY2_OPEN',
         errorReporting_TR03_121_errorDescription: 'Supply 2 sensor open',
         errorReporting_TR03_121_errorResolution:
           'Check a/o replace supply sensor a/o cable',

         errorReporting_TR03_122_errorName: 'DHW_OPEN',
         errorReporting_TR03_122_errorDescription: 'DHW sensor open',
         errorReporting_TR03_122_errorResolution:
           'Check a/o replace DHW sensor a/o cable',

         errorReporting_TR03_126_errorName: 'RETURN_SHORTED',
         errorReporting_TR03_126_errorDescription: 'Return sensor shorted',
         errorReporting_TR03_126_errorResolution:
           'Check a/o replace return sensor a/o cable',

         errorReporting_TR03_127_errorName: 'SUPPLY_SHORTED',
         errorReporting_TR03_127_errorDescription: 'Supply sensor shorted',
         errorReporting_TR03_127_errorResolution:
           'Check a/o replace supply sensor a/o cable',

         errorReporting_TR03_128_errorName: 'SUPPLY2_SHORTED',
         errorReporting_TR03_128_errorDescription: 'Supply 2 sensor shorted',
         errorReporting_TR03_128_errorResolution:
           'Check a/o replace supply sensor a/o cable',

         errorReporting_TR03_129_errorName: 'DHW_SHORTED',
         errorReporting_TR03_129_errorDescription: 'DHW sensor shorted',
         errorReporting_TR03_129_errorResolution:
           'Check a/o replace DHW sensor a/o cable',

         errorReporting_TR03_134_errorName: 'RESET_BUTTON_ERROR',
         errorReporting_TR03_134_errorDescription:
           'Too many resets in a short time period',
         errorReporting_TR03_134_errorResolution:
           'Interrupt power supply HIU for approx. 10 seconds',

         errorReporting_TR03_167_errorName: 'RETURN2_SHORTED',
         errorReporting_TR03_167_errorDescription:
           'Secondary circuit supply sensor shorted',
         errorReporting_TR03_167_errorResolution:
           'Check a/o replace return sensor a/o cable',

         errorReporting_TR03_168_errorName: 'RETURN2_OPEN',
         errorReporting_TR03_168_errorDescription:
           'Secondary circuit return sensor shorted',
         errorReporting_TR03_168_errorResolution:
           'Check a/o replace return sensor a/o cable',

         errorReporting_TR03_169_errorName: 'HEAT_COOL_ACTIVE',
         errorReporting_TR03_169_errorDescription:
           'Simultaneous cooling and heating demand',
         errorReporting_TR03_169_errorResolution:
           'Check thermostat/controller a/o cables to avoid simultaneous cooling and heating demand',

         errorReporting_TR03_170_errorName: 'HW_IDENTIFIER_ERROR',
         errorReporting_TR03_170_errorDescription:
           'Hardware ID detection mismatch',
         errorReporting_TR03_170_errorResolution: 'Replace controller',

         errorReporting_TR03_203_errorName: 'HIGH_PRESSURE',
         errorReporting_TR03_203_errorDescription:
           'High (CH) water pressure detected',
         errorReporting_TR03_203_errorResolution:
           'Reduce water pressure in secondary circuit to under 3 bar',

         errorReporting_TR03_204_errorName: 'OUTDOOR_WRONG',
         errorReporting_TR03_204_errorDescription:
           'Outdoor sensor measures open/shorted',
         errorReporting_TR03_204_errorResolution:
           'Check a/o replace sensor a/or cable',

         errorReporting_TR03_206_errorName: 'TE_BOOSTER_WARNING',
         errorReporting_TR03_206_errorDescription:
           'TE Booster setpoint not achieved within set timer',
         errorReporting_TR03_206_errorResolution:
           'Check a/o replace (parts of the) TE Booster',
         errorReporting_errorType_lockout: 'Lockout',
         errorReporting_errorType_blocking: 'Blocking',
         errorReporting_errorType_warning: 'Warning',
         device_single_dashboard_active_error_title: 'Active Alarm',
         devices_box_serial_number_start_with_F_error:
           'Serial Number Heat Interface Unit must start with F',
         devices_form_default_controller_type_field: 'Default Controller Type',
         devices_form_default_soft_version_field: 'Default Software Version',
         devices_form_default_appliance_type_field: 'Default Appliance Type',
         devices_form_default_client_name_field: 'Default Client Name',
         projects_form_total_amount_order_field: 'Amount on Production Order',
         error_check_details_table_device_status_field: 'Device Status',
         error_check_details_table_export_generated_at_field: 'Generated At',
         error_check_details_table_export_generated_for_field: 'Generated for',
         error_check_details_table_export_generated_by_user_field:
           'Generated By',
         error_check_details_table_export_report_name_field: 'Name',
         error_check_details_table_export_active_alarms_report_field:
           'Active Alarms',
         error_check_details_table_export_active_new_alarms_report_field:
           'New Active Alarms',
         error_check_details_table_export_resolved_alarms_report_field:
           'Resolved Alarms',
         error_check_details_table_export_active_alarms_sheet_report_field:
           'Active Alarms',
         error_check_details_table_export_active_new_alarms_sheet_report_field:
           'New Active Alarms',
         error_check_details_table_export_resolved_alarms_sheet_report_field:
           'Resolved Alarms',
         projects_form_main_client_contact_field: 'Main Client Contact',
         projects_form_main_service_client_contact_field:
           'Main Service Client Contact',
         errorReporting_TR03_IN_ERROR_MODE_BUT_SHOULD_NOT_BE_VISIBLE_TO_USER_errorName:
           'Alarm',
         errorReporting_TR03_IN_ERROR_MODE_BUT_SHOULD_NOT_BE_VISIBLE_TO_USER_errorDescription:
           'Device is in Alarm Mode',
         errorReporting_TR03_IN_ERROR_MODE_BUT_SHOULD_NOT_BE_VISIBLE_TO_USER_errorResolution:
           'Contact Support Department',
         errorReporting_TR04_IN_ERROR_MODE_BUT_SHOULD_NOT_BE_VISIBLE_TO_USER_errorName:
           'Alarm',
         errorReporting_TR04_IN_ERROR_MODE_BUT_SHOULD_NOT_BE_VISIBLE_TO_USER_errorDescription:
           'Device is in Alarm Mode',
         errorReporting_TR04_IN_ERROR_MODE_BUT_SHOULD_NOT_BE_VISIBLE_TO_USER_errorResolution:
           'Contact Support Department',
         error_check_details_table_error_name: 'Alarm Name',
         devices_sim_card_number_form_unique_error:
           'Sim card number must be unique',
         roles_overview_bread_crumb_first_link:
           'Role Permissions Overview (Active Roles)',
         roles_overview_form_header: 'Role Permissions Overview (Active Roles)',
         roles_overview_fortes_roles_tab: 'Fortes Roles',
         roles_overview_client_roles_tab: 'Client roles',
         roles_overview_service_client_roles_tab: 'Service client roles',
         roles_overview_filter_roles_button: 'Filter Roles',
         roles_form_permissions_loading:
           'Loading data... This may take between 10 to 20 seconds. Thank you for your patience.',
         roles_overview_success_message:
           'Role permissions for active roles have been successfully updated.',
         roles_overview_error_message:
           'Failed to update role permissions for active roles. Please contact the administrator.',
         roles_overview_success_no_permission_change_message:
           'No permission changes detected. Navigating back to the roles overview page.',
         roles_overview_export_button: 'Export',
         roles_overview_export_file_name: 'Roles Overview',
         roles_list_table_roles_overview_button: 'Roles Overview',
         roles_overview_update_button: 'Update Roles',
         devices_form_first_event_timestamp_field: 'First Incoming Event Date',
         devices_list_diagnostics_condition_modal_sensor_type_field_label:
           'Sensor Type',
         devices_list_diagnostics_condition_modal_controller_type_field_label:
           'Controller Type',
         subscription_form_unique_error_message:
           'Subscription Order Number already exist',

         email_common_questions: `Questions? Please contact <a style="color: ${primaryColor};" href="mailto:${process.env.REACT_APP_SUPPORT_EMAIL}"><span>${process.env.REACT_APP_SUPPORT_EMAIL}</span></a> for further support.`,
         email_common_footer_receiving:
           'You are receiving this email because you have an active account on the ##distributorName## portal and have chosen to receive notifications via email.',
         email_common_footer_unsubscribe: `Do not wish to receive these emails? Turn off email notifications <a style="color: ${primaryColor};" href="${process.env.REACT_APP_BASE_URL}/admin/setting">here</a>.`,

         email_template_new_account_created_title: 'New Account Created',
         email_template_new_account_created_main_content:
           'Thank you for registering with ##distributorName##, the platform to remotely monitor and manage your Fortes Heating Interface Units and linked energy meters.',
         email_template_new_account_created_password_intro:
           'To get you started, we have created an account for you on the ##distributorName## portal. Please find your temporary password below.',
         email_template_new_account_created_temp_password:
           'Temporary Password:',
         email_template_new_account_created_login_instruction: `Please follow this <a style="font-weight: 600;color: ${primaryColor};" href="${process.env.REACT_APP_BASE_URL}"> link</a>, to <a style="font-weight: 600;color: ${primaryColor};" href="${process.env.REACT_APP_BASE_URL}"> login</a> and change your password.`,
         email_template_new_account_created_button: 'LOGIN',
         email_template_modbus_data_title: 'Modbus Data',
         email_template_modbus_data_content:
           'You have requested an export for the available (Modbus) data of the Heating Interface Unit(s). The export file is password protected to safeguard your data.<br />Please click on this link to download the zip file. Enter the password when opening the zip file.',
         email_template_modbus_data_password: 'Password:',
         email_template_modbus_data_expiry_note:
           'Note: The above link will expire after 12 hours.',
         email_template_modbus_data_button: 'DOWNLOAD ZIP FILE',
         email_template_mbus_data_title: 'Mbus Data',
         email_template_mbus_data_content:
           'You have requested an export for the available (Mbus) data of the energy meter(s).',
         email_template_mbus_data_content_1:
           'The export file is password protected to safeguard your data.',
         email_template_mbus_data_content_2:
           'Please click on this link to download the zip file. Enter the password when opening the zip file.',
         email_template_mbus_data_password: 'Password:',
         email_template_mbus_data_expiry:
           'Note: The above link will expire after 12 hours.',
         email_template_mbus_data_button: 'DOWNLOAD ZIP FILE',

         email_template_device_swapping_title: 'Device Swapping',
         email_template_device_swapping_content:
           'You have recently swapped a Mercurius Communication Module for a new unit.',
         email_template_device_swapping_content_1:
           'Please find below a summary of the swap in your project.',
         email_template_device_swapping_old_device_section: 'Old Device',
         email_template_device_swapping_old_project: 'Project',
         email_template_device_swapping_old_client: 'Client',
         email_template_device_swapping_old_device_name: 'Device name',
         email_template_device_swapping_old_swapped_at: 'Swapped at',
         email_template_device_swapping_old_swapped_by: 'Swapped by',
         email_template_device_swapping_old_serial_number_mercurius:
           'Serial number Mercurius',
         email_template_device_swapping_old_type_heat_interface_unit:
           'Type Heat Interface Unit',
         email_template_device_swapping_old_distributor_serial_number:
           'Distributor Serial # heat interface unit',
         email_template_device_swapping_old_distributor_article_number:
           'Distributor Article # heat interface unit',
         email_template_device_swapping_old_serial_number:
           'Serial number Heat Interface Unit',
         email_template_device_swapping_old_production_date: 'Production date',
         email_template_device_swapping_old_customer_reference:
           'Customer reference',
         email_template_device_swapping_old_article_number_heat_interface_unit:
           'Article number heat interface unit',
         email_template_device_swapping_old_production_order_number:
           'Production order number',
         email_template_device_swapping_old_order_number: 'Order number',
         email_template_device_swapping_new_device_section: 'New Device',

         email_template_device_swapping_new_device_name: 'Name',
         email_template_device_swapping_new_serial_number:
           'Serial number Mercurius',
         email_template_device_swapping_new_sim_card: 'Sim card number',
         email_template_device_swapping_new_firmware: 'Firmware version',
         email_template_device_swapping_new_device_type: 'Device type',

         email_template_device_swapping_completion:
           'has proceeded to complete the swapping process.',
         email_template_device_swapping_completion_info:
           '##distributorName## generates this report after completing the device swapping process. This will allow you or your organisation to take timely action to resolve any issues.',

         email_template_active_alarms_title: 'Active Alarms',
         email_template_active_alarms_intro:
           'Please find below a summary of the Active Alarms <sup>2</sup> for the connected Fortes Heating Interface Units in your project(s).',
         email_template_active_alarms_new_active_alarms:
           'New Active Alarms<sup>2</sup>',
         email_template_active_alarms_existing_active_alarms:
           'Existing Active Alarms',
         email_template_active_alarms_resolved_alarms:
           'Resolved Alarms<sup>3</sup>',
         email_template_active_alarms_download_report:
           'To download the full Excel report, please click on this link.',
         email_template_active_alarms_download_report_button:
           'DOWNLOAD FULL EXCEL REPORT',
         email_template_active_alarms_report_info:
           '##distributorName## generates this report every 6 hours. This will allow you or your organisation to take timely action to resolve the alarms in the heating interface units and ensure correct operation.',
         email_template_active_alarms_report_info_1:
           '1. An Active Alarm is an alarm that has occurred and is not resolved yet.',
         email_template_active_alarms_report_info_2:
           '2. A New Active Alarm is an alarm that has occurred since the last report.',
         email_template_active_alarms_report_info_3:
           '3. A Resolved Alarm is an alarm that has been resolved since the last report.',

         email_template_api_gateway_title: 'New API Gateway Account Created',
         email_template_api_gateway_main_content:
           'Thank you for registering with ##distributorName##, the platform to remotely monitor and manage your Fortes Heating Interface Units and linked energy meters.',
         email_template_api_gateway_info:
           'To get you started, we have created an account for you on the ##distributorName## Platform. Please find your API Key below.',
         email_template_api_gateway_api_key: 'API Key:',
         email_template_api_gateway_spec_link: `Please click on this <a href="#" style="font-weight: 600; color: ${primaryColor};">link</a>, to review OpenAPI Specification.`,
         email_template_api_gateway_button: 'OpenAPI Specification',

         email_template_forgot_password_title: 'Forgot Password',
         email_template_forgot_password_content:
           'We received a request to reset the password for your account.',
         email_template_forgot_password_content_1: `Please click on this <a href="#" style="font-weight: 600; color: ${primaryColor};">link</a>, to reset your password.`,
         email_template_forgot_password_reset_password_button: 'RESET PASSWORD',

         email_template_mbus_hourly_logs_missing_title:
           'Mbus hourly logs Missing report',
         email_template_mbus_hourly_logs_missing_content:
           'We have identified that certain devices have not sent mbus hourly data.',
         email_template_mbus_hourly_logs_view_report_button: 'VIEW REPORT',

         email_template_anomaly_digest_title: 'Anomaly Digest',
         email_template_anomaly_digest_content:
           'Here are the details of Anomaly Digest',
         email_template_anomaly_digest_duration:
           'Duration: <b>{{ anomalyDuration }}</b>',
         email_template_anomaly_digest_project_name:
           'Project name: {{projectName}}',
         email_template_anomaly_digest_device_serial: 'Device serial',
         email_template_anomaly_digest_anomaly_count: 'Anomaly count',
         email_template_anomaly_digest_button: 'VIEW ANOMALY REPORT',

         email_template_maxitel_m2m_blend_and_api_status_title:
           'Maxitel M2M Blend And API Status',
         email_template_maxitel_m2m_blend_and_api_status_intro:
           'Here are the details of Maxitel M2M Blend And API Status.',
         email_template_maxitel_m2m_blend_and_api_status_service_header:
           'Maxitel Service',
         email_template_maxitel_m2m_blend_and_api_status_status_header:
           'Status',
         email_template_maxitel_m2m_blend_and_api_status_api_status:
           'Non-operational',
         email_template_maxitel_m2m_blend_and_api_status_operational:
           'Operational',

         email_template_device_commissioning_report_title:
           'Mercurius Commissioning Report',
         email_template_device_commissioning_report_intro:
           'Please find below the commissioning report of the recently commissioned Mercurius in your project.',
         email_template_device_commissioning_report_project: 'Project',
         email_template_device_commissioning_report_client: 'Client',
         email_template_device_commissioning_report_device_name: 'Device name',
         email_template_device_commissioning_report_commissioned_at:
           'Commissioned at',
         email_template_device_commissioning_report_commissioned_by:
           'Commissioned by',
         email_template_device_commissioning_report_commissioning_status:
           'Commissioning status',
         email_template_device_commissioning_report_completed_hiu_details:
           '-Completed HIU details',
         email_template_device_commissioning_report_mobile_connectivity_validation:
           '-Mobile connectivity validation',
         email_template_device_commissioning_report_modbus_connectivity_validation:
           '-Modbus connectivity validation',
         email_template_device_commissioning_report_mbus_connectivity_validation:
           '-MBus connectivity validation',
         email_template_device_commissioning_report_updated_address_details:
           '-Updated address details',
         email_template_device_commissioning_report_completion:
           'User has proceeded to complete the commissioning process.',
         email_template_device_commissioning_report_footer:
           'generates this report after completing the Mercurius commissioning process. This will allow you or your organisation to take timely action to resolve any issues with connecting the heating interface units and ensure correct commissioning.',

         email_template_subscriptions_expiring_title:
           'Project Subscriptions Expiring Soon Notification',
         email_template_subscriptions_expiring_content:
           'This is to inform you that {{ numberOfProjects }} projects are expiring soon.',
         email_template_subscriptions_expiring_content_1: `Please click on the <a style="font-weight: 600; color: ${primaryColor};" href={{ subscriptionsExpiringUrl }}>link</a> to view the details.`,
         email_template_subscriptions_expiring_soon_notification:
           'Expiring soon notification',
         email_template_subscriptions_expiring_months: 'months',
         email_template_subscriptions_expiring_button:
           'VIEW EXPIRING SOON SUBSCRIPTIONS',

         email_template_delete_device_sim_subscription_title:
           'Delete device sim subscription',
         email_template_delete_device_sim_subscription_content:
           'Please find below the device information required to manually delete the SIM subscription, as the Maxitel Delete Subscription API is currently not functioning.',

         email_template_delete_device_sim_subscription_project: 'Project',
         email_template_delete_device_sim_subscription_client: 'Client',
         email_template_delete_device_sim_subscription_device_name:
           'Device name',
         email_template_delete_device_sim_subscription_device_edited_by:
           'Device edited by',
         email_template_delete_device_sim_subscription_device_edited_at:
           'Device edited at',
         email_template_delete_device_sim_subscription_old_sim_number:
           'Old SIM number',
         email_template_greeting: 'Hi',
         swapping_email_swapped_at_field: 'Swapped At',
         swapping_email_swapped_by_field: 'Swapped By',
         projects_form_created_at_field: 'Creation Date',
         add_subscription_order_number_duplicate_error:
           'Subscription order number must be unique.',
         add_subscription_project_not_found_error:
           'The specified project does not exist.',
         add_subscription_subscription_project_credits_missing_error:
           'No devices found for the selected project.',
         add_subscription_subscription_creation_failed_error:
           'Failed to create the subscription due to an internal server error.',
         add_subscription_invalid_or_null_payload_error:
           'The provided payload is either null or invalid.',
         devices_bulk_delete_button: 'Delete Devices',
         devices_bulk_delete_modal_title: 'Are you sure?',
         devices_bulk_delete_modal_subtitle: `<strong>The following data will be deleted:</strong>
          <ul>
            <li><i>Device information</i></li>
            <li><i>Events</i></li>
            <li><i>Modbus Data</i></li>
            <li><i>Mbus Data</i></li>
            <li><i>Graph Data</i></li>
            <li><i>Device Register</i></li>
            <li><i>Error Data</i></li>
            <li><i>Other related tables</i></li>
          </ul>`,
         devices_bulk_delete_modal_note:
           '<strong>Note:</strong> <br/> Once you proceed with the deletion, it cannot be undone unless the IT team manually restores the data from old backups. Recovering events and other related information will be highly time-consuming. Device deletion takes some time due to the data mentioned above. Please be patient and do not cancel or refresh the page.',
         devices_bulk_delete_modal_cancel_button: 'Cancel',
         devices_bulk_delete_modal_delete_button: 'Delete',
         devices_bulk_deleted_message:
           '{{ DEVICES_COUNT }} Devices are deleted successfully',
         email_template_device_deletion_title: 'Deleted Devices Report',
         email_template_device_deletion_content:
           'Please find the summary of the devices deleted from the ##distributorName## platform:',
         email_template_device_deletion_content_1: `To download the full Excel report, please click on this <a href="#" style="font-weight: 600; color: ${primaryColor};">link</a>.`,
         email_template_device_deletion_download_button:
           'Download Full Excel Report',
         email_template_device_deletion_note:
           '##distributorName## generates this report to track device deletions for auditing purposes and to retain data in case of accidental deletions.',
         email_template_device_deletion_deleted_devices_count_field:
           'Deleted Devices count ',
         email_template_device_deletion_deleted_at_field: 'Deleted at',
         email_template_device_deletion_deleted_at_by: 'Deleted By',
         error_check_details_table_export_success_message:
           'An alarm email has been sent to your inbox.',
         error_check_details_table_export_error_message:
           'Alarm email forwarding failed. Please contact support for assistance.',
         errorReporting_TR03_256_errorName: 'MODBUS_WARNING_MESSAGE',
         errorReporting_TR03_256_errorDescription:
           'No Modbus communication with HIU controller',
         errorReporting_TR03_256_errorResolution:
           'Check a/o replace Modbus cable a/o connectors. If problem persists, replace controller',
         errorReporting_TR04_256_errorName: 'MODBUS_WARNING_MESSAGE',
         errorReporting_TR04_256_errorDescription:
           'No Modbus communication with HIU controller',
         errorReporting_TR04_256_errorResolution:
           'Check a/o replace Modbus cable a/o connectors. If problem persists, replace controller',
         error_check_details_table_export_start_time_field: 'Start Time',
         error_check_details_table_export_end_time_field: 'End Time',
         error_check_details_table_export_resolution_field: 'Resolution',
         error_check_details_table_export_alarm_code_field: 'Alarm Code',
         error_check_details_table_export_alarm_name_field: 'Alarm Name',
         error_check_details_table_export_alarm_resolutions_field:
           'Alarm Resolutions',
         error_check_details_table_export_alarm_description_field:
           'Description',
         subscription_form_subscriptionPeriod_years_field:
           'Subscription Period (years)',
         subscription_form_project_devices_missing_error:
           'No devices are currently assigned to the selected project. Please add devices to continue.',
         settings_notification_device_error_toast_message:
           '"Notify when a device is in error mode" is updated successfully.',
         subscription_form_client_email_status_field: 'Client Email Status',
         subscription_form_client_email_success_field:
           'The Client Contact for this client is set on the Edit Client page, and email is successfully forwarded for the subscription extension.',
         subscription_form_client_email_error_field:
           'The Client Contact for this client is not set on the Edit Client page, and email is not forwarded for the subscription extension.',
         subscription_extension_client_email_status: 'Client Email Status',
         subscription_form_keycloak_user_id_mismatch_issue_error:
           'Client email user account has issue. Please contact the administrator',
         devices_partner_order_number_field: 'Distributor Order Number',
         edit_devices_distributor_order_number_error:
           'Distributor Order Number is required',
         legal_documents_checkbox_link_information_form_error:
           '<strong>Note: </strong><i>In the document checkbox label field, use [link] to insert the document URL and it will be automatically replaced with the actual link.</i>',
         devices_form_distinct_mercurius_type_field: 'Distinct Mercurius Type',
         devices_table_row_all_records_label: 'All',
         devices_show_all_devices_modal_title: 'Are you Sure?',
         devices_show_all_devices_modal_subtitle:
           'By selecting "All" from the records dropdown, you are requesting to load all available records i.e. ##TOTAL_DEVICES##.',
         devices_show_all_devices_modal_note:
           '<ul><li>This action may take 30 seconds or more and could slow down the page.</li><li>Loading all records (over 10MB of data) might cause performance issues, including page lag due to the large number of items being rendered.</li><li>If you\'re okay with that, click <strong>"Proceed Anyway"</strong>.</li><li>To cancel and revert to the default 25 records, click <strong>"Cancel"</strong>.</li></ul>',
         devices_show_all_devices_modal_cancel_button: 'Cancel',
         devices_show_all_devices_modal_proceed_anyway_button: 'Proceed Anyway',
       };
